import * as React from 'react';

function SvgEs(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 480"
            width={props.width || 640}
            height={props.height || 480}
            {...props}
        >
            <path fill="#c60b1e" d="M0 0h640v480H0z" />
            <path fill="#ffc400" d="M0 120h640v240H0z" />
            <path
                d="M127.27 213.35s-.49 0-.76-.152c-.27-.157-1.084-.927-1.084-.927l-.652-.463-.593-.822s-.704-1.124-.38-2c.323-.873.866-1.183 1.356-1.44.49-.255 1.515-.564 1.515-.564s.818-.358 1.088-.412c.27-.05 1.25-.307 1.25-.307s.27-.152.54-.255c.273-.102.65-.102.87-.156.216-.053.76-.227 1.084-.244.504-.02 1.303.09 1.576.09.27 0 1.193.053 1.57.053.378 0 1.735-.106 2.116-.106.378 0 .652-.047 1.088 0 .432.05 1.19.306 1.41.412.217.103 1.52.566 2.006.72.49.15 1.684.357 2.228.614.54.26.87.692 1.14 1.052.274.36.324.75.433 1.01.102.255.106.807.003 1.064-.11.255-.494.784-.494.784l-.6.974-.757.614s-.544.518-.975.463c-.437-.043-4.832-.82-7.654-.82s-7.328.82-7.328.82"
                fill="#ad1519"
            />
            <path
                d="M127.27 213.35s-.49 0-.76-.152c-.27-.157-1.084-.927-1.084-.927l-.652-.463-.593-.822s-.704-1.124-.38-2c.323-.873.866-1.183 1.356-1.44.49-.255 1.515-.564 1.515-.564s.818-.358 1.088-.412c.27-.05 1.25-.307 1.25-.307s.27-.152.54-.255c.273-.102.65-.102.87-.156.216-.053.76-.227 1.084-.244.504-.02 1.303.09 1.576.09.27 0 1.193.053 1.57.053.378 0 1.735-.106 2.116-.106.378 0 .652-.047 1.088 0 .432.05 1.19.306 1.41.412.217.103 1.52.566 2.006.72.49.15 1.684.357 2.228.614.54.26.87.692 1.14 1.052.274.36.324.75.433 1.01.102.255.106.807.003 1.064-.11.255-.494.784-.494.784l-.6.974-.757.614s-.544.518-.975.463c-.437-.043-4.832-.82-7.654-.82s-7.328.82-7.328.82h.004z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
                strokeLinejoin="round"
            />
            <path
                d="M133.306 207.055c0-1.326.593-2.396 1.324-2.396.73 0 1.325 1.07 1.325 2.395 0 1.32-.595 2.393-1.325 2.393s-1.324-1.073-1.324-2.393"
                fill="#c8b100"
            />
            <path
                d="M133.306 207.055c0-1.326.593-2.396 1.324-2.396.73 0 1.325 1.07 1.325 2.395 0 1.32-.595 2.393-1.325 2.393s-1.324-1.073-1.324-2.393z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M134.047 207.055c0-1.22.274-2.208.608-2.208.34 0 .608.99.608 2.208 0 1.21-.27 2.2-.608 2.2-.334 0-.608-.99-.608-2.2"
                fill="#c8b100"
            />
            <path
                d="M134.047 207.055c0-1.22.274-2.208.608-2.208.34 0 .608.99.608 2.208 0 1.21-.27 2.2-.608 2.2-.334 0-.608-.99-.608-2.2z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M133.762 204.522c0-.46.396-.842.886-.842s.886.382.886.842c0 .464-.396.835-.886.835s-.886-.37-.886-.835"
                fill="#c8b100"
            />
            <path
                d="M135.274 204.226v.558h-1.37v-.558h.448v-1.258h-.593v-.556h.592v-.545h.583v.545h.59v.556h-.59v1.258h.34"
                fill="#c8b100"
            />
            <path
                d="M135.274 204.226v.558h-1.37v-.558h.448v-1.258h-.593v-.556h.592v-.545h.583v.545h.59v.556h-.59v1.258h.34"
                fill="none"
                stroke="#000"
                strokeWidth={0.288}
            />
            <path
                d="M135.886 204.226v.558h-2.433v-.558h.9v-1.258h-.594v-.556h.592v-.545h.583v.545h.59v.556h-.59v1.258h.95"
                fill="#c8b100"
            />
            <path
                d="M135.886 204.226v.558h-2.433v-.558h.9v-1.258h-.594v-.556h.592v-.545h.583v.545h.59v.556h-.59v1.258h.95"
                fill="none"
                stroke="#000"
                strokeWidth={0.288}
            />
            <path
                d="M134.903 203.715c.368.102.63.426.63.807 0 .464-.395.835-.885.835s-.886-.37-.886-.835c0-.388.277-.72.656-.81"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M134.65 213.198h-4.614l-.106-1.132-.217-1.18-.23-1.472c-1.272-1.678-2.44-2.78-2.834-2.543.093-.31.205-.54.45-.684 1.13-.672 3.462.94 5.216 3.59.158.24.31.483.443.726h3.81c.137-.24.288-.48.446-.727 1.75-2.648 4.085-4.26 5.212-3.59.245.144.357.376.454.686-.395-.23-1.562.866-2.84 2.544l-.227 1.473-.216 1.18-.106 1.13h-4.64"
                fill="#c8b100"
            />
            <path
                d="M134.65 213.198h-4.614l-.106-1.132-.217-1.18-.23-1.472c-1.272-1.678-2.44-2.78-2.834-2.543.093-.31.205-.54.45-.684 1.13-.672 3.462.94 5.216 3.59.158.24.31.483.443.726h3.81c.137-.24.288-.48.446-.727 1.75-2.648 4.085-4.26 5.212-3.59.245.144.357.376.454.686-.395-.23-1.562.866-2.84 2.544l-.227 1.473-.216 1.18-.106 1.13h-4.643z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M126.852 206.827c.867-.51 2.893 1.095 4.538 3.59m11.087-3.59c-.87-.51-2.894 1.095-4.54 3.59"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M127.834 215.28c-.19-.548-.554-1.04-.554-1.04 1.868-.548 4.47-.892 7.364-.9 2.89.008 5.515.352 7.38.9l-.498.88c-.162.284-.373.777-.36.777-1.687-.517-3.862-.783-6.536-.786-2.67.004-5.24.33-6.58.822.014 0-.093-.31-.227-.65h.01"
                fill="#c8b100"
            />
            <path
                d="M127.834 215.28c-.19-.548-.554-1.04-.554-1.04 1.868-.548 4.47-.892 7.364-.9 2.89.008 5.515.352 7.38.9l-.498.88c-.162.284-.373.777-.36.777-1.687-.517-3.862-.783-6.536-.786-2.67.004-5.24.33-6.58.822.014 0-.093-.31-.227-.65h.01"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M134.644 217.657c2.333-.004 4.906-.358 5.853-.603.638-.185 1.007-.47.94-.802-.032-.156-.17-.292-.353-.37-1.397-.447-3.906-.764-6.44-.768-2.53.004-5.057.32-6.45.767-.183.08-.32.216-.352.372-.07.33.302.617.935.802.95.245 3.535.6 5.867.603"
                fill="#c8b100"
            />
            <path
                d="M134.644 217.657c2.333-.004 4.906-.358 5.853-.603.638-.185 1.007-.47.94-.802-.032-.156-.17-.292-.353-.37-1.397-.447-3.906-.764-6.44-.768-2.53.004-5.057.32-6.45.767-.183.08-.32.216-.352.372-.07.33.302.617.935.802.95.245 3.535.6 5.867.603z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M142.143 213.198l-.572-.514s-.54.333-1.22.23c-.677-.1-.896-.922-.896-.922s-.76.636-1.383.59c-.622-.056-1.03-.59-1.03-.59s-.675.483-1.273.436c-.597-.055-1.166-.798-1.166-.798s-.596.77-1.193.825c-.598.048-1.088-.52-1.088-.52s-.27.568-1.03.693c-.76.13-1.408-.59-1.408-.59s-.435.696-.95.877c-.514.18-1.195-.26-1.195-.26s-.11.26-.187.413c-.083.154-.3.182-.3.182l.17.46c1.86-.54 4.38-.873 7.23-.876 2.856.003 5.444.337 7.31.88l.19-.516"
                fill="#c8b100"
            />
            <path
                d="M142.143 213.198l-.572-.514s-.54.333-1.22.23c-.677-.1-.896-.922-.896-.922s-.76.636-1.383.59c-.622-.056-1.03-.59-1.03-.59s-.675.483-1.273.436c-.597-.055-1.166-.798-1.166-.798s-.596.77-1.193.825c-.598.048-1.088-.52-1.088-.52s-.27.568-1.03.693c-.76.13-1.408-.59-1.408-.59s-.435.696-.95.877c-.514.18-1.195-.26-1.195-.26s-.11.26-.187.413c-.083.154-.3.182-.3.182l.17.46c1.86-.54 4.38-.873 7.23-.876 2.856.003 5.444.337 7.31.88l.19-.516h-.008z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M134.66 210.712l.268.05a.977.977 0 00-.053.356c0 .56.478 1.013 1.073 1.013.474 0 .874-.293 1.015-.698.018.01.104-.368.147-.362.032 0 .028.393.046.386.066.507.533.856 1.06.856.59 0 1.063-.453 1.063-1.012 0-.042 0-.083-.007-.123l.335-.335.183.426c-.073.13-.1.28-.1.44 0 .536.46.97 1.02.97.355 0 .664-.175.85-.434l.215-.273-.004.34c0 .332.145.632.473.687 0 0 .37.027.875-.368.496-.393.77-.72.77-.72l.03.402s-.487.804-.934 1.06c-.242.143-.617.293-.91.24-.31-.046-.533-.298-.65-.584-.22.132-.48.207-.762.207-.605 0-1.148-.334-1.363-.827-.28.3-.664.48-1.118.48a1.56 1.56 0 01-1.202-.552 1.547 1.547 0 01-1.05.406 1.564 1.564 0 01-1.282-.66c-.27.393-.745.66-1.278.66-.407 0-.778-.154-1.05-.406a1.56 1.56 0 01-1.204.552 1.49 1.49 0 01-1.116-.48c-.215.49-.76.827-1.364.827-.28 0-.543-.075-.763-.207-.115.286-.338.538-.648.585-.295.052-.665-.098-.91-.24-.447-.257-.973-1.06-.973-1.06l.07-.404s.276.327.77.72c.5.394.874.367.874.367.328-.055.472-.355.472-.688l-.004-.34.215.274c.183.26.494.433.85.433.56 0 1.017-.433 1.017-.968a.909.909 0 00-.096-.442l.18-.426.335.335a.71.71 0 00-.01.123c0 .56.476 1.012 1.07 1.012.525 0 .99-.35 1.058-.856.014.007.01-.386.046-.386.042-.007.132.373.147.362.14.405.543.7 1.018.7.59 0 1.07-.455 1.07-1.014a.91.91 0 00-.055-.357l.28-.048"
                fill="#c8b100"
            />
            <path
                d="M134.66 210.712l.268.05a.977.977 0 00-.053.356c0 .56.478 1.013 1.073 1.013.474 0 .874-.293 1.015-.698.018.01.104-.368.147-.362.032 0 .028.393.046.386.066.507.533.856 1.06.856.59 0 1.063-.453 1.063-1.012 0-.042 0-.083-.007-.123l.335-.335.183.426c-.073.13-.1.28-.1.44 0 .536.46.97 1.02.97.355 0 .664-.175.85-.434l.215-.273-.004.34c0 .332.145.632.473.687 0 0 .37.027.875-.368.496-.393.77-.72.77-.72l.03.402s-.487.804-.934 1.06c-.242.143-.617.293-.91.24-.31-.046-.533-.298-.65-.584-.22.132-.48.207-.762.207-.605 0-1.148-.334-1.363-.827-.28.3-.664.48-1.118.48a1.56 1.56 0 01-1.202-.552 1.547 1.547 0 01-1.05.406 1.564 1.564 0 01-1.282-.66c-.27.393-.745.66-1.278.66-.407 0-.778-.154-1.05-.406a1.56 1.56 0 01-1.204.552 1.49 1.49 0 01-1.116-.48c-.215.49-.76.827-1.364.827-.28 0-.543-.075-.763-.207-.115.286-.338.538-.648.585-.295.052-.665-.098-.91-.24-.447-.257-.973-1.06-.973-1.06l.07-.404s.276.327.77.72c.5.394.874.367.874.367.328-.055.472-.355.472-.688l-.004-.34.215.274c.183.26.494.433.85.433.56 0 1.017-.433 1.017-.968a.909.909 0 00-.096-.442l.18-.426.335.335a.71.71 0 00-.01.123c0 .56.476 1.012 1.07 1.012.525 0 .99-.35 1.058-.856.014.007.01-.386.046-.386.042-.007.132.373.147.362.14.405.543.7 1.018.7.59 0 1.07-.455 1.07-1.014a.91.91 0 00-.055-.357l.28-.048h.008z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M134.644 213.345c-2.893.003-5.496.347-7.36.9-.127.04-.28-.056-.32-.168-.04-.118.05-.265.172-.306 1.875-.572 4.542-.933 7.508-.936 2.963.003 5.64.364 7.516.937.123.042.212.19.173.307-.036.112-.194.208-.317.168-1.867-.553-4.48-.897-7.372-.9"
                fill="#c8b100"
            />
            <path
                d="M134.644 213.345c-2.893.003-5.496.347-7.36.9-.127.04-.28-.056-.32-.168-.04-.118.05-.265.172-.306 1.875-.572 4.542-.933 7.508-.936 2.963.003 5.64.364 7.516.937.123.042.212.19.173.307-.036.112-.194.208-.317.168-1.867-.553-4.48-.897-7.372-.9z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
                strokeLinejoin="round"
            />
            <path
                d="M131.844 214.37c0-.217.187-.395.42-.395.232 0 .418.178.418.396 0 .222-.186.395-.418.395-.233 0-.42-.173-.42-.394"
                fill="#fff"
            />
            <path
                d="M131.844 214.37c0-.217.187-.395.42-.395.232 0 .418.178.418.396 0 .222-.186.395-.418.395-.233 0-.42-.173-.42-.394z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M134.677 214.542h-.93c-.17 0-.315-.137-.315-.3 0-.162.14-.294.31-.294h1.884a.3.3 0 01.31.293c0 .165-.14.302-.313.302h-.946"
                fill="#ad1519"
            />
            <path
                d="M134.677 214.542h-.93c-.17 0-.315-.137-.315-.3 0-.162.14-.294.31-.294h1.884a.3.3 0 01.31.293c0 .165-.14.302-.313.302h-.946"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M130.015 214.86l-.665.1c-.17.024-.335-.085-.36-.248a.296.296 0 01.26-.334l.668-.1.685-.105c.17-.02.327.086.356.246a.305.305 0 01-.264.336l-.68.105"
                fill="#058e6e"
            />
            <path
                d="M130.015 214.86l-.665.1c-.17.024-.335-.085-.36-.248a.296.296 0 01.26-.334l.668-.1.685-.105c.17-.02.327.086.356.246a.305.305 0 01-.264.336l-.68.105"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M127.326 215.328l.296-.476.63.12-.368.535-.558-.18" fill="#ad1519" />
            <path d="M127.326 215.328l.296-.476.63.12-.368.535-.558-.18" fill="none" stroke="#000" strokeWidth={0.25} />
            <path
                d="M136.61 214.37c0-.217.187-.395.42-.395.23 0 .418.178.418.396a.404.404 0 01-.417.395c-.233 0-.42-.173-.42-.394"
                fill="#fff"
            />
            <path
                d="M136.61 214.37c0-.217.187-.395.42-.395.23 0 .418.178.418.396a.404.404 0 01-.417.395c-.233 0-.42-.173-.42-.394z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M139.276 214.86l.67.1a.314.314 0 00.357-.248.294.294 0 00-.256-.334l-.673-.1-.68-.105c-.173-.02-.33.086-.357.246-.03.158.09.312.263.336l.676.105"
                fill="#058e6e"
            />
            <path
                d="M139.276 214.86l.67.1a.314.314 0 00.357-.248.294.294 0 00-.256-.334l-.673-.1-.68-.105c-.173-.02-.33.086-.357.246-.03.158.09.312.263.336l.676.105"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M141.91 215.356l-.236-.508-.648.054.31.57.575-.116" fill="#ad1519" />
            <path d="M141.91 215.356l-.236-.508-.648.054.31.57.575-.116" fill="none" stroke="#000" strokeWidth={0.25} />
            <path
                d="M134.636 217.115c-2.334-.003-4.447-.208-6.053-.623 1.606-.413 3.72-.67 6.053-.675 2.337.003 4.46.26 6.07.675-1.61.415-3.733.62-6.07.623"
                fill="#ad1519"
            />
            <path
                d="M134.636 217.115c-2.334-.003-4.447-.208-6.053-.623 1.606-.413 3.72-.67 6.053-.675 2.337.003 4.46.26 6.07.675-1.61.415-3.733.62-6.07.623z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
                strokeLinejoin="round"
            />
            <path
                d="M142.005 212.05c.06-.18.004-.36-.125-.404-.13-.036-.288.08-.35.253-.06.183-.008.365.126.405.13.037.284-.075.35-.255"
                fill="#c8b100"
            />
            <path
                d="M142.005 212.05c.06-.18.004-.36-.125-.404-.13-.036-.288.08-.35.253-.06.183-.008.365.126.405.13.037.284-.075.35-.255z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M137.355 211.15c.02-.188-.07-.355-.205-.372-.138-.017-.267.126-.288.314-.025.187.065.354.2.37.14.014.268-.13.293-.312"
                fill="#c8b100"
            />
            <path
                d="M137.355 211.15c.02-.188-.07-.355-.205-.372-.138-.017-.267.126-.288.314-.025.187.065.354.2.37.14.014.268-.13.293-.312z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M131.95 211.15c-.02-.188.07-.355.208-.372.136-.017.266.126.29.314.023.187-.068.354-.205.37-.133.014-.267-.13-.292-.312"
                fill="#c8b100"
            />
            <path
                d="M131.95 211.15c-.02-.188.07-.355.208-.372.136-.017.266.126.29.314.023.187-.068.354-.205.37-.133.014-.267-.13-.292-.312z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M127.3 212.05c-.06-.18-.003-.36.128-.404.13-.036.287.08.348.253.062.183.007.365-.126.405-.13.037-.285-.075-.35-.255"
                fill="#c8b100"
            />
            <path
                d="M127.3 212.05c-.06-.18-.003-.36.128-.404.13-.036.287.08.348.253.062.183.007.365-.126.405-.13.037-.285-.075-.35-.255z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M134.636 208.463l-.823.497.612 1.326.21.14.21-.14.616-1.326-.824-.497" fill="#c8b100" />
            <path
                d="M134.636 208.463l-.823.497.612 1.326.21.14.21-.14.616-1.326-.824-.497"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M132.834 210.468l.374.546 1.288-.397.134-.18-.138-.185-1.284-.375-.374.59" fill="#c8b100" />
            <path
                d="M132.834 210.468l.374.546 1.288-.397.134-.18-.138-.185-1.284-.375-.374.59"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M136.45 210.468l-.373.546-1.29-.397-.136-.18.14-.185 1.287-.375.374.59" fill="#c8b100" />
            <path
                d="M136.45 210.468l-.373.546-1.29-.397-.136-.18.14-.185 1.287-.375.374.59"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M129.28 209.053l-.647.61.827 1.092.22.087.162-.167.288-1.318-.85-.304" fill="#c8b100" />
            <path
                d="M129.28 209.053l-.647.61.827 1.092.22.087.162-.167.288-1.318-.85-.304"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M127.923 211.24l.487.457 1.173-.633.09-.204-.17-.154-1.342-.116-.237.65" fill="#c8b100" />
            <path
                d="M127.923 211.24l.487.457 1.173-.633.09-.204-.17-.154-1.342-.116-.237.65"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M131.467 210.53l-.25.602-1.346-.122-.172-.155.094-.207 1.177-.62.497.5" fill="#c8b100" />
            <path
                d="M131.467 210.53l-.25.602-1.346-.122-.172-.155.094-.207 1.177-.62.497.5"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M126.628 211.41l-.108.64-1.342.14-.202-.117.043-.217 1.01-.84.598.395" fill="#c8b100" />
            <path
                d="M126.628 211.41l-.108.64-1.342.14-.202-.117.043-.217 1.01-.84.598.395"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M129.22 210.863c0-.25.212-.45.472-.45s.47.2.47.45a.46.46 0 01-.47.446.46.46 0 01-.472-.447"
                fill="#c8b100"
            />
            <path
                d="M129.22 210.863c0-.25.212-.45.472-.45s.47.2.47.45a.46.46 0 01-.47.446.46.46 0 01-.472-.447z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M140.02 209.053l.646.61-.828 1.092-.223.087-.157-.167-.292-1.318.853-.304" fill="#c8b100" />
            <path
                d="M140.02 209.053l.646.61-.828 1.092-.223.087-.157-.167-.292-1.318.853-.304"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M141.372 211.24l-.486.457-1.174-.633-.093-.204.176-.154 1.343-.116.232.65" fill="#c8b100" />
            <path
                d="M141.372 211.24l-.486.457-1.174-.633-.093-.204.176-.154 1.343-.116.232.65"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M137.833 210.53l.25.602 1.337-.122.178-.155-.098-.207-1.173-.62-.494.5" fill="#c8b100" />
            <path
                d="M137.833 210.53l.25.602 1.337-.122.178-.155-.098-.207-1.173-.62-.494.5"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M142.484 211.41l.112.64 1.343.14.2-.117-.047-.217-1.01-.84-.6.395" fill="#c8b100" />
            <path
                d="M142.484 211.41l.112.64 1.343.14.2-.117-.047-.217-1.01-.84-.6.395"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M134.173 210.44a.46.46 0 01.47-.45c.264 0 .473.198.473.45a.46.46 0 01-.472.447.461.461 0 01-.47-.446"
                fill="#c8b100"
            />
            <path
                d="M134.173 210.44a.46.46 0 01.47-.45c.264 0 .473.198.473.45a.46.46 0 01-.472.447.461.461 0 01-.47-.446z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M139.144 210.863c0-.25.212-.45.47-.45a.46.46 0 01.472.45.46.46 0 01-.47.446.46.46 0 01-.472-.447"
                fill="#c8b100"
            />
            <path
                d="M139.144 210.863c0-.25.212-.45.47-.45a.46.46 0 01.472.45.46.46 0 01-.47.446.46.46 0 01-.472-.447z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M124.814 212.158c-.015.01-.363-.464-.63-.702-.19-.167-.648-.31-.648-.31 0-.085.267-.276.558-.276a.54.54 0 01.428.19l.04-.184s.234.045.342.308c.11.272.04.685.04.685s-.044.19-.13.288"
                fill="#c8b100"
            />
            <path
                d="M124.814 212.158c-.015.01-.363-.464-.63-.702-.19-.167-.648-.31-.648-.31 0-.085.267-.276.558-.276a.54.54 0 01.428.19l.04-.184s.234.045.342.308c.11.272.04.685.04.685s-.044.19-.13.288z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M124.832 211.923c.11-.116.342-.092.51.055.174.146.224.36.113.48-.112.12-.343.093-.512-.054-.172-.147-.222-.365-.11-.48"
                fill="#c8b100"
            />
            <path
                d="M124.832 211.923c.11-.116.342-.092.51.055.174.146.224.36.113.48-.112.12-.343.093-.512-.054-.172-.147-.222-.365-.11-.48z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M144.302 212.158c.01.01.364-.464.63-.702.183-.167.648-.31.648-.31 0-.085-.27-.276-.562-.276-.17 0-.33.07-.428.19l-.04-.184s-.234.045-.34.308c-.106.272-.038.685-.038.685s.04.19.13.288"
                fill="#c8b100"
            />
            <path
                d="M144.302 212.158c.01.01.364-.464.63-.702.183-.167.648-.31.648-.31 0-.085-.27-.276-.562-.276-.17 0-.33.07-.428.19l-.04-.184s-.234.045-.34.308c-.106.272-.038.685-.038.685s.04.19.13.288z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M144.312 211.923c-.11-.116-.34-.092-.513.055-.175.146-.225.36-.114.48.113.12.342.093.516-.054.172-.147.22-.365.11-.48"
                fill="#c8b100"
            />
            <path
                d="M144.312 211.923c-.11-.116-.34-.092-.513.055-.175.146-.225.36-.114.48.113.12.342.093.516-.054.172-.147.22-.365.11-.48z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M123.997 223.074h21.395v-5.608h-21.395v5.608z" fill="#c8b100" />
            <path d="M123.997 223.074h21.395v-5.608h-21.395v5.608z" fill="none" stroke="#000" strokeWidth={0.374} />
            <path
                d="M126.242 226.806a.934.934 0 01.397-.06h16.02c.16 0 .31.026.436.077-.547-.183-.943-.68-.943-1.268 0-.586.428-1.094.982-1.285-.125.04-.313.08-.463.08H126.64a1.43 1.43 0 01-.45-.053l.086.014c.572.178.9.686.9 1.245a1.33 1.33 0 01-.934 1.25"
                fill="#c8b100"
            />
            <path
                d="M126.242 226.806a.934.934 0 01.397-.06h16.02c.16 0 .31.026.436.077-.547-.183-.943-.68-.943-1.268 0-.586.428-1.094.982-1.285-.125.04-.313.08-.463.08H126.64a1.43 1.43 0 01-.45-.053l.086.014c.572.178.9.686.9 1.245a1.33 1.33 0 01-.934 1.25z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M126.64 226.745h16.02c.544 0 .983.337.983.75 0 .416-.44.754-.982.754h-16.02c-.545 0-.984-.34-.984-.755 0-.413.44-.75.983-.75"
                fill="#c8b100"
            />
            <path
                d="M126.64 226.745h16.02c.544 0 .983.337.983.75 0 .416-.44.754-.982.754h-16.02c-.545 0-.984-.34-.984-.755 0-.413.44-.75.983-.75z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M126.64 223.074h16.032c.54 0 .983.286.983.634 0 .354-.444.64-.983.64H126.64c-.545 0-.984-.286-.984-.64 0-.348.44-.634.983-.634"
                fill="#c8b100"
            />
            <path
                d="M126.64 223.074h16.032c.54 0 .983.286.983.634 0 .354-.444.64-.983.64H126.64c-.545 0-.984-.286-.984-.64 0-.348.44-.634.983-.634z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M149.63 317.45c-1.48 0-2.798-.31-3.77-.83-.965-.49-2.27-.79-3.71-.79-1.447 0-2.786.304-3.75.797-.97.51-2.308.822-3.77.822-1.48 0-2.797-.346-3.77-.863-.955-.47-2.238-.758-3.64-.758-1.452 0-2.74.276-3.705.777-.973.516-2.32.842-3.794.842v2.316c1.476 0 2.822-.337 3.795-.848.965-.498 2.253-.78 3.704-.78 1.398 0 2.68.29 3.64.763.97.516 2.29.866 3.77.866 1.462 0 2.8-.32 3.77-.823.964-.5 2.303-.805 3.75-.805 1.44 0 2.745.304 3.71.798.972.517 2.268.83 3.752.83l.017-2.317"
                fill="#005bbf"
            />
            <path
                d="M149.63 317.45c-1.48 0-2.798-.31-3.77-.83-.965-.49-2.27-.79-3.71-.79-1.447 0-2.786.304-3.75.797-.97.51-2.308.822-3.77.822-1.48 0-2.797-.346-3.77-.863-.955-.47-2.238-.758-3.64-.758-1.452 0-2.74.276-3.705.777-.973.516-2.32.842-3.794.842v2.316c1.476 0 2.822-.337 3.795-.848.965-.498 2.253-.78 3.704-.78 1.398 0 2.68.29 3.64.763.97.516 2.29.866 3.77.866 1.462 0 2.8-.32 3.77-.823.964-.5 2.303-.805 3.75-.805 1.44 0 2.745.304 3.71.798.972.517 2.268.83 3.752.83l.017-2.317z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M149.63 319.766c-1.48 0-2.798-.313-3.77-.83-.965-.494-2.27-.798-3.71-.798-1.447 0-2.786.304-3.75.805-.97.504-2.308.823-3.77.823-1.48 0-2.797-.35-3.77-.865-.955-.473-2.238-.762-3.64-.762-1.452 0-2.74.282-3.705.78-.973.51-2.32.848-3.794.848v2.312c1.476 0 2.822-.33 3.795-.842.965-.505 2.253-.784 3.704-.784 1.398 0 2.68.29 3.64.764.97.515 2.29.862 3.77.862 1.462 0 2.8-.32 3.77-.825.964-.497 2.303-.8 3.75-.8 1.44 0 2.745.303 3.71.797.972.515 2.268.828 3.752.828l.017-2.312"
                fill="#ccc"
            />
            <path
                d="M149.63 319.766c-1.48 0-2.798-.313-3.77-.83-.965-.494-2.27-.798-3.71-.798-1.447 0-2.786.304-3.75.805-.97.504-2.308.823-3.77.823-1.48 0-2.797-.35-3.77-.865-.955-.473-2.238-.762-3.64-.762-1.452 0-2.74.282-3.705.78-.973.51-2.32.848-3.794.848v2.312c1.476 0 2.822-.33 3.795-.842.965-.505 2.253-.784 3.704-.784 1.398 0 2.68.29 3.64.764.97.515 2.29.862 3.77.862 1.462 0 2.8-.32 3.77-.825.964-.497 2.303-.8 3.75-.8 1.44 0 2.745.303 3.71.797.972.515 2.268.828 3.752.828l.017-2.312"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M149.63 322.078c-1.48 0-2.798-.313-3.77-.828-.965-.494-2.27-.798-3.71-.798-1.447 0-2.786.304-3.75.8-.97.506-2.308.826-3.77.826-1.48 0-2.797-.347-3.77-.862-.955-.474-2.238-.764-3.64-.764-1.452 0-2.74.28-3.705.784-.973.512-2.32.842-3.794.842v2.31c1.476 0 2.822-.33 3.795-.844.965-.497 2.253-.777 3.704-.777 1.398 0 2.68.29 3.64.76.97.518 2.29.862 3.77.862 1.462 0 2.8-.317 3.77-.82.964-.5 2.303-.803 3.75-.803 1.44 0 2.745.3 3.71.795.972.52 2.268.827 3.752.827l.017-2.312"
                fill="#005bbf"
            />
            <path
                d="M149.63 322.078c-1.48 0-2.798-.313-3.77-.828-.965-.494-2.27-.798-3.71-.798-1.447 0-2.786.304-3.75.8-.97.506-2.308.826-3.77.826-1.48 0-2.797-.347-3.77-.862-.955-.474-2.238-.764-3.64-.764-1.452 0-2.74.28-3.705.784-.973.512-2.32.842-3.794.842v2.31c1.476 0 2.822-.33 3.795-.844.965-.497 2.253-.777 3.704-.777 1.398 0 2.68.29 3.64.76.97.518 2.29.862 3.77.862 1.462 0 2.8-.317 3.77-.82.964-.5 2.303-.803 3.75-.803 1.44 0 2.745.3 3.71.795.972.52 2.268.827 3.752.827l.017-2.312"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M149.612 326.704c-1.484 0-2.78-.313-3.752-.83-.965-.492-2.27-.793-3.71-.793-1.447 0-2.786.302-3.75.8-.97.505-2.308.824-3.77.824-1.48 0-2.797-.348-3.77-.866-.955-.47-2.238-.757-3.64-.757-1.452 0-2.74.28-3.705.78-.973.514-2.32.844-3.794.844v-2.3c1.476 0 2.822-.345 3.795-.86.965-.497 2.253-.777 3.704-.777 1.398 0 2.68.29 3.64.76.97.518 2.29.862 3.77.862 1.462 0 2.8-.317 3.77-.82.964-.5 2.303-.803 3.75-.803 1.44 0 2.745.3 3.71.795.972.52 2.29.827 3.77.827l-.018 2.314"
                fill="#ccc"
            />
            <path
                d="M149.612 326.704c-1.484 0-2.78-.313-3.752-.83-.965-.492-2.27-.793-3.71-.793-1.447 0-2.786.302-3.75.8-.97.505-2.308.824-3.77.824-1.48 0-2.797-.348-3.77-.866-.955-.47-2.238-.757-3.64-.757-1.452 0-2.74.28-3.705.78-.973.514-2.32.844-3.794.844v-2.3c1.476 0 2.822-.345 3.795-.86.965-.497 2.253-.777 3.704-.777 1.398 0 2.68.29 3.64.76.97.518 2.29.862 3.77.862 1.462 0 2.8-.317 3.77-.82.964-.5 2.303-.803 3.75-.803 1.44 0 2.745.3 3.71.795.972.52 2.29.827 3.77.827l-.018 2.314"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M149.612 329.02c-1.484 0-2.78-.315-3.752-.83-.965-.497-2.27-.8-3.71-.8-1.447 0-2.786.306-3.75.804-.97.504-2.308.825-3.77.825-1.48 0-2.797-.352-3.77-.867-.955-.473-2.238-.763-3.64-.763-1.452 0-2.74.283-3.705.783-.973.512-2.32.846-3.794.846v-2.296c1.476 0 2.822-.35 3.795-.865.965-.5 2.253-.775 3.704-.775 1.398 0 2.68.286 3.64.757.97.514 2.29.862 3.77.862 1.462 0 2.8-.32 3.77-.824.964-.498 2.303-.795 3.75-.795 1.44 0 2.745.297 3.71.79.972.516 2.283.83 3.765.83l-.013 2.314"
                fill="#005bbf"
            />
            <path
                d="M149.612 329.02c-1.484 0-2.78-.315-3.752-.83-.965-.497-2.27-.8-3.71-.8-1.447 0-2.786.306-3.75.804-.97.504-2.308.825-3.77.825-1.48 0-2.797-.352-3.77-.867-.955-.473-2.238-.763-3.64-.763-1.452 0-2.74.283-3.705.783-.973.512-2.32.846-3.794.846v-2.296c1.476 0 2.822-.35 3.795-.865.965-.5 2.253-.775 3.704-.775 1.398 0 2.68.286 3.64.757.97.514 2.29.862 3.77.862 1.462 0 2.8-.32 3.77-.824.964-.498 2.303-.795 3.75-.795 1.44 0 2.745.297 3.71.79.972.516 2.283.83 3.765.83l-.013 2.314z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M126.242 307.952c.052.195.123.386.123.593 0 1.404-1.212 2.522-2.696 2.522h22.018c-1.483 0-2.697-1.118-2.697-2.522 0-.205.04-.398.093-.593a1.29 1.29 0 01-.422.05h-16.02c-.13 0-.282-.013-.398-.05"
                fill="#c8b100"
            />
            <path
                d="M126.242 307.952c.052.195.123.386.123.593 0 1.404-1.212 2.522-2.696 2.522h22.018c-1.483 0-2.697-1.118-2.697-2.522 0-.205.04-.398.093-.593a1.29 1.29 0 01-.422.05h-16.02c-.13 0-.282-.013-.398-.05z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M126.64 306.496h16.02c.544 0 .983.34.983.754 0 .416-.44.754-.982.754h-16.02c-.545 0-.984-.338-.984-.754 0-.413.44-.754.983-.754"
                fill="#c8b100"
            />
            <path
                d="M126.64 306.496h16.02c.544 0 .983.34.983.754 0 .416-.44.754-.982.754h-16.02c-.545 0-.984-.338-.984-.754 0-.413.44-.754.983-.754z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path d="M123.698 316.668h21.96v-5.6H123.7v5.6z" fill="#c8b100" />
            <path d="M123.698 316.668h21.96v-5.6H123.7v5.6z" fill="none" stroke="#000" strokeWidth={0.374} />
            <path
                d="M121.98 286.673c-2.173 1.255-3.645 2.54-3.407 3.18.12.59.81 1.03 1.795 1.685 1.552 1.08 2.495 3.01 1.757 3.9 1.285-1.036 2.098-2.584 2.098-4.306 0-1.8-.856-3.422-2.242-4.46"
                fill="#ad1519"
            />
            <path
                d="M121.98 286.673c-2.173 1.255-3.645 2.54-3.407 3.18.12.59.81 1.03 1.795 1.685 1.552 1.08 2.495 3.01 1.757 3.9 1.285-1.036 2.098-2.584 2.098-4.306 0-1.8-.856-3.422-2.242-4.46z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path d="M126.844 305.59h15.604v-76.45h-15.604v76.45z" fill="#ccc" />
            <path
                d="M137.967 229.244v76.285m1.753-76.286v76.285m-12.876.062h15.604v-76.45h-15.604v76.45z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M158.387 257.735c-3.405-1.407-9.193-2.45-15.834-2.67-2.29.02-4.842.234-7.477.673-9.333 1.557-16.443 5.283-15.877 8.318.01.064.03.196.045.255 0 0-3.497-7.883-3.556-8.184-.623-3.368 7.263-7.506 17.623-9.234 3.25-.543 6.42-.754 9.174-.727 6.628 0 12.387.85 15.856 2.138l.044 9.432"
                fill="#ad1519"
            />
            <path
                d="M158.387 257.735c-3.405-1.407-9.193-2.45-15.834-2.67-2.29.02-4.842.234-7.477.673-9.333 1.557-16.443 5.283-15.877 8.318.01.064.03.196.045.255 0 0-3.497-7.883-3.556-8.184-.623-3.368 7.263-7.506 17.623-9.234 3.25-.543 6.42-.754 9.174-.727 6.628 0 12.387.85 15.856 2.138l.044 9.432"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M126.82 267.33c-4.328-.31-7.282-1.465-7.62-3.274-.268-1.442 1.194-3.038 3.807-4.486 1.166.125 2.48.286 3.837.286l-.025 7.475"
                fill="#ad1519"
            />
            <path
                d="M126.82 267.33c-4.328-.31-7.282-1.465-7.62-3.274-.268-1.442 1.194-3.038 3.807-4.486 1.166.125 2.48.286 3.837.286l-.025 7.475"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M142.477 261.49c2.703.408 4.734 1.08 5.744 1.904l.092.166c.482.99-1.893 3.093-5.86 5.442l.025-7.513"
                fill="#ad1519"
            />
            <path
                d="M142.477 261.49c2.703.408 4.734 1.08 5.744 1.904l.092.166c.482.99-1.893 3.093-5.86 5.442l.025-7.513"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M117.125 282.08c-.41-1.236 3.81-3.707 9.773-5.895 2.725-.975 4.975-1.992 7.763-3.22 8.285-3.664 14.404-7.867 13.652-9.4l-.083-.157c.442.358 1.125 7.908 1.125 7.908.757 1.405-4.844 5.546-12.472 9.2-2.44 1.167-7.595 3.072-10.028 3.924-4.352 1.51-8.68 4.358-8.282 5.414l-1.448-7.77"
                fill="#ad1519"
            />
            <path
                d="M117.125 282.08c-.41-1.236 3.81-3.707 9.773-5.895 2.725-.975 4.975-1.992 7.763-3.22 8.285-3.664 14.404-7.867 13.652-9.4l-.083-.157c.442.358 1.125 7.908 1.125 7.908.757 1.405-4.844 5.546-12.472 9.2-2.44 1.167-7.595 3.072-10.028 3.924-4.352 1.51-8.68 4.358-8.282 5.414l-1.448-7.77v-.005z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M125.768 254.068c1.908-.696 3.157-1.518 2.545-3.02-.386-.956-1.372-1.14-2.844-.6l-2.61.947 2.35 5.792c.256-.116.51-.236.778-.334.262-.096.54-.168.81-.246l-1.03-2.536v-.002zm-1.134-2.796l.66-.24c.546-.2 1.165.09 1.44.765.203.515.15 1.087-.48 1.49a4.397 4.397 0 01-.673.313l-.946-2.328m7.231-2.422c-.274.073-.547.156-.825.21-.275.054-.56.085-.84.122l1.352 6.024 4.208-.845c-.05-.118-.116-.245-.14-.368-.03-.126-.025-.266-.033-.392-.737.212-1.544.44-2.512.635l-1.205-5.386m8.422 5.194c.795-2.185 1.756-4.28 2.702-6.4a5.287 5.287 0 01-1.04.07c-.503 1.537-1.13 3.074-1.79 4.605-.79-1.453-1.665-2.87-2.332-4.334-.327.042-.662.09-.993.113-.327.02-.67.015-.997.02a131.437 131.437 0 013.492 5.986c.154-.028.313-.065.48-.076.156-.01.32.005.478.01m8.797-4.63c.146-.294.295-.58.46-.853-.226-.215-.922-.527-1.736-.61-1.716-.17-2.702.593-2.817 1.63-.242 2.168 3.18 1.98 3.024 3.42-.068.62-.727.87-1.425.803-.78-.08-1.35-.508-1.45-1.145l-.213-.02a7.262 7.262 0 01-.455 1.106c.5.324 1.153.508 1.775.57 1.75.173 3.086-.528 3.212-1.68.227-2.06-3.23-2.18-3.096-3.393.057-.51.45-.846 1.343-.756.64.065 1.038.412 1.21.91l.17.018"
                fill="#c8b100"
            />
            <path
                d="M277.852 211.606s-.705.743-1.22.85c-.515.1-1.166-.464-1.166-.464s-.464.483-1.033.612c-.57.13-1.36-.64-1.36-.64s-.54.77-1.028.95c-.49.18-1.083-.23-1.083-.23s-.216.38-.623.592c-.174.082-.46-.054-.46-.054l-.575-.358-.652-.695-.596-.234s-.27-.872-.298-1.025l-.08-.54c-.122-.624.838-1.348 2.21-1.658.788-.184 1.474-.17 1.98-.014.547-.466 1.706-.79 3.07-.79 1.234 0 2.318.26 2.916.667.59-.406 1.673-.668 2.912-.668 1.356 0 2.515.325 3.063.79.508-.155 1.19-.166 1.984.015 1.367.31 2.332 1.034 2.21 1.657l-.082.54c-.03.154-.3 1.026-.3 1.026l-.597.233-.652.694-.564.358s-.29.136-.462.054c-.407-.208-.627-.592-.627-.592s-.596.41-1.083.23c-.488-.18-1.032-.95-1.032-.95s-.785.77-1.358.64c-.568-.13-1.03-.612-1.03-.612s-.652.565-1.165.463c-.518-.106-1.216-.85-1.216-.85"
                fill="#ad1519"
            />
            <path
                d="M277.852 211.606s-.705.743-1.22.85c-.515.1-1.166-.464-1.166-.464s-.464.483-1.033.612c-.57.13-1.36-.64-1.36-.64s-.54.77-1.028.95c-.49.18-1.083-.23-1.083-.23s-.216.38-.623.592c-.174.082-.46-.054-.46-.054l-.575-.358-.652-.695-.596-.234s-.27-.872-.298-1.025l-.08-.54c-.122-.624.838-1.348 2.21-1.658.788-.184 1.474-.17 1.98-.014.547-.466 1.706-.79 3.07-.79 1.234 0 2.318.26 2.916.667.59-.406 1.673-.668 2.912-.668 1.356 0 2.515.325 3.063.79.508-.155 1.19-.166 1.984.015 1.367.31 2.332 1.034 2.21 1.657l-.082.54c-.03.154-.3 1.026-.3 1.026l-.597.233-.652.694-.564.358s-.29.136-.462.054c-.407-.208-.627-.592-.627-.592s-.596.41-1.083.23c-.488-.18-1.032-.95-1.032-.95s-.785.77-1.358.64c-.568-.13-1.03-.612-1.03-.612s-.652.565-1.165.463c-.518-.106-1.216-.85-1.216-.85h-.004z"
                fill="none"
                stroke="#000"
                strokeWidth={0.259}
            />
            <path
                d="M276.51 207.55c0-1.04.59-1.882 1.32-1.882.73 0 1.325.84 1.325 1.88 0 1.045-.594 1.89-1.325 1.89-.73 0-1.32-.845-1.32-1.89"
                fill="#c8b100"
            />
            <path
                d="M276.51 207.55c0-1.04.59-1.882 1.32-1.882.73 0 1.325.84 1.325 1.88 0 1.045-.594 1.89-1.325 1.89-.73 0-1.32-.845-1.32-1.89z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M277.247 207.55c0-.955.274-1.732.61-1.732.336 0 .607.777.607 1.73 0 .96-.27 1.737-.608 1.737-.335 0-.61-.778-.61-1.736"
                fill="#c8b100"
            />
            <path
                d="M277.247 207.55c0-.955.274-1.732.61-1.732.336 0 .607.777.607 1.73 0 .96-.27 1.737-.608 1.737-.335 0-.61-.778-.61-1.736z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M271.037 215.28a4.536 4.536 0 00-.56-1.04c1.87-.548 4.473-.892 7.367-.9 2.895.008 5.515.352 7.384.9l-.5.88c-.163.284-.376.777-.36.777-1.69-.517-3.863-.783-6.534-.786-2.675.004-5.246.33-6.585.822.018 0-.094-.31-.227-.65h.014"
                fill="#c8b100"
            />
            <path
                d="M271.037 215.28a4.536 4.536 0 00-.56-1.04c1.87-.548 4.473-.892 7.367-.9 2.895.008 5.515.352 7.384.9l-.5.88c-.163.284-.376.777-.36.777-1.69-.517-3.863-.783-6.534-.786-2.675.004-5.246.33-6.585.822.018 0-.094-.31-.227-.65h.014"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M277.844 217.657c2.336-.004 4.907-.358 5.857-.603.634-.185 1.006-.47.936-.802-.03-.156-.168-.292-.353-.37-1.393-.447-3.904-.764-6.44-.768-2.528.004-5.052.32-6.45.767-.178.08-.32.216-.35.372-.07.33.3.617.938.802.948.245 3.53.6 5.864.603"
                fill="#c8b100"
            />
            <path
                d="M277.844 217.657c2.336-.004 4.907-.358 5.857-.603.634-.185 1.006-.47.936-.802-.03-.156-.168-.292-.353-.37-1.393-.447-3.904-.764-6.44-.768-2.528.004-5.052.32-6.45.767-.178.08-.32.216-.35.372-.07.33.3.617.938.802.948.245 3.53.6 5.864.603z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M283.507 208.392c0-.23.194-.413.43-.413.243 0 .437.183.437.412 0 .228-.194.41-.436.41a.42.42 0 01-.43-.41"
                fill="#fff"
            />
            <path
                d="M283.507 208.392c0-.23.194-.413.43-.413.243 0 .437.183.437.412 0 .228-.194.41-.436.41a.42.42 0 01-.43-.41zm-.244-1.439a.42.42 0 01.432-.412c.24 0 .435.184.435.413 0 .225-.196.41-.435.41a.422.422 0 01-.432-.41zm-1.088-.9c0-.228.193-.412.436-.412.237 0 .433.185.433.412 0 .23-.196.413-.432.413a.422.422 0 01-.435-.413zm-1.358-.433c0-.232.195-.416.435-.416.242 0 .433.184.433.416 0 .222-.19.41-.433.41-.24 0-.435-.188-.435-.41zm-1.382.048c0-.23.194-.412.432-.412.242 0 .437.183.437.412 0 .228-.195.408-.437.408a.42.42 0 01-.432-.408z"
                fill="none"
                stroke="#000"
                strokeWidth={0.202}
            />
            <path
                d="M287.798 211.187c.13-.317.21-.67.21-1.033 0-1.527-1.21-2.768-2.712-2.768-.48 0-.93.13-1.32.354"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
                strokeLinecap="round"
            />
            <path
                d="M282.967 209.244c.14-.25.24-.552.24-.84 0-1.1-1.137-1.992-2.536-1.992-.597 0-1.145.163-1.576.432"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M288.172 209.933c0-.226.198-.413.436-.413.24 0 .435.187.435.413 0 .228-.195.41-.435.41-.238 0-.436-.182-.436-.41zm-.164-1.514c0-.23.197-.41.437-.41a.42.42 0 01.433.41c0 .224-.195.408-.433.408-.24 0-.437-.184-.437-.41zm-.973-1.16a.42.42 0 01.432-.41c.24 0 .434.185.434.41a.423.423 0 01-.433.412.423.423 0 01-.432-.412zm-1.304-.618c0-.224.196-.408.436-.408s.433.184.433.408c0 .23-.195.417-.434.417a.427.427 0 01-.435-.418zm-1.384.056c0-.23.194-.413.434-.413s.437.184.437.413c0 .224-.196.41-.437.41-.24 0-.434-.186-.434-.41z"
                fill="none"
                stroke="#000"
                strokeWidth={0.202}
            />
            <path
                d="M285.34 213.198l-.566-.514s-.544.333-1.223.23c-.676-.1-.893-.922-.893-.922s-.762.636-1.382.59c-.623-.056-1.03-.59-1.03-.59s-.68.483-1.277.436c-.597-.055-1.167-.798-1.167-.798s-.596.77-1.194.825c-.597.048-1.084-.52-1.084-.52s-.273.568-1.033.693c-.76.13-1.41-.59-1.41-.59s-.43.696-.948.877c-.514.18-1.19-.26-1.19-.26s-.11.26-.192.413c-.083.154-.3.182-.3.182l.17.46c1.86-.54 4.382-.873 7.232-.876 2.854.003 5.445.337 7.303.88l.19-.516"
                fill="#c8b100"
            />
            <path
                d="M285.34 213.198l-.566-.514s-.544.333-1.223.23c-.676-.1-.893-.922-.893-.922s-.762.636-1.382.59c-.623-.056-1.03-.59-1.03-.59s-.68.483-1.277.436c-.597-.055-1.167-.798-1.167-.798s-.596.77-1.194.825c-.597.048-1.084-.52-1.084-.52s-.273.568-1.033.693c-.76.13-1.41-.59-1.41-.59s-.43.696-.948.877c-.514.18-1.19-.26-1.19-.26s-.11.26-.192.413c-.083.154-.3.182-.3.182l.17.46c1.86-.54 4.382-.873 7.232-.876 2.854.003 5.445.337 7.303.88l.19-.516h-.004z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M271.258 208.392c0-.23.193-.413.435-.413.237 0 .432.183.432.412a.42.42 0 01-.432.41c-.242 0-.435-.182-.435-.41"
                fill="#fff"
            />
            <path
                d="M271.258 208.392c0-.23.193-.413.435-.413.237 0 .432.183.432.412a.42.42 0 01-.432.41c-.242 0-.435-.182-.435-.41zm.245-1.439c0-.23.194-.412.435-.412.238 0 .432.184.432.413 0 .225-.194.41-.432.41-.24 0-.435-.185-.435-.41zm1.083-.9c0-.228.194-.412.435-.412.242 0 .437.185.437.412 0 .23-.195.413-.436.413a.424.424 0 01-.434-.413zm1.357-.433c0-.232.195-.416.435-.416.242 0 .436.184.436.416 0 .222-.194.41-.436.41-.24 0-.435-.188-.435-.41zm1.385.048c0-.23.194-.412.432-.412.242 0 .436.183.436.412 0 .228-.194.408-.436.408a.42.42 0 01-.432-.408z"
                fill="none"
                stroke="#000"
                strokeWidth={0.202}
            />
            <path
                d="M267.832 211.187a2.793 2.793 0 01-.21-1.033c0-1.527 1.213-2.768 2.712-2.768.48 0 .93.13 1.323.354"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
                strokeLinecap="round"
            />
            <path
                d="M272.697 209.21c-.14-.246-.275-.518-.275-.805 0-1.1 1.14-1.993 2.54-1.993a3 3 0 011.576.432"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M266.59 209.933c0-.226.192-.413.435-.413.235 0 .43.187.43.413a.42.42 0 01-.43.41c-.243 0-.436-.182-.436-.41zm.16-1.514c0-.23.198-.41.437-.41.24 0 .435.18.435.41 0 .224-.194.408-.435.408-.24 0-.436-.184-.436-.41zm.98-1.16c0-.225.194-.41.436-.41a.42.42 0 01.432.41.423.423 0 01-.432.412.424.424 0 01-.436-.412zm1.303-.618c0-.224.194-.408.43-.408.244 0 .437.184.437.408 0 .23-.193.417-.436.417a.425.425 0 01-.43-.418zm1.382.056c0-.23.194-.413.436-.413a.42.42 0 01.433.413.42.42 0 01-.432.41c-.24 0-.435-.186-.435-.41z"
                fill="none"
                stroke="#000"
                strokeWidth={0.202}
            />
            <path
                d="M277.86 210.712l.27.05a.998.998 0 00-.052.356c0 .56.48 1.013 1.07 1.013.475 0 .88-.293 1.016-.698.016.01.103-.368.146-.362.04 0 .033.393.043.386.07.507.536.856 1.062.856.59 0 1.068-.453 1.068-1.012a.712.712 0 00-.01-.123l.338-.335.18.426a.92.92 0 00-.1.44c0 .536.458.97 1.02.97.356 0 .67-.175.85-.434l.215-.273-.004.34c0 .332.146.632.47.687 0 0 .38.027.877-.368.5-.393.775-.72.775-.72l.028.402s-.49.804-.933 1.06c-.244.143-.616.293-.91.24-.314-.046-.533-.298-.65-.584a1.49 1.49 0 01-.765.207c-.604 0-1.147-.334-1.36-.827a1.5 1.5 0 01-1.12.48c-.48 0-.924-.215-1.202-.552a1.542 1.542 0 01-1.052.406c-.53 0-1.01-.267-1.28-.66-.27.393-.742.66-1.28.66-.406 0-.776-.154-1.05-.406a1.556 1.556 0 01-1.2.552c-.454 0-.84-.18-1.117-.48-.213.49-.76.827-1.36.827-.28 0-.54-.075-.763-.207-.115.286-.338.538-.648.585-.296.052-.667-.098-.91-.24-.45-.257-.977-1.06-.977-1.06l.07-.404s.27.327.77.72c.5.394.877.367.877.367.327-.055.467-.355.467-.688v-.34l.214.274c.184.26.496.433.85.433.566 0 1.022-.433 1.022-.968a.922.922 0 00-.1-.442l.18-.426.333.335c-.007.04-.007.08-.007.123 0 .56.476 1.012 1.06 1.012.53 0 .996-.35 1.064-.856.014.007.01-.386.046-.386.048-.007.133.373.148.362.14.405.543.7 1.018.7.592 0 1.07-.455 1.07-1.014a.982.982 0 00-.05-.357l.277-.048"
                fill="#c8b100"
            />
            <path
                d="M277.86 210.712l.27.05a.998.998 0 00-.052.356c0 .56.48 1.013 1.07 1.013.475 0 .88-.293 1.016-.698.016.01.103-.368.146-.362.04 0 .033.393.043.386.07.507.536.856 1.062.856.59 0 1.068-.453 1.068-1.012a.712.712 0 00-.01-.123l.338-.335.18.426a.92.92 0 00-.1.44c0 .536.458.97 1.02.97.356 0 .67-.175.85-.434l.215-.273-.004.34c0 .332.146.632.47.687 0 0 .38.027.877-.368.5-.393.775-.72.775-.72l.028.402s-.49.804-.933 1.06c-.244.143-.616.293-.91.24-.314-.046-.533-.298-.65-.584a1.49 1.49 0 01-.765.207c-.604 0-1.147-.334-1.36-.827a1.5 1.5 0 01-1.12.48c-.48 0-.924-.215-1.202-.552a1.542 1.542 0 01-1.052.406c-.53 0-1.01-.267-1.28-.66-.27.393-.742.66-1.28.66-.406 0-.776-.154-1.05-.406a1.556 1.556 0 01-1.2.552c-.454 0-.84-.18-1.117-.48-.213.49-.76.827-1.36.827-.28 0-.54-.075-.763-.207-.115.286-.338.538-.648.585-.296.052-.667-.098-.91-.24-.45-.257-.977-1.06-.977-1.06l.07-.404s.27.327.77.72c.5.394.877.367.877.367.327-.055.467-.355.467-.688v-.34l.214.274c.184.26.496.433.85.433.566 0 1.022-.433 1.022-.968a.922.922 0 00-.1-.442l.18-.426.333.335c-.007.04-.007.08-.007.123 0 .56.476 1.012 1.06 1.012.53 0 .996-.35 1.064-.856.014.007.01-.386.046-.386.048-.007.133.373.148.362.14.405.543.7 1.018.7.592 0 1.07-.455 1.07-1.014a.982.982 0 00-.05-.357l.277-.048h.008z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M277.844 213.345c-2.894.003-5.493.347-7.36.9-.126.04-.28-.056-.32-.168-.04-.118.05-.265.17-.306 1.88-.572 4.545-.933 7.51-.936 2.963.003 5.64.364 7.517.937.125.042.216.19.177.307-.04.112-.2.208-.32.168-1.87-.553-4.478-.897-7.373-.9"
                fill="#c8b100"
            />
            <path
                d="M277.844 213.345c-2.894.003-5.493.347-7.36.9-.126.04-.28-.056-.32-.168-.04-.118.05-.265.17-.306 1.88-.572 4.545-.933 7.51-.936 2.963.003 5.64.364 7.517.937.125.042.216.19.177.307-.04.112-.2.208-.32.168-1.87-.553-4.478-.897-7.373-.9z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M275.044 214.37c0-.217.187-.395.422-.395.23 0 .417.178.417.396a.404.404 0 01-.417.395c-.235 0-.422-.173-.422-.394"
                fill="#fff"
            />
            <path
                d="M275.044 214.37c0-.217.187-.395.422-.395.23 0 .417.178.417.396a.404.404 0 01-.417.395c-.235 0-.422-.173-.422-.394z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M277.88 214.542h-.93c-.175 0-.32-.137-.32-.3 0-.162.14-.294.315-.294h1.883a.3.3 0 01.308.293c0 .165-.14.302-.312.302h-.944"
                fill="#ad1519"
            />
            <path
                d="M277.88 214.542h-.93c-.175 0-.32-.137-.32-.3 0-.162.14-.294.315-.294h1.883a.3.3 0 01.308.293c0 .165-.14.302-.312.302h-.944"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M273.216 214.86l-.666.1a.316.316 0 01-.36-.248.294.294 0 01.258-.334l.67-.1.683-.105c.172-.02.33.086.36.246a.302.302 0 01-.264.336l-.68.105"
                fill="#058e6e"
            />
            <path
                d="M273.216 214.86l-.666.1a.316.316 0 01-.36-.248.294.294 0 01.258-.334l.67-.1.683-.105c.172-.02.33.086.36.246a.302.302 0 01-.264.336l-.68.105"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M270.526 215.328l.296-.476.634.12-.368.535-.562-.18" fill="#ad1519" />
            <path
                d="M270.526 215.328l.296-.476.634.12-.368.535-.562-.18"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M279.81 214.37c0-.217.19-.395.42-.395.232 0 .422.178.422.396 0 .222-.19.395-.42.395-.23 0-.42-.173-.42-.394"
                fill="#fff"
            />
            <path
                d="M279.81 214.37c0-.217.19-.395.42-.395.232 0 .422.178.422.396 0 .222-.19.395-.42.395-.23 0-.42-.173-.42-.394z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M282.477 214.86l.67.1a.312.312 0 00.356-.248.292.292 0 00-.255-.334l-.67-.1-.683-.105c-.173-.02-.332.086-.357.246-.03.158.094.312.263.336l.677.105"
                fill="#058e6e"
            />
            <path
                d="M282.477 214.86l.67.1a.312.312 0 00.356-.248.292.292 0 00-.255-.334l-.67-.1-.683-.105c-.173-.02-.332.086-.357.246-.03.158.094.312.263.336l.677.105"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M285.113 215.356l-.238-.508-.65.054.312.57.576-.116" fill="#ad1519" />
            <path
                d="M285.113 215.356l-.238-.508-.65.054.312.57.576-.116"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M277.84 217.115c-2.335-.003-4.448-.208-6.057-.623 1.61-.413 3.722-.67 6.058-.675 2.337.003 4.46.26 6.065.675-1.604.415-3.728.62-6.064.623"
                fill="#ad1519"
            />
            <path
                d="M277.84 217.115c-2.335-.003-4.448-.208-6.057-.623 1.61-.413 3.722-.67 6.058-.675 2.337.003 4.46.26 6.065.675-1.604.415-3.728.62-6.064.623z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
                strokeLinejoin="round"
            />
            <path
                d="M285.206 212.05c.06-.18.008-.36-.127-.404-.13-.036-.284.08-.346.253-.064.183-.008.365.122.405.13.037.288-.075.35-.255"
                fill="#c8b100"
            />
            <path
                d="M285.206 212.05c.06-.18.008-.36-.127-.404-.13-.036-.284.08-.346.253-.064.183-.008.365.122.405.13.037.288-.075.35-.255z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M280.555 211.15c.025-.188-.07-.355-.205-.372-.133-.017-.267.126-.288.314-.025.187.064.354.202.37.136.014.266-.13.29-.312"
                fill="#c8b100"
            />
            <path
                d="M280.555 211.15c.025-.188-.07-.355-.205-.372-.133-.017-.267.126-.288.314-.025.187.064.354.202.37.136.014.266-.13.29-.312z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M275.156 211.15c-.025-.188.064-.355.2-.372.138-.017.267.126.293.314.02.187-.07.354-.203.37-.136.014-.267-.13-.29-.312"
                fill="#c8b100"
            />
            <path
                d="M275.156 211.15c-.025-.188.064-.355.2-.372.138-.017.267.126.293.314.02.187-.07.354-.203.37-.136.014-.267-.13-.29-.312z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M270.505 212.05c-.065-.18-.007-.36.122-.404.13-.036.288.08.35.253.06.183.007.365-.122.405-.134.037-.29-.075-.35-.255"
                fill="#c8b100"
            />
            <path
                d="M270.505 212.05c-.065-.18-.007-.36.122-.404.13-.036.288.08.35.253.06.183.007.365-.122.405-.134.037-.29-.075-.35-.255z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M277.84 208.463l-.823.497.61 1.326.214.14.21-.14.615-1.326-.824-.497" fill="#c8b100" />
            <path
                d="M277.84 208.463l-.823.497.61 1.326.214.14.21-.14.615-1.326-.824-.497"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M276.033 210.468l.376.546 1.284-.397.136-.18-.136-.185-1.285-.375-.377.59" fill="#c8b100" />
            <path
                d="M276.033 210.468l.376.546 1.284-.397.136-.18-.136-.185-1.285-.375-.377.59"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M279.655 210.468l-.378.546-1.285-.397-.136-.18.136-.185 1.285-.375.378.59" fill="#c8b100" />
            <path
                d="M279.655 210.468l-.378.546-1.285-.397-.136-.18.136-.185 1.285-.375.378.59"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M272.48 209.053l-.646.61.827 1.092.22.087.164-.167.29-1.318-.854-.304" fill="#c8b100" />
            <path
                d="M272.48 209.053l-.646.61.827 1.092.22.087.164-.167.29-1.318-.854-.304"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M271.124 211.24l.485.457 1.173-.633.09-.204-.168-.154-1.342-.116-.24.65" fill="#c8b100" />
            <path
                d="M271.124 211.24l.485.457 1.173-.633.09-.204-.168-.154-1.342-.116-.24.65"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M274.666 210.53l-.248.602-1.344-.122-.174-.155.092-.207 1.178-.62.496.5" fill="#c8b100" />
            <path
                d="M274.666 210.53l-.248.602-1.344-.122-.174-.155.092-.207 1.178-.62.496.5"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M269.832 211.41l-.11.64-1.346.14-.204-.117.05-.217 1.012-.84.598.395" fill="#c8b100" />
            <path
                d="M269.832 211.41l-.11.64-1.346.14-.204-.117.05-.217 1.012-.84.598.395"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M272.42 210.863c0-.25.213-.45.472-.45a.46.46 0 01.47.45.46.46 0 01-.47.446.46.46 0 01-.472-.447"
                fill="#c8b100"
            />
            <path
                d="M272.42 210.863c0-.25.213-.45.472-.45a.46.46 0 01.47.45.46.46 0 01-.47.446.46.46 0 01-.472-.447z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M283.22 209.053l.647.61-.83 1.092-.22.087-.16-.167-.292-1.318.854-.304" fill="#c8b100" />
            <path
                d="M283.22 209.053l.647.61-.83 1.092-.22.087-.16-.167-.292-1.318.854-.304"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M284.576 211.24l-.486.457-1.174-.633-.094-.204.174-.154 1.342-.116.238.65" fill="#c8b100" />
            <path
                d="M284.576 211.24l-.486.457-1.174-.633-.094-.204.174-.154 1.342-.116.238.65"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M281.034 210.53l.247.602 1.345-.122.172-.155-.09-.207-1.176-.62-.496.5" fill="#c8b100" />
            <path
                d="M281.034 210.53l.247.602 1.345-.122.172-.155-.09-.207-1.176-.62-.496.5"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M285.688 211.41l.108.64 1.34.14.204-.117-.05-.217-1.008-.84-.594.395" fill="#c8b100" />
            <path
                d="M285.688 211.41l.108.64 1.34.14.204-.117-.05-.217-1.008-.84-.594.395"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M277.377 210.44c0-.252.207-.45.47-.45.257 0 .473.198.473.45 0 .245-.213.447-.472.447a.458.458 0 01-.47-.446"
                fill="#c8b100"
            />
            <path
                d="M277.377 210.44c0-.252.207-.45.47-.45.257 0 .473.198.473.45 0 .245-.213.447-.472.447a.458.458 0 01-.47-.446z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M282.344 210.863c0-.25.212-.45.47-.45.263 0 .478.2.478.45 0 .245-.215.446-.477.446a.46.46 0 01-.47-.447"
                fill="#c8b100"
            />
            <path
                d="M282.344 210.863c0-.25.212-.45.47-.45.263 0 .478.2.478.45 0 .245-.215.446-.477.446a.46.46 0 01-.47-.447z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M276.963 205.396c0-.465.396-.84.885-.84.488 0 .89.375.89.84 0 .463-.402.838-.89.838-.49 0-.885-.375-.885-.838"
                fill="#c8b100"
            />
            <path
                d="M278.474 205.098v.556h-1.368v-.556h.448v-1.254h-.595v-.56h.594v-.547h.586v.548h.583v.56h-.583v1.253h.33"
                fill="#c8b100"
            />
            <path
                d="M278.474 205.098v.556h-1.368v-.556h.448v-1.254h-.595v-.56h.594v-.547h.586v.548h.583v.56h-.583v1.253h.334z"
                fill="none"
                stroke="#000"
                strokeWidth={0.288}
            />
            <path
                d="M279.087 205.098v.556h-2.434v-.556h.9v-1.254h-.594v-.56h.594v-.547h.586v.548h.586v.56h-.586v1.253h.947"
                fill="#c8b100"
            />
            <path
                d="M278.104 204.59c.366.1.633.424.633.806 0 .463-.395.838-.89.838-.488 0-.884-.375-.884-.838 0-.39.278-.713.655-.812"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M268.014 212.158c-.01.01-.364-.464-.63-.702-.187-.167-.647-.31-.647-.31 0-.085.27-.276.562-.276.168 0 .33.07.425.19l.034-.184s.237.045.34.308c.11.272.04.685.04.685s-.043.19-.126.288"
                fill="#c8b100"
            />
            <path
                d="M268.014 212.158c-.01.01-.364-.464-.63-.702-.187-.167-.647-.31-.647-.31 0-.085.27-.276.562-.276.168 0 .33.07.425.19l.034-.184s.237.045.34.308c.11.272.04.685.04.685s-.043.19-.126.288z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M268.032 211.923c.113-.116.342-.092.512.055.173.146.223.36.11.48-.11.12-.338.093-.51-.054-.173-.147-.223-.365-.112-.48"
                fill="#c8b100"
            />
            <path
                d="M268.032 211.923c.113-.116.342-.092.512.055.173.146.223.36.11.48-.11.12-.338.093-.51-.054-.173-.147-.223-.365-.112-.48z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M287.5 212.158c.016.01.364-.464.632-.702.184-.167.648-.31.648-.31 0-.085-.27-.276-.562-.276-.17 0-.33.07-.428.19l-.035-.184s-.24.045-.343.308c-.108.272-.04.685-.04.685s.043.19.13.288"
                fill="#c8b100"
            />
            <path
                d="M287.5 212.158c.016.01.364-.464.632-.702.184-.167.648-.31.648-.31 0-.085-.27-.276-.562-.276-.17 0-.33.07-.428.19l-.035-.184s-.24.045-.343.308c-.108.272-.04.685-.04.685s.043.19.13.288z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M287.514 211.923c-.114-.116-.342-.092-.516.055-.173.146-.22.36-.112.48.112.12.342.093.514-.054.173-.147.225-.365.114-.48"
                fill="#c8b100"
            />
            <path
                d="M287.514 211.923c-.114-.116-.342-.092-.516.055-.173.146-.22.36-.112.48.112.12.342.093.514-.054.173-.147.225-.365.114-.48z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M267.165 223.074h21.394v-5.608h-21.395v5.608z" fill="#c8b100" />
            <path d="M267.165 223.074h21.394v-5.608h-21.395v5.608z" fill="none" stroke="#000" strokeWidth={0.374} />
            <path
                d="M286.315 226.806a.944.944 0 00-.396-.06h-16.023c-.16 0-.31.026-.443.077.55-.183.947-.68.947-1.268 0-.586-.43-1.094-.985-1.285.133.04.312.08.47.08h16.034c.16 0 .312-.008.448-.053l-.09.014c-.572.178-.9.686-.9 1.245 0 .538.363 1.078.937 1.25"
                fill="#c8b100"
            />
            <path
                d="M286.315 226.806a.944.944 0 00-.396-.06h-16.023c-.16 0-.31.026-.443.077.55-.183.947-.68.947-1.268 0-.586-.43-1.094-.985-1.285.133.04.312.08.47.08h16.034c.16 0 .312-.008.448-.053l-.09.014c-.572.178-.9.686-.9 1.245 0 .538.363 1.078.937 1.25z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M269.897 226.745h16.022c.538 0 .978.337.978.75 0 .416-.44.754-.98.754H269.9c-.545 0-.984-.34-.984-.755 0-.413.44-.75.983-.75"
                fill="#c8b100"
            />
            <path
                d="M269.897 226.745h16.022c.538 0 .978.337.978.75 0 .416-.44.754-.98.754H269.9c-.545 0-.984-.34-.984-.755 0-.413.44-.75.983-.75z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M269.885 223.074h16.034c.538 0 .978.286.978.634 0 .354-.44.64-.98.64h-16.033c-.542 0-.982-.286-.982-.64 0-.348.44-.634.982-.634"
                fill="#c8b100"
            />
            <path
                d="M269.885 223.074h16.034c.538 0 .978.286.978.634 0 .354-.44.64-.98.64h-16.033c-.542 0-.982-.286-.982-.64 0-.348.44-.634.982-.634z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M262.925 317.45c1.482 0 2.8-.31 3.77-.83.967-.49 2.273-.79 3.712-.79 1.444 0 2.787.304 3.752.797.964.51 2.302.822 3.764.822 1.476 0 2.8-.346 3.772-.863.957-.47 2.235-.758 3.642-.758 1.452 0 2.736.276 3.705.777.968.516 2.317.842 3.793.842v2.316c-1.476 0-2.825-.337-3.793-.848-.97-.498-2.253-.78-3.705-.78-1.407 0-2.685.29-3.642.763-.968.516-2.296.866-3.772.866-1.458 0-2.797-.32-3.765-.823-.966-.5-2.305-.805-3.753-.805-1.44 0-2.745.304-3.71.798-.973.517-2.27.83-3.75.83l-.022-2.317"
                fill="#005bbf"
            />
            <path
                d="M262.925 317.45c1.482 0 2.8-.31 3.77-.83.967-.49 2.273-.79 3.712-.79 1.444 0 2.787.304 3.752.797.964.51 2.302.822 3.764.822 1.476 0 2.8-.346 3.772-.863.957-.47 2.235-.758 3.642-.758 1.452 0 2.736.276 3.705.777.968.516 2.317.842 3.793.842v2.316c-1.476 0-2.825-.337-3.793-.848-.97-.498-2.253-.78-3.705-.78-1.407 0-2.685.29-3.642.763-.968.516-2.296.866-3.772.866-1.458 0-2.797-.32-3.765-.823-.966-.5-2.305-.805-3.753-.805-1.44 0-2.745.304-3.71.798-.973.517-2.27.83-3.75.83l-.022-2.317z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M262.925 319.766c1.482 0 2.8-.313 3.77-.83.967-.494 2.273-.798 3.712-.798 1.444 0 2.787.304 3.752.805.964.504 2.302.823 3.764.823 1.476 0 2.8-.35 3.772-.865.957-.473 2.235-.762 3.642-.762 1.452 0 2.736.282 3.705.78.968.51 2.317.848 3.793.848v2.312c-1.476 0-2.825-.33-3.793-.842-.97-.505-2.253-.784-3.705-.784-1.407 0-2.685.29-3.642.764-.968.515-2.296.862-3.772.862-1.458 0-2.797-.32-3.765-.825-.966-.497-2.305-.8-3.753-.8-1.44 0-2.745.303-3.71.797-.973.515-2.27.828-3.75.828l-.022-2.312"
                fill="#ccc"
            />
            <path
                d="M262.925 319.766c1.482 0 2.8-.313 3.77-.83.967-.494 2.273-.798 3.712-.798 1.444 0 2.787.304 3.752.805.964.504 2.302.823 3.764.823 1.476 0 2.8-.35 3.772-.865.957-.473 2.235-.762 3.642-.762 1.452 0 2.736.282 3.705.78.968.51 2.317.848 3.793.848v2.312c-1.476 0-2.825-.33-3.793-.842-.97-.505-2.253-.784-3.705-.784-1.407 0-2.685.29-3.642.764-.968.515-2.296.862-3.772.862-1.458 0-2.797-.32-3.765-.825-.966-.497-2.305-.8-3.753-.8-1.44 0-2.745.303-3.71.797-.973.515-2.27.828-3.75.828l-.022-2.312"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M262.925 322.078c1.482 0 2.8-.313 3.77-.828.967-.494 2.273-.798 3.712-.798 1.444 0 2.787.304 3.752.8.964.506 2.302.826 3.764.826 1.476 0 2.8-.347 3.772-.862.957-.474 2.235-.764 3.642-.764 1.452 0 2.736.28 3.705.784.968.512 2.317.842 3.793.842v2.31c-1.476 0-2.825-.33-3.793-.844-.97-.497-2.253-.777-3.705-.777-1.407 0-2.685.29-3.642.76-.968.518-2.296.862-3.772.862-1.458 0-2.797-.317-3.765-.82-.966-.5-2.305-.803-3.753-.803-1.44 0-2.745.3-3.71.795-.973.52-2.27.827-3.75.827l-.022-2.312"
                fill="#005bbf"
            />
            <path
                d="M262.925 322.078c1.482 0 2.8-.313 3.77-.828.967-.494 2.273-.798 3.712-.798 1.444 0 2.787.304 3.752.8.964.506 2.302.826 3.764.826 1.476 0 2.8-.347 3.772-.862.957-.474 2.235-.764 3.642-.764 1.452 0 2.736.28 3.705.784.968.512 2.317.842 3.793.842v2.31c-1.476 0-2.825-.33-3.793-.844-.97-.497-2.253-.777-3.705-.777-1.407 0-2.685.29-3.642.76-.968.518-2.296.862-3.772.862-1.458 0-2.797-.317-3.765-.82-.966-.5-2.305-.803-3.753-.803-1.44 0-2.745.3-3.71.795-.973.52-2.27.827-3.75.827l-.022-2.312"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M262.946 326.704c1.48 0 2.778-.313 3.75-.83.966-.492 2.272-.793 3.71-.793 1.445 0 2.788.302 3.753.8.964.505 2.302.824 3.764.824 1.476 0 2.8-.348 3.772-.866.957-.47 2.235-.757 3.642-.757 1.452 0 2.736.28 3.705.78.968.514 2.317.844 3.793.844v-2.3c-1.476 0-2.825-.345-3.793-.86-.97-.497-2.253-.777-3.705-.777-1.407 0-2.685.29-3.642.76-.968.518-2.296.862-3.772.862-1.458 0-2.797-.317-3.765-.82-.966-.5-2.305-.803-3.753-.803-1.44 0-2.745.3-3.71.795-.973.52-2.29.827-3.772.827l.02 2.314"
                fill="#ccc"
            />
            <path
                d="M262.946 326.704c1.48 0 2.778-.313 3.75-.83.966-.492 2.272-.793 3.71-.793 1.445 0 2.788.302 3.753.8.964.505 2.302.824 3.764.824 1.476 0 2.8-.348 3.772-.866.957-.47 2.235-.757 3.642-.757 1.452 0 2.736.28 3.705.78.968.514 2.317.844 3.793.844v-2.3c-1.476 0-2.825-.345-3.793-.86-.97-.497-2.253-.777-3.705-.777-1.407 0-2.685.29-3.642.76-.968.518-2.296.862-3.772.862-1.458 0-2.797-.317-3.765-.82-.966-.5-2.305-.803-3.753-.803-1.44 0-2.745.3-3.71.795-.973.52-2.29.827-3.772.827l.02 2.314"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M262.946 329.02c1.48 0 2.778-.315 3.75-.83.966-.497 2.272-.8 3.71-.8 1.445 0 2.788.306 3.753.804.964.504 2.302.825 3.764.825 1.476 0 2.8-.352 3.772-.867.957-.473 2.235-.763 3.642-.763 1.452 0 2.736.283 3.705.783.968.512 2.317.846 3.793.846v-2.296c-1.476 0-2.825-.35-3.793-.865-.97-.5-2.253-.775-3.705-.775-1.407 0-2.685.286-3.642.757-.968.514-2.296.862-3.772.862-1.458 0-2.797-.32-3.765-.824-.966-.498-2.305-.795-3.753-.795-1.44 0-2.745.297-3.71.79-.973.516-2.286.83-3.765.83l.014 2.314"
                fill="#005bbf"
            />
            <path
                d="M262.946 329.02c1.48 0 2.778-.315 3.75-.83.966-.497 2.272-.8 3.71-.8 1.445 0 2.788.306 3.753.804.964.504 2.302.825 3.764.825 1.476 0 2.8-.352 3.772-.867.957-.473 2.235-.763 3.642-.763 1.452 0 2.736.283 3.705.783.968.512 2.317.846 3.793.846v-2.296c-1.476 0-2.825-.35-3.793-.865-.97-.5-2.253-.775-3.705-.775-1.407 0-2.685.286-3.642.757-.968.514-2.296.862-3.772.862-1.458 0-2.797-.32-3.765-.824-.966-.498-2.305-.795-3.753-.795-1.44 0-2.745.297-3.71.79-.973.516-2.286.83-3.765.83l.014 2.314z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M286.31 307.952c-.05.195-.117.386-.117.593 0 1.404 1.21 2.522 2.69 2.522H266.87c1.478 0 2.69-1.118 2.69-2.522 0-.205-.04-.398-.085-.593.12.045.27.05.418.05h16.022c.13 0 .28-.013.392-.05"
                fill="#c8b100"
            />
            <path
                d="M286.31 307.952c-.05.195-.117.386-.117.593 0 1.404 1.21 2.522 2.69 2.522H266.87c1.478 0 2.69-1.118 2.69-2.522 0-.205-.04-.398-.085-.593.12.045.27.05.418.05h16.022c.13 0 .28-.013.392-.05h.004z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M269.897 306.496h16.022c.538 0 .978.34.978.754 0 .416-.44.754-.98.754H269.9c-.545 0-.984-.338-.984-.754 0-.413.44-.754.983-.754"
                fill="#c8b100"
            />
            <path
                d="M269.897 306.496h16.022c.538 0 .978.34.978.754 0 .416-.44.754-.98.754H269.9c-.545 0-.984-.338-.984-.754 0-.413.44-.754.983-.754z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path d="M266.895 316.668h21.962v-5.6h-21.962v5.6z" fill="#c8b100" />
            <path d="M266.895 316.668h21.962v-5.6h-21.962v5.6z" fill="none" stroke="#000" strokeWidth={0.374} />
            <path
                d="M290.572 286.673c2.175 1.255 3.65 2.54 3.413 3.18-.12.59-.81 1.03-1.796 1.685-1.553 1.08-2.5 3.01-1.76 3.9-1.282-1.036-2.093-2.584-2.093-4.306 0-1.8.854-3.422 2.235-4.46"
                fill="#ad1519"
            />
            <path
                d="M290.572 286.673c2.175 1.255 3.65 2.54 3.413 3.18-.12.59-.81 1.03-1.796 1.685-1.553 1.08-2.5 3.01-1.76 3.9-1.282-1.036-2.093-2.584-2.093-4.306 0-1.8.854-3.422 2.235-4.46z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path d="M270.106 305.59h15.604v-76.45h-15.604v76.45z" fill="#ccc" />
            <path
                d="M281.425 229.11v76.29m1.754-76.287V305.4m-13.073.19h15.604v-76.45h-15.604v76.45z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M254.167 257.735c3.407-1.407 9.197-2.45 15.838-2.67 2.288.02 4.84.234 7.476.673 9.33 1.557 16.44 5.283 15.875 8.318-.01.064-.03.196-.047.255 0 0 3.5-7.883 3.553-8.184.627-3.368-7.256-7.506-17.615-9.234a53.48 53.48 0 00-9.176-.727c-6.63 0-12.39.85-15.86 2.138l-.043 9.432"
                fill="#ad1519"
            />
            <path
                d="M254.167 257.735c3.407-1.407 9.197-2.45 15.838-2.67 2.288.02 4.84.234 7.476.673 9.33 1.557 16.44 5.283 15.875 8.318-.01.064-.03.196-.047.255 0 0 3.5-7.883 3.553-8.184.627-3.368-7.256-7.506-17.615-9.234a53.48 53.48 0 00-9.176-.727c-6.63 0-12.39.85-15.86 2.138l-.043 9.432"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M285.738 267.33c4.327-.31 7.282-1.465 7.617-3.274.27-1.442-1.195-3.038-3.805-4.486-1.17.125-2.484.286-3.84.286l.028 7.475"
                fill="#ad1519"
            />
            <path
                d="M285.738 267.33c4.327-.31 7.282-1.465 7.617-3.274.27-1.442-1.195-3.038-3.805-4.486-1.17.125-2.484.286-3.84.286l.028 7.475"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M270.08 261.49c-2.706.408-4.734 1.08-5.748 1.904l-.09.166c-.486.99 1.892 3.093 5.86 5.442l-.02-7.513"
                fill="#ad1519"
            />
            <path
                d="M270.08 261.49c-2.706.408-4.734 1.08-5.748 1.904l-.09.166c-.486.99 1.892 3.093 5.86 5.442l-.02-7.513"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M295.428 282.08c.41-1.236-3.81-3.707-9.772-5.895-2.725-.975-4.976-1.992-7.764-3.22-8.283-3.664-14.402-7.867-13.647-9.4l.08-.157c-.436.358-1.12 7.908-1.12 7.908-.755 1.405 4.846 5.546 12.464 9.2 2.44 1.167 7.598 3.072 10.032 3.924 4.352 1.51 8.676 4.358 8.283 5.414l1.443-7.77"
                fill="#ad1519"
            />
            <path
                d="M295.428 282.08c.41-1.236-3.81-3.707-9.772-5.895-2.725-.975-4.976-1.992-7.764-3.22-8.283-3.664-14.402-7.867-13.647-9.4l.08-.157c-.436.358-1.12 7.908-1.12 7.908-.755 1.405 4.846 5.546 12.464 9.2 2.44 1.167 7.598 3.072 10.032 3.924 4.352 1.51 8.676 4.358 8.283 5.414l1.443-7.77v-.005z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M263.892 254.385c.59-2.24 1.353-4.405 2.102-6.597-.165.045-.344.08-.51.106a5.2 5.2 0 01-.522.047c-.356 1.576-.84 3.16-1.357 4.74-.922-1.384-1.926-2.728-2.725-4.125-.32.065-.652.143-.98.192-.32.047-.662.07-.992.102a131.248 131.248 0 014.032 5.674c.154-.04.304-.092.475-.116.154-.02.316-.017.477-.023m5.934-6.552c-.286.013-.57.034-.855.03-.282-.004-.566-.037-.847-.058l-.116 6.156 4.305.074c-.022-.126-.054-.263-.05-.392 0-.127.04-.26.06-.386-.77.05-1.61.1-2.598.082l.102-5.505m6.757 1.011c.688.058 1.35.177 2.013.297-.012-.13-.032-.26-.022-.393.01-.126.06-.253.094-.376l-5.83-.483c.015.13.037.257.023.382-.01.137-.058.26-.09.385a19.3 19.3 0 012.113.048l-.508 5.54c.284.006.568.003.85.026.283.022.565.073.845.115l.508-5.54m2.388 6.067c.28.044.564.077.843.14.277.057.548.147.818.224l.69-2.83.076.018c.16.388.37.862.48 1.135l.863 2.138c.338.054.675.098 1.008.17.34.075.668.174.996.266l-.298-.64c-.465-.966-.954-1.927-1.357-2.904 1.073.047 1.905-.342 2.113-1.204.148-.6-.09-1.07-.656-1.474-.416-.296-1.226-.453-1.748-.57l-2.35-.513-1.476 6.043m3.015-5.205c.678.15 1.524.26 1.524 1.03-.004.193-.023.33-.054.452-.22.904-.904 1.217-2.045.876l.575-2.358m8.082 7.05c-.052.668-.17 1.316-.3 2.018.294.14.586.266.87.422.285.158.547.33.82.502l.577-6.942a3.41 3.41 0 01-.75-.41l-6.12 3.888c.163.078.33.15.488.235.16.09.292.184.45.273.514-.433 1.054-.784 1.674-1.244l2.29 1.254v.003zm-1.734-1.585l2.038-1.32-.237 2.302-1.8-.982"
                fill="#c8b100"
            />
            <path
                d="M182.19 192.43c0-1.09.933-1.973 2.08-1.973 1.146 0 2.082.883 2.082 1.974 0 1.09-.932 1.97-2.08 1.97-1.15 0-2.08-.88-2.08-1.97z"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path
                d="M205.663 175.414c6.38 0 12.055.944 15.752 2.41 2.116.955 4.957 1.66 8.067 2.076 2.368.317 4.618.38 6.576.232 2.618-.05 6.404.715 10.19 2.382 3.135 1.39 5.752 3.082 7.49 4.72l-1.504 1.34-.435 3.802-4.127 4.724-2.062 1.75-4.884 3.91-2.495.204-.757 2.16-31.602-3.704-31.696 3.703-.76-2.16-2.498-.202-4.884-3.91-2.062-1.75-4.125-4.724-.43-3.803-1.51-1.34c1.745-1.637 4.362-3.328 7.49-4.72 3.787-1.666 7.574-2.432 10.19-2.38 1.957.148 4.208.084 6.576-.233 3.113-.416 5.956-1.12 8.068-2.076 3.7-1.466 9.06-2.41 15.435-2.41z"
                fill="#ad1519"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M206.148 217.132c-11.774-.017-22.32-1.41-29.846-3.678-.55-.167-.84-.672-.807-1.194-.01-.507.275-.967.807-1.128 7.526-2.264 18.072-3.658 29.846-3.675 11.77.017 22.31 1.41 29.838 3.675.532.16.812.62.802 1.128.03.522-.255 1.027-.802 1.194-7.527 2.267-18.067 3.66-29.838 3.678"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M206.12 215.587c-10.626-.013-20.23-1.24-27.54-3.128 7.31-1.894 16.914-3.05 27.54-3.07 10.622.02 20.277 1.176 27.588 3.07-7.31 1.887-16.966 3.114-27.59 3.127"
                fill="#ad1519"
            />
            <path d="M206.908 215.652v-6.305" fill="none" stroke="#000" strokeWidth={0.086} />
            <path d="M205.196 215.652v-6.305" fill="none" stroke="#000" strokeWidth={0.134} />
            <path d="M203.58 215.652v-6.305" fill="none" stroke="#000" strokeWidth={0.173} />
            <path d="M201.977 215.652v-6.305" fill="none" stroke="#000" strokeWidth={0.221} />
            <path d="M200.548 215.652v-6.305" fill="none" stroke="#000" strokeWidth={0.269} />
            <path d="M197.825 215.312l-.038-5.738m1.33 5.814v-6.003" fill="none" stroke="#000" strokeWidth={0.317} />
            <path d="M195.31 215.053v-5.286m1.274 5.438l-.037-5.626" fill="none" stroke="#000" strokeWidth={0.355} />
            <path
                d="M191.938 214.752v-4.645m1.106 4.72v-4.87m1.14 5.022v-5.063"
                fill="none"
                stroke="#000"
                strokeWidth={0.403}
            />
            <path d="M190.755 214.714v-4.494" fill="none" stroke="#000" strokeWidth={0.442} />
            <path d="M189.653 214.487v-4.19" fill="none" stroke="#000" strokeWidth={0.49} />
            <path d="M188.47 214.374v-3.89" fill="none" stroke="#000" strokeWidth={0.538} />
            <path d="M186.05 214.035l-.038-3.097m1.28 3.248v-3.475" fill="none" stroke="#000" strokeWidth={0.576} />
            <path d="M184.81 213.77v-2.72" fill="none" stroke="#000" strokeWidth={0.605} />
            <path d="M183.673 213.55v-2.266" fill="none" stroke="#000" strokeWidth={0.653} />
            <path d="M182.433 213.248v-1.774" fill="none" stroke="#000" strokeWidth={0.701} />
            <path d="M181.158 213.097v-1.32" fill="none" stroke="#000" strokeWidth={0.739} />
            <path d="M179.81 212.795v-.642" fill="none" stroke="#000" strokeWidth={0.874} />
            <path
                d="M213.72 215.312v-5.776m-2.9 5.965l.038-6.115m-2.153 6.192v-6.23"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path
                d="M206.066 207.447c-11.914.023-22.608 1.517-30.135 3.836.626-.298.57-1.068-.208-3.07-.94-2.426-2.404-2.32-2.404-2.32 8.322-2.457 19.905-3.995 32.798-4.013 12.898.018 24.575 1.556 32.897 4.013 0 0-1.465-.106-2.404 2.32-.78 2.002-.837 2.772-.21 3.07-7.526-2.32-18.42-3.813-30.334-3.836"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M206.116 201.883c-12.893.02-24.476 1.555-32.798 4.017-.555.166-1.142-.05-1.32-.576-.18-.526.118-1.13.673-1.3 8.358-2.563 20.24-4.172 33.45-4.2 13.212.025 25.14 1.637 33.497 4.2.555.17.854.774.674 1.3-.18.525-.766.742-1.32.576-8.323-2.462-19.956-3.996-32.854-4.017"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M206.12 215.587c-10.626-.013-20.23-1.24-27.54-3.128 7.31-1.894 16.914-3.05 27.54-3.07 10.622.02 20.277 1.176 27.588 3.07-7.31 1.887-16.966 3.114-27.59 3.127z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
                strokeLinejoin="round"
            />
            <path
                d="M196.92 204.812c0-.55.47-.995 1.05-.995.584 0 1.057.446 1.057.995 0 .548-.473 1-1.056 1-.58 0-1.05-.452-1.05-1"
                fill="#fff"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M206.142 205.596h-3.154c-.582 0-1.065-.443-1.065-.995 0-.548.472-.997 1.052-.997h6.376c.58 0 1.054.45 1.054.998 0 .553-.482.996-1.067.996h-3.195"
                fill="#ad1519"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M190.293 206.465l-2.27.263c-.578.07-1.115-.32-1.187-.863-.07-.548.34-1.046.92-1.11l2.282-.266 2.32-.268c.576-.067 1.102.314 1.174.863.07.545-.352 1.046-.928 1.11l-2.31.27"
                fill="#058e6e"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M181.072 206.664c0-.55.47-.996 1.05-.996.584 0 1.055.447 1.055.996 0 .552-.47.998-1.055.998-.58 0-1.05-.446-1.05-.998"
                fill="#fff"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M174.056 208.477l1.17-1.53 3.233.408-2.587 1.886-1.817-.763"
                fill="#ad1519"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M221.995 206.465l2.267.263c.575.07 1.117-.32 1.188-.863.065-.548-.342-1.046-.918-1.11l-2.282-.266-2.32-.268c-.58-.067-1.106.314-1.175.863-.072.545.353 1.046.928 1.11l2.312.27"
                fill="#058e6e"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M213.26 204.812c0-.55.474-.995 1.054-.995.582 0 1.054.446 1.054.995 0 .548-.472 1-1.054 1-.58 0-1.053-.452-1.053-1m15.849 1.852c0-.55.472-.996 1.052-.996.583 0 1.054.447 1.054.996 0 .552-.47.998-1.054.998-.58 0-1.052-.446-1.052-.998"
                fill="#fff"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M238.23 208.477l-1.168-1.53-3.233.408 2.584 1.886 1.817-.763"
                fill="#ad1519"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M177.31 212.796c7.444-2.09 17.566-3.385 28.81-3.406 11.242.02 21.414 1.316 28.858 3.406"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M182.324 183.762l1.332 1.068 1.997-3.262c-2.167-1.327-3.653-3.63-3.653-6.257 0-.295.017-.584.055-.87.208-4.164 5.28-7.604 11.718-7.604 3.34 0 6.358.914 8.482 2.38.057-.644.115-1.196.205-1.782-2.34-1.365-5.375-2.185-8.687-2.185-7.403 0-13.195 4.204-13.476 9.186-.03.29-.043.583-.043.875 0 2.658 1.213 5.05 3.13 6.714l-1.06 1.738"
                fill="#c8b100"
            />
            <path
                d="M182.324 183.762l1.332 1.068 1.997-3.262c-2.167-1.327-3.653-3.63-3.653-6.257 0-.295.017-.584.055-.87.208-4.164 5.28-7.604 11.718-7.604 3.34 0 6.358.914 8.482 2.38.057-.644.115-1.196.205-1.782-2.34-1.365-5.375-2.185-8.687-2.185-7.403 0-13.195 4.204-13.476 9.186-.03.29-.043.583-.043.875 0 2.658 1.213 5.05 3.13 6.714l-1.06 1.738"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M182.41 183.8c-2.527-1.886-4.095-4.45-4.095-7.27 0-3.254 2.126-6.154 5.358-8.077-1.994 1.6-3.203 3.67-3.376 5.983-.03.29-.043.583-.043.875 0 2.658 1.213 5.05 3.13 6.714l-.974 1.775"
                fill="#c8b100"
            />
            <path
                d="M182.41 183.8c-2.527-1.886-4.095-4.45-4.095-7.27 0-3.254 2.126-6.154 5.358-8.077-1.994 1.6-3.203 3.67-3.376 5.983-.03.29-.043.583-.043.875 0 2.658 1.213 5.05 3.13 6.714l-.974 1.775"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M160.12 187.092c-1.416-1.584-2.283-3.633-2.283-5.873 0-1.352.312-2.643.877-3.795 2.045-4.206 8.46-7.268 16.083-7.268 2.078 0 4.065.226 5.9.644-.407.445-.726.932-1.038 1.423a25.514 25.514 0 00-4.863-.457c-6.98 0-12.818 2.714-14.51 6.38a7.065 7.065 0 00-.702 3.073c0 2.228 1.044 4.226 2.678 5.59l-2.526 4.127-1.353-1.076 1.735-2.764"
                fill="#c8b100"
            />
            <path
                d="M160.12 187.092c-1.416-1.584-2.283-3.633-2.283-5.873 0-1.352.312-2.643.877-3.795 2.045-4.206 8.46-7.268 16.083-7.268 2.078 0 4.065.226 5.9.644-.407.445-.726.932-1.038 1.423a25.514 25.514 0 00-4.863-.457c-6.98 0-12.818 2.714-14.51 6.38a7.065 7.065 0 00-.702 3.073c0 2.228 1.044 4.226 2.678 5.59l-2.526 4.127-1.353-1.076 1.735-2.764v-.004z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M162.707 173.263c-1.837 1.156-3.226 2.577-3.993 4.162a8.596 8.596 0 00-.877 3.794c0 2.24.867 4.288 2.282 5.872l-1.535 2.49c-1.468-1.887-2.322-4.088-2.322-6.43 0-4.033 2.566-7.557 6.444-9.89"
                fill="#c8b100"
            />
            <path
                d="M162.707 173.263c-1.837 1.156-3.226 2.577-3.993 4.162a8.596 8.596 0 00-.877 3.794c0 2.24.867 4.288 2.282 5.872l-1.535 2.49c-1.468-1.887-2.322-4.088-2.322-6.43 0-4.033 2.566-7.557 6.444-9.89z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M206.037 164.416c1.692 0 3.146 1.12 3.493 2.62.226 1.325.367 2.835.398 4.444.003.167-.01.33-.01.494.004.19.04.396.043.59.06 3.374.54 6.354 1.228 8.178l-5.153 4.93-5.21-4.93c.69-1.824 1.17-4.804 1.234-8.178.003-.194.04-.4.04-.59 0-.164-.01-.327-.007-.494.025-1.61.17-3.12.395-4.445.343-1.5 1.858-2.62 3.546-2.62"
                fill="#c8b100"
            />
            <path
                d="M206.037 164.416c1.692 0 3.146 1.12 3.493 2.62.226 1.325.367 2.835.398 4.444.003.167-.01.33-.01.494.004.19.04.396.043.59.06 3.374.54 6.354 1.228 8.178l-5.153 4.93-5.21-4.93c.69-1.824 1.17-4.804 1.234-8.178.003-.194.04-.4.04-.59 0-.164-.01-.327-.007-.494.025-1.61.17-3.12.395-4.445.343-1.5 1.858-2.62 3.546-2.62h.003z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M206.037 166.022c.88 0 1.62.56 1.8 1.336.213 1.254.35 2.687.378 4.2 0 .157-.008.314-.008.466 0 .188.032.376.036.567.055 3.188.512 5.997 1.167 7.726l-3.4 3.218-3.4-3.218c.65-1.725 1.106-4.538 1.163-7.725.004-.19.037-.378.04-.566 0-.152-.01-.31-.01-.466a28.14 28.14 0 01.38-4.2c.177-.776.98-1.336 1.854-1.336"
                fill="#c8b100"
            />
            <path
                d="M206.037 166.022c.88 0 1.62.56 1.8 1.336.213 1.254.35 2.687.378 4.2 0 .157-.008.314-.008.466 0 .188.032.376.036.567.055 3.188.512 5.997 1.167 7.726l-3.4 3.218-3.4-3.218c.65-1.725 1.106-4.538 1.163-7.725.004-.19.037-.378.04-.566 0-.152-.01-.31-.01-.466a28.14 28.14 0 01.38-4.2c.177-.776.98-1.336 1.854-1.336z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M229.712 183.762l-1.332 1.068-1.997-3.262c2.165-1.327 3.653-3.63 3.653-6.257a7.08 7.08 0 00-.053-.87c-.207-4.164-5.285-7.604-11.718-7.604-3.348 0-6.36.914-8.487 2.38a23.008 23.008 0 00-.206-1.782c2.34-1.365 5.374-2.185 8.693-2.185 7.402 0 13.192 4.204 13.476 9.186.026.29.04.583.04.875 0 2.658-1.21 5.05-3.13 6.714l1.062 1.738"
                fill="#c8b100"
            />
            <path
                d="M229.712 183.762l-1.332 1.068-1.997-3.262c2.165-1.327 3.653-3.63 3.653-6.257a7.08 7.08 0 00-.053-.87c-.207-4.164-5.285-7.604-11.718-7.604-3.348 0-6.36.914-8.487 2.38a23.008 23.008 0 00-.206-1.782c2.34-1.365 5.374-2.185 8.693-2.185 7.402 0 13.192 4.204 13.476 9.186.026.29.04.583.04.875 0 2.658-1.21 5.05-3.13 6.714l1.062 1.738"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M229.626 183.8c2.526-1.886 4.096-4.45 4.096-7.27 0-3.254-2.128-6.154-5.356-8.077 1.99 1.6 3.2 3.67 3.375 5.983.026.29.04.583.04.875 0 2.658-1.21 5.05-3.13 6.714l.976 1.775"
                fill="#c8b100"
            />
            <path
                d="M229.626 183.8c2.526-1.886 4.096-4.45 4.096-7.27 0-3.254-2.128-6.154-5.356-8.077 1.99 1.6 3.2 3.67 3.375 5.983.026.29.04.583.04.875 0 2.658-1.21 5.05-3.13 6.714l.976 1.775"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M251.92 187.092c1.412-1.584 2.278-3.633 2.278-5.873a8.654 8.654 0 00-.873-3.795c-2.05-4.206-8.462-7.268-16.088-7.268-2.077 0-4.063.226-5.9.644.412.445.73.932 1.043 1.423a25.447 25.447 0 014.854-.457c6.98 0 12.822 2.714 14.51 6.38.453.936.703 1.98.703 3.073 0 2.228-1.045 4.226-2.68 5.59l2.528 4.127 1.357-1.076-1.734-2.764"
                fill="#c8b100"
            />
            <path
                d="M251.92 187.092c1.412-1.584 2.278-3.633 2.278-5.873a8.654 8.654 0 00-.873-3.795c-2.05-4.206-8.462-7.268-16.088-7.268-2.077 0-4.063.226-5.9.644.412.445.73.932 1.043 1.423a25.447 25.447 0 014.854-.457c6.98 0 12.822 2.714 14.51 6.38.453.936.703 1.98.703 3.073 0 2.228-1.045 4.226-2.68 5.59l2.528 4.127 1.357-1.076-1.734-2.764.003-.004z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M249.33 173.263c1.835 1.156 3.225 2.577 3.995 4.162a8.7 8.7 0 01.873 3.794c0 2.24-.866 4.288-2.277 5.872l1.53 2.49c1.47-1.887 2.318-4.088 2.318-6.43 0-4.033-2.562-7.557-6.438-9.89"
                fill="#c8b100"
            />
            <path
                d="M249.33 173.263c1.835 1.156 3.225 2.577 3.995 4.162a8.7 8.7 0 01.873 3.794c0 2.24-.866 4.288-2.277 5.872l1.53 2.49c1.47-1.887 2.318-4.088 2.318-6.43 0-4.033-2.562-7.557-6.438-9.89z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M204.206 181.376c0-.955.82-1.724 1.83-1.724 1.007 0 1.827.77 1.827 1.724 0 .958-.82 1.732-1.828 1.732-1.01 0-1.83-.774-1.83-1.732"
                fill="#fff"
            />
            <path
                d="M204.206 181.376c0-.955.82-1.724 1.83-1.724 1.007 0 1.827.77 1.827 1.724 0 .958-.82 1.732-1.828 1.732-1.01 0-1.83-.774-1.83-1.732z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M204.206 177.984c0-.954.82-1.732 1.83-1.732 1.007 0 1.827.778 1.827 1.732 0 .955-.82 1.728-1.828 1.728-1.01 0-1.83-.773-1.83-1.728m.367-3.648c0-.764.656-1.38 1.463-1.38.8 0 1.457.616 1.457 1.38 0 .763-.656 1.38-1.457 1.38-.807 0-1.463-.617-1.463-1.38m.41-3.29c0-.547.473-.994 1.053-.994.582 0 1.05.447 1.05.994 0 .553-.468 1-1.05 1-.58 0-1.053-.447-1.053-1m.21-2.876c0-.444.376-.798.843-.798.463 0 .84.354.84.798 0 .44-.377.798-.84.798-.467 0-.843-.358-.843-.798"
                fill="#fff"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M206.19 191.786l1.187.22c-.19.48-.23 1.004-.23 1.557 0 2.464 2.116 4.47 4.72 4.47 2.093 0 3.875-1.296 4.487-3.086.07.047.45-1.616.648-1.595.165.017.147 1.728.208 1.697.303 2.252 2.362 3.777 4.68 3.777 2.602 0 4.712-1.995 4.712-4.463 0-.184-.01-.368-.036-.546l1.48-1.466.793 1.868c-.316.587-.442 1.246-.442 1.95 0 2.357 2.016 4.262 4.503 4.262 1.566 0 2.94-.753 3.748-1.895l.947-1.204-.007 1.476c0 1.482.626 2.812 2.073 3.046 0 0 1.662.103 3.863-1.625 2.203-1.728 3.416-3.16 3.416-3.16l.19 1.732s-1.83 2.827-3.82 3.98c-1.087.632-2.74 1.297-4.052 1.083-1.39-.226-2.38-1.34-2.89-2.625a6.72 6.72 0 01-3.413.923c-2.692 0-5.112-1.476-6.07-3.698-1.237 1.336-2.962 2.157-4.984 2.157-2.148 0-4.118-.967-5.352-2.454a6.934 6.934 0 01-4.68 1.787c-2.38 0-4.502-1.167-5.705-2.926-1.202 1.758-3.323 2.925-5.7 2.925a6.943 6.943 0 01-4.68-1.787c-1.23 1.487-3.204 2.454-5.353 2.454-2.023 0-3.747-.82-4.987-2.157-.956 2.222-3.374 3.698-6.068 3.698a6.698 6.698 0 01-3.408-.923c-.515 1.284-1.505 2.4-2.89 2.625-1.315.214-2.967-.45-4.056-1.084-1.99-1.15-3.817-3.978-3.817-3.978l.192-1.73s1.213 1.43 3.412 3.16c2.204 1.73 3.863 1.624 3.863 1.624 1.447-.234 2.072-1.564 2.072-3.047l-.007-1.477.947 1.204c.806 1.142 2.186 1.895 3.748 1.895 2.487 0 4.502-1.905 4.502-4.26 0-.706-.127-1.365-.443-1.952l.793-1.868 1.482 1.466a4.442 4.442 0 00-.036.546c0 2.468 2.106 4.463 4.71 4.463 2.322 0 4.377-1.525 4.68-3.778.064.03.047-1.68.21-1.698.197-.02.58 1.642.646 1.595.615 1.79 2.394 3.085 4.493 3.085 2.604 0 4.714-2.005 4.714-4.47 0-.552-.033-1.077-.227-1.557l1.232-.22"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M238.6 197.676c.27-.8.028-1.59-.548-1.764-.576-.18-1.268.324-1.54 1.12-.275.8-.03 1.586.547 1.767.574.172 1.265-.33 1.54-1.124m-20.519-3.973c.105-.835-.294-1.564-.895-1.633-.6-.072-1.177.544-1.285 1.377-.108.83.29 1.565.892 1.637.602.067 1.178-.55 1.287-1.382m-23.827.001c-.107-.835.296-1.564.893-1.633.6-.072 1.177.544 1.286 1.377.104.83-.29 1.565-.892 1.637-.602.067-1.178-.55-1.286-1.382m-20.518 3.975c-.273-.8-.028-1.59.548-1.764.576-.18 1.263.324 1.537 1.12.27.8.025 1.586-.548 1.767-.576.172-1.263-.33-1.537-1.124"
                fill="#fff"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M182.648 183.984c1.02.643 1.908 1.715 2.217 2.912 0 0 .12-.246.68-.57.566-.317 1.044-.308 1.044-.308s-.162.93-.242 1.266c-.082.327-.09 1.326-.305 2.226-.217.9-.61 1.62-.61 1.62a1.9 1.9 0 00-1.51-.4 1.832 1.832 0 00-1.275.862s-.63-.548-1.156-1.322c-.53-.775-.89-1.71-1.09-1.992-.2-.286-.685-1.11-.685-1.11s.447-.168 1.092-.05c.642.12.844.315.844.315-.136-1.23.27-2.516.994-3.45"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M183.08 193.785a1.745 1.745 0 01-.648-1.037c-.08-.42.01-.835.224-1.176 0 0-.85-.43-1.762-.668-.69-.18-1.906-.188-2.274-.194l-1.1-.027s.06.167.268.53c.252.44.476.716.476.716-1.218.28-2.254 1.08-2.91 2.008.952.657 2.216 1.056 3.456.93 0 0-.108.332-.186.832-.065.413-.06.584-.06.584l1.024-.38c.342-.125 1.484-.52 2.07-.916.766-.525 1.422-1.2 1.422-1.2m2.728-.46a1.65 1.65 0 00.235-1.18 1.72 1.72 0 00-.634-1.035s.64-.68 1.406-1.2c.584-.396 1.727-.795 2.07-.917.342-.126 1.026-.382 1.026-.382s.003.174-.062.587a5.742 5.742 0 01-.187.828c1.243-.13 2.508.286 3.46.948-.655.923-1.7 1.71-2.912 1.99a6.44 6.44 0 00.745 1.248s-.734-.017-1.1-.023c-.368-.006-1.584-.01-2.275-.194-.91-.243-1.772-.665-1.772-.665"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M182.19 192.43c0-1.09.933-1.973 2.08-1.973 1.146 0 2.082.883 2.082 1.974 0 1.09-.932 1.97-2.08 1.97-1.15 0-2.08-.88-2.08-1.97"
                fill="#ad1519"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M206.11 180.83c1 .908 1.77 2.263 1.87 3.658 0 0 .178-.252.873-.504.694-.252 1.227-.154 1.227-.154s-.37 1.013-.533 1.366c-.16.356-.37 1.467-.803 2.425a8.232 8.232 0 01-1.007 1.692 2.13 2.13 0 00-1.606-.72c-.644 0-1.22.284-1.6.72 0 0-.587-.726-1.012-1.69-.43-.96-.64-2.07-.8-2.426-.16-.353-.536-1.366-.536-1.366s.537-.1 1.228.154c.694.252.878.504.878.504.097-1.395.825-2.75 1.82-3.658"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M204.558 191.838a1.916 1.916 0 01-.507-1.275c0-.48.185-.93.494-1.268 0 0-.857-.642-1.82-1.077-.732-.334-2.09-.566-2.496-.642l-1.224-.23s.033.193.19.64c.192.542.383.89.383.89-1.41.085-2.74.786-3.662 1.697.922.903 2.247 1.588 3.662 1.68 0 0-.19.345-.382.89-.158.44-.19.638-.19.638s.813-.15 1.223-.224c.407-.082 1.764-.31 2.495-.648.964-.437 1.835-1.066 1.835-1.066m3.134-.005c.31-.345.507-.79.507-1.275 0-.48-.182-.93-.492-1.268 0 0 .857-.642 1.822-1.077.733-.334 2.09-.566 2.497-.642l1.216-.23s-.028.193-.19.64c-.192.542-.378.89-.378.89 1.41.085 2.74.786 3.657 1.697-.918.903-2.243 1.588-3.657 1.68 0 0 .186.345.378.89.16.44.19.638.19.638l-1.216-.224c-.407-.082-1.764-.31-2.497-.648-.965-.437-1.837-1.066-1.837-1.066m21.989-7.859c-1.014.643-1.902 1.715-2.213 2.912 0 0-.124-.246-.684-.57-.562-.317-1.046-.308-1.046-.308s.163.93.246 1.266c.084.327.087 1.326.302 2.226.217.9.607 1.62.607 1.62a1.91 1.91 0 011.513-.4c.56.096 1.016.426 1.278.862 0 0 .627-.548 1.157-1.322.524-.775.888-1.71 1.082-1.992.2-.286.688-1.11.688-1.11s-.45-.168-1.094-.05c-.645.12-.848.315-.848.315.144-1.23-.266-2.516-.99-3.45"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M229.254 193.785c.322-.257.57-.615.644-1.037a1.64 1.64 0 00-.22-1.176s.847-.43 1.757-.668c.692-.18 1.913-.188 2.274-.194l1.102-.027s-.058.167-.27.53a6.2 6.2 0 01-.474.716c1.215.28 2.252 1.08 2.907 2.008-.946.657-2.21 1.056-3.455.93 0 0 .112.332.188.832.06.413.056.584.056.584s-.683-.253-1.02-.38c-.343-.125-1.485-.52-2.072-.916-.762-.525-1.418-1.2-1.418-1.2m-2.73-.46a1.674 1.674 0 01-.235-1.18c.08-.422.314-.78.637-1.035 0 0-.644-.68-1.41-1.2-.584-.396-1.73-.795-2.07-.917a171.41 171.41 0 01-1.022-.382s-.003.174.06.587c.077.498.185.828.185.828-1.243-.13-2.51.286-3.456.948.655.923 1.696 1.71 2.908 1.99 0 0-.22.276-.472.716-.21.37-.27.532-.27.532s.73-.017 1.1-.023c.362-.006 1.586-.01 2.273-.194a11.117 11.117 0 001.77-.665"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M225.98 192.43c0-1.09.93-1.973 2.08-1.973 1.152 0 2.084.883 2.084 1.974 0 1.09-.932 1.97-2.084 1.97-1.15 0-2.08-.88-2.08-1.97m23.27 4.377c-.49-.518-1.505-.41-2.264.24-.76.643-.98 1.59-.49 2.105.49.518 1.505.406 2.263-.238.76-.65.98-1.596.49-2.107"
                fill="#ad1519"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M246.295 198.062c.105-.354.342-.716.69-1.015.76-.648 1.774-.757 2.265-.24.06.07.13.16.17.243 0 0 1.054-2 2.303-2.665 1.25-.672 3.363-.502 3.363-.502 0-1.535-1.257-2.774-2.877-2.774-.952 0-1.85.394-2.38 1.062l-.22-1.03s-1.303.26-1.9 1.75c-.594 1.493.053 3.65.053 3.65s-.324-.927-.812-1.545c-.486-.612-1.735-1.284-2.386-1.59-.652-.304-1.318-.76-1.318-.76s-.03.166-.054.58a4.91 4.91 0 00.015.796c-1.195-.157-2.59.038-3.675.46.464.913 1.35 1.773 2.508 2.212 0 0-.417.345-.8.723a3.94 3.94 0 00-.416.47s.817.117 1.228.174c.405.055 1.762.27 2.573.215a14.513 14.513 0 001.67-.215m-80.259.001c-.104-.354-.34-.716-.69-1.015-.76-.648-1.772-.757-2.266-.24-.064.07-.13.16-.17.243 0 0-1.058-2-2.306-2.665-1.245-.672-3.358-.502-3.358-.502 0-1.535 1.257-2.774 2.876-2.774.954 0 1.847.394 2.382 1.062l.217-1.03s1.304.26 1.9 1.75c.597 1.493-.053 3.65-.053 3.65s.324-.927.814-1.545c.49-.612 1.74-1.284 2.39-1.59.65-.304 1.318-.76 1.318-.76s.025.166.05.58c.027.492-.014.796-.014.796 1.192-.157 2.59.038 3.676.46-.465.913-1.348 1.773-2.51 2.212 0 0 .418.345.8.723.317.32.42.47.42.47l-1.226.174c-.412.055-1.764.27-2.575.215a14.658 14.658 0 01-1.674-.215"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M163.08 196.808c.494-.518 1.506-.41 2.265.24.763.643.978 1.59.49 2.105-.49.518-1.506.406-2.264-.238-.76-.65-.978-1.596-.49-2.107m40.969-6.245c0-1.09.932-1.97 2.08-1.97 1.15 0 2.085.88 2.085 1.97 0 1.09-.93 1.974-2.084 1.974-1.148 0-2.08-.884-2.08-1.974"
                fill="#ad1519"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M201.8 160.61c0-2.23 1.906-4.03 4.252-4.03 2.347 0 4.25 1.8 4.25 4.03 0 2.22-1.903 4.02-4.25 4.02-2.346 0-4.252-1.8-4.252-4.02"
                fill="#005bbf"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M204.938 149.316v2.174h-2.326v2.205h2.326v6.345h-2.93c-.034.206-.21.357-.21.573 0 .556.115 1.09.33 1.57.007.014.025.018.03.03h7.794c.006-.012.025-.016.03-.03.216-.48.333-1.014.333-1.57 0-.215-.177-.368-.21-.574h-2.84v-6.344h2.325v-2.206h-2.326v-2.174h-2.326z"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M206.473 330.56c-12.558 0-25.006-3.078-35.47-8.2-7.713-3.82-12.828-11.524-12.828-20.34v-31.968h96.406v31.97c0 8.814-5.113 16.518-12.83 20.34-10.462 5.12-22.715 8.198-35.277 8.198"
                fill="#ccc"
            />
            <path
                d="M206.473 330.56c-12.558 0-25.006-3.078-35.47-8.2-7.713-3.82-12.828-11.524-12.828-20.34v-31.968h96.406v31.97c0 8.814-5.113 16.518-12.83 20.34-10.462 5.12-22.715 8.198-35.277 8.198z"
                fill="none"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path d="M206.268 269.997h48.31v-53.485h-48.31v53.485z" fill="#ccc" />
            <path d="M206.268 269.997h48.31v-53.485h-48.31v53.485z" fill="none" stroke="#000" strokeWidth={0.499} />
            <path
                d="M206.304 301.983c0 12.634-10.706 22.874-24.04 22.874-13.34 0-24.154-10.24-24.154-22.874v-32.017h48.194v32.017"
                fill="#ad1519"
            />
            <path
                d="M168.64 320.86c1.505.8 3.573 2.13 5.783 2.663l-.14-54.685h-5.644v52.022z"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M158.03 301.552c.148 6.747 2.826 11.762 5.504 15.047v-47.496H158.1l-.07 32.448z"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.48}
                strokeLinejoin="round"
            />
            <path
                d="M179.384 324.722a26.58 26.58 0 005.644 0v-55.884h-5.644v55.884z"
                fill="#c7b500"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M189.99 323.523c2.21-.444 4.7-1.82 5.785-2.53v-52.155h-5.644l-.14 54.685z"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path d="M158.113 269.997h48.172v-53.485h-48.172v53.485z" fill="#ad1519" />
            <path d="M158.113 269.997h48.172v-53.485h-48.172v53.485z" fill="none" stroke="#000" strokeWidth={0.499} />
            <path
                d="M201.02 316.067c2.35-2.087 4.56-6.837 5.363-12.25l.14-34.98h-5.644l.14 47.23z"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M206.304 301.983c0 12.634-10.706 22.874-24.04 22.874-13.34 0-24.154-10.24-24.154-22.874v-32.017h48.194v32.017"
                fill="none"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M254.624 269.966v32.017c0 12.634-10.827 22.874-24.167 22.874-13.336 0-24.153-10.24-24.153-22.874v-32.017h48.32"
                fill="#ad1519"
            />
            <path
                d="M254.624 269.966v32.017c0 12.634-10.827 22.874-24.167 22.874-13.336 0-24.153-10.24-24.153-22.874v-32.017h48.32"
                fill="none"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M215.093 294.132c.077.164.12.328.12.502 0 .59-.5 1.06-1.124 1.06-.62 0-1.123-.47-1.123-1.06 0-.174.043-.338.122-.48l-1.57-.022c-.033.16-.052.328-.052.502 0 1.11.768 2.052 1.828 2.37l-.002 3.85 1.645.01.002-3.878a2.56 2.56 0 001.63-1.55h4.418v-1.303h-5.897m21.677 0v1.302l-3.973.01a2.55 2.55 0 01-.256.487l4.616 5.243-1.238 1.003-4.593-5.25c-.085.027-.127.06-.216.085l-.013 8.675h-1.626l-.003-8.713c-.07-.016-.127-.05-.19-.08l-4.782 5.283-1.238-1.003 4.778-5.304a2.13 2.13 0 01-.2-.435h-4.106v-1.302h13.044-.004zm2.647 0v1.302h4.422c.262.73.857 1.302 1.627 1.55l.003 3.88 1.642-.01-.004-3.852c1.062-.317 1.833-1.26 1.833-2.37 0-.173-.017-.34-.058-.5h-1.562c.076.163.116.327.116.5 0 .59-.497 1.06-1.12 1.06-.618 0-1.123-.47-1.123-1.06a.98.98 0 01.123-.48l-5.9-.02m-6.678 22.12c1.29-.205 2.478-.56 3.65-1.053l.807 1.373a17.6 17.6 0 01-4.32 1.223c-.252 1.122-1.3 1.964-2.558 1.964-1.257 0-2.305-.832-2.564-1.945a17.522 17.522 0 01-4.542-1.242l.81-1.373c1.236.52 2.553.868 3.92 1.058.29-.625.818-1.11 1.513-1.335l.014-6.726h1.623l.015 6.702c.72.214 1.328.705 1.63 1.352h.003zm-11.033-2.257l-.8 1.38a16.654 16.654 0 01-3.647-3.085c-.835.247-1.78.1-2.49-.48-1.103-.893-1.237-2.46-.293-3.5l.137-.146a15.272 15.272 0 01-1.267-4.804l1.642.007a13.127 13.127 0 001.05 4.105c.46-.065.954-.01 1.397.153l4.106-4.544 1.238 1-4.08 4.537c.55.838.528 1.92-.102 2.744a15.172 15.172 0 003.11 2.636zm-6.09-4.766c.405-.45 1.113-.5 1.584-.12.472.382.53 1.057.126 1.5a1.167 1.167 0 01-1.584.12 1.026 1.026 0 01-.127-1.5zm-2.07-4.493l-1.687-.378-.238-4.276 1.674-.553.002 2.453c0 .95.085 1.85.25 2.754zm1.4-5.3l1.682.395s.087 2.747.05 2.13c-.043-.72.184 2.15.184 2.15l-1.694.557c-.17-.873-.226-1.767-.226-2.687l.003-2.547h.004zm5.543 13.676a15.667 15.667 0 004.84 2.57l.374-1.626a13.696 13.696 0 01-4.007-2.01l-1.207 1.066m-.813 1.404a17.4 17.4 0 004.84 2.547l-1.258 1.176a18.707 18.707 0 01-3.955-2.03l.373-1.693m2.194-9.42l1.604.68 2.937-3.26-.964-1.386-3.577 3.966m-1.246-1.006l-.963-1.394 2.94-3.26 1.6.685-3.576 3.97m18.08 9.906l.802 1.38a16.698 16.698 0 003.646-3.085c.83.247 1.78.1 2.49-.48 1.102-.893 1.23-2.46.29-3.5l-.138-.146a15.04 15.04 0 001.263-4.804l-1.633.007a13.268 13.268 0 01-1.052 4.105 2.916 2.916 0 00-1.4.153l-4.103-4.544-1.24 1 4.08 4.537a2.36 2.36 0 00.1 2.744 15.085 15.085 0 01-3.107 2.636zm6.086-4.766a1.16 1.16 0 00-1.58-.12 1.025 1.025 0 00-.126 1.5 1.167 1.167 0 001.584.12 1.024 1.024 0 00.122-1.5zm2.07-4.493l1.688-.378.238-4.276-1.67-.553-.004 2.453c0 .95-.084 1.85-.252 2.754zm-1.396-5.3l-1.68.395s-.092 2.747-.055 2.13c.045-.72-.185 2.15-.185 2.15l1.695.557c.17-.873.227-1.767.227-2.687l-.003-2.547m-5.544 13.677a15.722 15.722 0 01-4.838 2.57l-.374-1.626a13.674 13.674 0 004.003-2.01l1.21 1.066m.814 1.404a17.453 17.453 0 01-4.84 2.547l1.258 1.176c1.41-.52 2.74-1.21 3.956-2.03l-.374-1.693m-2.193-9.42l-1.604.68-2.938-3.26.965-1.386 3.578 3.966m1.245-1.006l.963-1.394-2.938-3.26-1.6.685 3.575 3.97m-20.105-8.652l.493 1.6h4.525l.487-1.6h-5.505m21.135 0l-.496 1.6h-4.523l-.487-1.6h5.505m-11.62 21.837c0-.59.502-1.066 1.122-1.066.618 0 1.118.475 1.118 1.065 0 .587-.5 1.06-1.118 1.06-.62 0-1.123-.473-1.123-1.06zm1.902-7.752l1.69-.473v-4.28l-1.69-.462v5.215m-1.637 0l-1.684-.473v-4.28l1.684-.462v5.215"
                fill="#c8b100"
            />
            <path
                d="M211.52 294.17c.194-.892.89-1.616 1.79-1.886l-.014-5.282h1.63l.002 5.31c.804.253 1.422.847 1.67 1.612l4.392.007v.24h-5.897a1.16 1.16 0 00-1.004-.566c-.436 0-.818.242-1 .586l-1.57-.02m12.206 0v-.24h4.08a2.37 2.37 0 01.174-.385l-5.032-5.608 1.237-1.004 4.97 5.517c.085-.042.176-.08.264-.11l.004-7.35h1.627v7.304c.074.02.184.042.257.063l4.853-5.526 1.247.99-4.872 5.503c.126.185.21.39.28.608h3.952v.24h-13.045.004zm21.59 0a1.153 1.153 0 011-.566c.44 0 .818.242 1.004.586l1.562-.02c-.194-.892-.885-1.616-1.784-1.886l.01-5.28h-1.624l-.007 5.31c-.8.254-1.418.845-1.667 1.61l-4.393.007v.24h5.9m-30.13-14.918l6.054 6.786 1.24-1.004-6.086-6.76c.12-.18.207-.378.28-.59h4.428v-1.544h-4.43c-.34-1-1.333-1.718-2.502-1.718-1.448 0-2.625 1.114-2.625 2.488 0 1.088.736 2.018 1.766 2.353l-.01 5.235h1.628v-5.2c.07-.02.193-.02.26-.046zm31.94.035l-.015 5.21h-1.628v-5.23a2.452 2.452 0 01-.364-.15l-6.02 6.796-1.245-.99 6.135-6.93c-.05-.096-.104-.2-.14-.31h-4.452v-1.543h4.438c.342-1 1.325-1.718 2.49-1.718 1.447 0 2.625 1.114 2.625 2.488 0 1.116-.76 2.058-1.824 2.377zm-16.06-.02l-.013 3.21h-1.626l.004-3.184a2.57 2.57 0 01-1.715-1.61h-3.97v-1.543h3.97c.343-1 1.32-1.718 2.488-1.718 1.166 0 2.152.717 2.495 1.718h4.05v1.543h-4.06a2.528 2.528 0 01-1.62 1.583zm-17.75 3.895l-1.69.475v4.29l1.69.465v-5.23m1.637 0l1.684.475v4.29l-1.684.465v-5.23m30.515 0l-1.684.475v4.29l1.683.465v-5.23m1.638 0l1.69.475v4.29l-1.69.465v-5.23m-25.547.847l1.608-.683 2.937 3.265-.965 1.393-3.58-3.976m-1.243 1.01l-.96 1.398 2.936 3.262 1.6-.687-3.576-3.972m18.444-1.137l-1.608-.67-2.91 3.29.976 1.383 3.543-4.003m1.254 1l.974 1.388-2.908 3.29-1.605-.673 3.54-4.003m-20.335 9.044l.493-1.602h4.525l.488 1.602h-5.506m-6.634-17.016c0-.587.503-1.066 1.124-1.066.618 0 1.12.48 1.12 1.066 0 .588-.502 1.062-1.12 1.062-.62 0-1.124-.474-1.124-1.062zm12.1.775l-.495 1.606h-4.52l-.49-1.606h5.507m0-1.555l-.496-1.6h-4.52l-.49 1.6h5.507m15.668 17.796l-.496-1.602h-4.523l-.487 1.602h5.505m4.39-17.016c0-.587.5-1.066 1.122-1.066.62 0 1.12.48 1.12 1.066 0 .588-.5 1.062-1.12 1.062-.622 0-1.123-.474-1.123-1.062zm-16.123 0c0-.587.504-1.066 1.122-1.066.62 0 1.12.48 1.12 1.066 0 .588-.5 1.062-1.12 1.062-.618 0-1.122-.474-1.122-1.062zm6.266.775l.497 1.606h4.52l.49-1.606h-5.507m0-1.555l.497-1.6h4.52l.49 1.6h-5.507m-5.906 5.012l-1.685.474v4.29l1.685.465v-5.23m1.62 0l1.684.475v4.29l-1.684.465v-5.23"
                fill="#c8b100"
            />
            <path
                d="M232.738 316.252c1.29-.204 2.478-.56 3.65-1.052l.807 1.373a17.6 17.6 0 01-4.32 1.223c-.252 1.122-1.3 1.964-2.558 1.964-1.257 0-2.305-.832-2.564-1.945a17.522 17.522 0 01-4.542-1.242l.81-1.373c1.236.52 2.553.868 3.92 1.06.29-.627.818-1.11 1.513-1.337l.014-6.726h1.623l.015 6.702c.72.214 1.328.705 1.63 1.352h.003zm-4.707-20.378a2.282 2.282 0 01-.198-.44h-4.107v-1.54h4.08a2.6 2.6 0 01.178-.383l-5.035-5.6 1.237-1.002 4.973 5.506a2.16 2.16 0 01.266-.108l.004-7.337h1.622v7.29c.073.02.184.042.257.066l4.853-5.52 1.247.992-4.872 5.49c.125.183.21.388.28.605h3.952v1.54l-3.974.012c-.058.174-.16.334-.252.487l4.616 5.247-1.238 1-4.593-5.252c-.085.03-.127.064-.22.088l-.01 8.676h-1.628l-.005-8.713c-.068-.02-.124-.056-.19-.086l-4.78 5.287-1.237-1 4.776-5.306m-12.842-16.632l6.053 6.774 1.24-1.002-6.086-6.747c.12-.18.207-.378.28-.59h4.428v-1.54h-4.43c-.34-1-1.333-1.715-2.502-1.715-1.448 0-2.625 1.112-2.625 2.482 0 1.087.736 2.014 1.766 2.348l-.01 5.227h1.628v-5.193c.07-.02.193-.02.26-.045zm6.517 34.754l-.8 1.38a16.654 16.654 0 01-3.647-3.085c-.835.247-1.78.1-2.49-.48-1.103-.893-1.237-2.46-.293-3.5l.137-.146a15.272 15.272 0 01-1.267-4.804l1.642.007a13.127 13.127 0 001.05 4.105c.46-.065.954-.01 1.397.154l4.106-4.545 1.238 1-4.08 4.537c.55.838.528 1.92-.102 2.744a15.172 15.172 0 003.11 2.636zm-8.41-13.14v-3.853c-1.06-.314-1.83-1.26-1.83-2.37 0-1.108.782-2.062 1.844-2.383l-.014-5.27h1.63l.002 5.3c.804.253 1.422.843 1.67 1.607l4.392.007v1.54h-4.42a2.56 2.56 0 01-1.627 1.552l-.003 3.88-1.646-.01m2.32 8.374c.406-.45 1.114-.5 1.585-.12.472.382.53 1.057.126 1.5a1.167 1.167 0 01-1.584.12 1.026 1.026 0 01-.127-1.5zm-2.068-4.493l-1.688-.378-.238-4.276 1.674-.553.002 2.453c0 .95.085 1.85.25 2.754zm1.4-5.3l1.68.395s.088 2.747.052 2.13c-.044-.72.184 2.15.184 2.15l-1.696.557c-.17-.873-.226-1.767-.226-2.687l.003-2.547h.004zm5.542 13.676a15.667 15.667 0 004.84 2.57l.374-1.626a13.696 13.696 0 01-4.007-2.01l-1.207 1.066m-.813 1.404a17.4 17.4 0 004.84 2.547l-1.258 1.176a18.707 18.707 0 01-3.955-2.03l.373-1.693"
                fill="none"
                stroke="#c8b100"
                strokeWidth={0.25}
            />
            <path
                d="M221.87 305.096l1.604.68 2.937-3.258-.964-1.387-3.577 3.966m-1.246-1.006l-.963-1.394 2.94-3.26 1.6.685-3.576 3.97m-7.657-9.456c0-.59.503-1.067 1.122-1.067.62 0 1.12.476 1.12 1.067 0 .59-.5 1.06-1.12 1.06-.62 0-1.123-.47-1.123-1.06zm25.736 19.362l.803 1.38a16.698 16.698 0 003.646-3.085c.83.247 1.78.1 2.49-.48 1.102-.893 1.23-2.46.29-3.5l-.138-.146a15.04 15.04 0 001.263-4.804l-1.633.007a13.268 13.268 0 01-1.052 4.105 2.916 2.916 0 00-1.4.154l-4.103-4.545-1.24 1 4.08 4.537a2.36 2.36 0 00.1 2.744 15.085 15.085 0 01-3.107 2.636zm8.413-13.14l-.004-3.853c1.062-.314 1.832-1.26 1.832-2.37 0-1.108-.78-2.062-1.843-2.383l.012-5.27h-1.628l-.007 5.3c-.8.253-1.418.843-1.667 1.607l-4.394.007v1.54h4.423c.262.73.856 1.303 1.626 1.552l.003 3.88 1.642-.01h.004zm-2.326 8.374a1.16 1.16 0 00-1.58-.12 1.025 1.025 0 00-.126 1.5 1.167 1.167 0 001.584.12 1.024 1.024 0 00.122-1.5zm2.07-4.493l1.688-.378.238-4.276-1.67-.552-.004 2.45c0 .952-.084 1.852-.252 2.755zm-1.396-5.3l-1.68.395s-.092 2.748-.055 2.13c.045-.72-.185 2.15-.185 2.15l1.695.557c.17-.873.227-1.767.227-2.687l-.003-2.547m1.662-20.16l-.014 5.203h-1.628v-5.225a2.248 2.248 0 01-.364-.147l-6.02 6.782-1.245-.99 6.135-6.913c-.05-.098-.104-.2-.14-.31h-4.452v-1.54h4.438c.342-1 1.325-1.715 2.49-1.715 1.447 0 2.625 1.11 2.625 2.482 0 1.115-.76 2.055-1.824 2.372zm-16.058-.02l-.014 3.204h-1.626l.004-3.177a2.568 2.568 0 01-1.715-1.606h-3.97v-1.54h3.97c.343-1 1.32-1.715 2.487-1.715s2.153.716 2.496 1.714h4.05v1.54h-4.06a2.523 2.523 0 01-1.622 1.58zm8.852 33.857a15.722 15.722 0 01-4.838 2.57l-.374-1.626a13.674 13.674 0 004.003-2.01l1.21 1.066m.814 1.404a17.453 17.453 0 01-4.84 2.547l1.258 1.176c1.41-.52 2.74-1.21 3.956-2.028l-.374-1.695m-27.418-31.372l-1.688.475v4.28l1.688.464v-5.22m1.638 0l1.684.476v4.28l-1.684.464v-5.22m30.515 0l-1.685.476v4.28l1.684.464v-5.22"
                fill="none"
                stroke="#c8b100"
                strokeWidth={0.25}
            />
            <path
                d="M247.108 283.145l1.69.475v4.28l-1.69.464v-5.22m-8.567 21.952l-1.604.68-2.938-3.258.965-1.387 3.578 3.966m1.245-1.006l.963-1.394-2.937-3.26-1.6.685 3.575 3.97m-18.224-20.1l1.608-.682 2.937 3.26-.965 1.39-3.58-3.968m-1.243 1.01l-.96 1.394 2.936 3.256 1.6-.685-3.576-3.966m18.444-1.136l-1.608-.667-2.91 3.282.977 1.38 3.54-3.996m1.254 1l.974 1.383-2.908 3.283-1.605-.672 3.54-3.995m-20.335 9.028l.493-1.6h4.525l.488 1.6h-5.506m0 1.548l.493 1.6h4.525l.488-1.6h-5.506m-6.634-18.53c0-.586.503-1.064 1.124-1.064.618 0 1.12.478 1.12 1.063 0 .587-.502 1.06-1.12 1.06-.62 0-1.124-.473-1.124-1.06zm12.1.773l-.495 1.603h-4.52l-.49-1.602h5.507m0-1.55l-.496-1.6h-4.52l-.49 1.6h5.507m20.046 18.504c0-.59.505-1.067 1.123-1.067.623 0 1.12.476 1.12 1.067 0 .59-.497 1.06-1.12 1.06-.618 0-1.123-.47-1.123-1.06zm-4.378-.743l-.496-1.6h-4.523l-.487 1.6h5.505m0 1.548l-.496 1.6h-4.523l-.487-1.6h5.505m-11.62 21.837c0-.59.502-1.066 1.122-1.066.618 0 1.118.475 1.118 1.065 0 .587-.5 1.06-1.118 1.06-.62 0-1.123-.473-1.123-1.06zm1.902-7.752l1.69-.473v-4.28l-1.69-.462v5.215m-1.637 0l-1.684-.473v-4.28l1.684-.462v5.215m15.744-32.616c0-.585.5-1.063 1.123-1.063.62 0 1.12.478 1.12 1.063 0 .587-.5 1.06-1.12 1.06-.622 0-1.123-.473-1.123-1.06zm-16.122 0c0-.585.504-1.063 1.122-1.063.62 0 1.12.478 1.12 1.063 0 .587-.5 1.06-1.12 1.06-.618 0-1.122-.473-1.122-1.06zm6.266.774l.497 1.603h4.52l.49-1.602h-5.507m0-1.55l.497-1.6h4.52l.49 1.6h-5.507m-5.91 4.994l-1.685.474v4.282l1.685.464v-5.22m1.62 0l1.684.474v4.282l-1.684.464v-5.22"
                fill="none"
                stroke="#c8b100"
                strokeWidth={0.25}
            />
            <path
                d="M227.688 294.66c0-1.376 1.178-2.49 2.63-2.49 1.446 0 2.622 1.114 2.622 2.49 0 1.37-1.176 2.482-2.623 2.482-1.45 0-2.63-1.11-2.63-2.482"
                fill="#058e6e"
            />
            <path
                d="M230.892 229.69l.054-.593.082-.33s-1.546.126-2.36-.103c-.814-.23-1.548-.566-2.308-1.206-.76-.646-1.058-1.048-1.602-1.128-1.302-.21-2.306.382-2.306.382s.98.36 1.713 1.257c.73.903 1.527 1.36 1.87 1.468.57.174 2.55.05 3.093.072.544.027 1.764.183 1.764.183"
                fill="#db4446"
            />
            <path
                d="M230.892 229.69l.054-.593.082-.33s-1.546.126-2.36-.103c-.814-.23-1.548-.566-2.308-1.206-.76-.646-1.058-1.048-1.602-1.128-1.302-.21-2.306.382-2.306.382s.98.36 1.713 1.257c.73.903 1.527 1.36 1.87 1.468.57.174 2.55.05 3.093.072.544.027 1.764.183 1.764.183v-.003z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M238.124 227.515s.004.692.07 1.354c.067.633-.203 1.188-.1 1.54.1.355.15.634.29.89.128.255.2.903.2.903s-.37-.263-.713-.52c-.337-.258-.58-.418-.58-.418s.07.692.102.99c.037.295.21.854.49 1.185.278.324.833.856 1.004 1.282.177.43.142 1.378.142 1.378s-.45-.72-.837-.85c-.38-.133-1.215-.596-1.215-.596s.766.76.766 1.483c0 .722-.31 1.544-.31 1.544s-.347-.654-.796-1.083c-.454-.426-1.08-.856-1.08-.856s.49 1.12.49 1.872c0 .76-.137 2.373-.137 2.373s-.382-.623-.764-.927c-.384-.293-.835-.556-.976-.75-.136-.197.455.62.52 1.114.067.495.3 2.257 1.842 4.507.9 1.315 2.292 3.616 5.276 2.86 2.988-.754 1.88-4.77 1.253-6.645-.628-1.87-.94-3.948-.905-4.673.033-.72.554-2.856.486-3.256-.068-.39-.23-1.92.14-3.15.383-1.28.7-1.778.905-2.307.204-.526.377-.823.446-1.283.07-.46.07-1.32.07-1.32s.554 1.023.694 1.384c.138.366.138 1.447.138 1.447s.103-1.08.94-1.606c.835-.53 1.805-1.087 2.05-1.383.242-.3.313-.494.313-.494s-.07 1.845-.59 2.57c-.345.47-1.705 2.005-1.705 2.005s.698-.266 1.182-.293c.487-.037.833 0 .833 0s-.59.46-1.354 1.578c-.762 1.115-.45 1.214-1.006 2.134-.56.92-1.01.955-1.704 1.514-1.043.84-.48 4.172-.345 4.668.14.49 1.944 4.573 1.98 5.56.032.988.21 3.19-1.53 4.604-1.12.918-2.95.925-3.37 1.187-.418.258-1.245 1.08-1.245 2.79 0 1.716.62 1.975 1.106 2.404.49.43 1.113.198 1.252.53.14.326.21.523.418.72.21.195.35.427.278.785-.068.364-.868 1.186-1.146 1.782-.28.586-.835 2.137-.835 2.366 0 .232-.065.955.173 1.32 0 0 .868 1.012.277 1.21-.382.13-.755-.24-.936-.198-.518.137-.79.456-.938.43-.348-.066-.348-.236-.383-.723-.032-.492-.015-.692-.17-.692-.21 0-.313.17-.35.43-.036.262-.036.85-.276.85-.243 0-.59-.425-.798-.52-.21-.1-.8-.198-.832-.46-.036-.263.346-.822.727-.922.382-.098.73-.292.486-.49s-.486-.198-.727 0c-.244.198-.763.03-.73-.265.035-.297.104-.656.067-.822-.032-.16-.45-.49.102-.792.558-.293.798.267 1.353.167.558-.093.836-.298 1.044-.622.21-.327.173-1.02-.208-1.445-.383-.43-.764-.498-.905-.76-.14-.263-.345-.887-.345-.887s.1 1.15.03 1.316c-.066.164-.03.852-.03.852s-.382-.427-.695-.753c-.31-.33-.623-1.314-.623-1.314s-.033.92-.033 1.284c0 .357.414.69.277.822-.14.13-.796-.692-.97-.822-.177-.132-.73-.558-.976-1.022-.24-.46-.418-1.115-.485-1.35-.07-.23-.185-1.255-.07-1.514.172-.392.45-1.085.45-1.085h-1.354c-.727 0-1.25-.228-1.526.262-.277.495-.14 1.484.206 2.765.35 1.278.553 1.906.453 2.137-.102.23-.555.758-.727.853-.178.102-.664.068-.873-.027-.205-.1-.55-.267-1.213-.267-.658 0-1.076.03-1.317-.027-.243-.067-.835-.365-1.116-.3-.278.068-.757.313-.626.693.212.59-.205.724-.486.69-.277-.034-.514-.133-.868-.23-.344-.1-.867 0-.797-.397.067-.396.208-.426.38-.72.175-.3.24-.49.046-.51-.244-.025-.49-.052-.68.105-.183.153-.482.485-.727.362-.245-.13-.435-.413-.435-1.034 0-.616-.65-1.155-.053-1.128.597.028 1.357.465 1.494.13.134-.337.05-.487-.272-.75-.326-.256-.732-.41-.297-.743.434-.332.542-.332.708-.515.162-.177.394-.756.7-.613.595.283.027.695.624 1.36.598.667.976.903 1.98.797 1.003-.102 1.278-.232 1.278-.515 0-.284-.084-.795-.112-1.003-.025-.204.138-.95.138-.95s-.462.285-.598.564c-.13.284-.404.77-.404.77s-.11-.577-.08-1.048c.02-.276.117-.757.107-.852-.026-.255-.216-.9-.216-.9s-.164.696-.27.9c-.11.205-.162 1.03-.162 1.03s-.638-.556-.46-1.49c.132-.72-.11-1.67.106-1.98.213-.31.728-1.57 1.978-1.623 1.248-.047 2.223.054 2.66.03.434-.03 1.98-.31 1.98-.31s-2.85-1.462-3.5-1.902c-.65-.433-1.656-1.564-1.983-2.08-.325-.514-.623-1.513-.623-1.513s-.512.023-.975.28a4.92 4.92 0 00-1.192.947c-.274.31-.705 1.005-.705 1.005s.078-.9.078-1.183c0-.276-.053-.824-.053-.824s-.325 1.233-.976 1.693c-.652.468-1.41 1.11-1.41 1.11s.082-.69.082-.846c0-.153.16-.95.16-.95s-.46.687-1.166.824c-.705.126-1.738.1-1.82.54-.08.43.19 1.024.028 1.33-.163.31-.514.516-.514.516s-.407-.338-.76-.362c-.353-.027-.68.157-.68.157s-.3-.39-.19-.645c.11-.256.65-.64.517-.797-.136-.154-.57.054-.842.18-.27.13-.842.256-.788-.18.055-.437.19-.692.055-1.003-.136-.303-.055-.51.165-.59.215-.07 1.083.024 1.165-.173.08-.208-.216-.464-.788-.594-.57-.126-.842-.463-.542-.746.298-.283.38-.358.515-.616.135-.26.19-.72.707-.49.51.23.403.796.95.976.538.184 1.815-.074 2.084-.228.275-.157 1.142-.798 1.44-.954.3-.15 1.545-1.077 1.545-1.077s-.73-.51-1.003-.77c-.27-.257-.756-.87-.997-1-.246-.133-1.44-.59-1.847-.617-.407-.027-1.656-.46-1.656-.46s.57-.184.76-.338c.19-.153.62-.542.84-.514.215.028.267.028.267.028s-1.16-.056-1.407-.127c-.244-.083-.95-.52-1.218-.52-.276 0-.815.107-.815.107s.73-.463 1.327-.565c.597-.1 1.06-.08 1.06-.08s-.922-.255-1.142-.562c-.216-.31-.43-.767-.598-.975-.162-.204-.27-.54-.57-.565-.297-.027-.814.36-1.11.334-.296-.024-.516-.21-.546-.643-.02-.438 0-.286-.102-.514-.11-.234-.544-.774-.138-.9.41-.13 1.278.076 1.357-.078.083-.154-.46-.617-.812-.797-.353-.18-.922-.49-.623-.744.3-.256.596-.357.76-.59.162-.23.352-.872.706-.67.352.207.84 1.212 1.112 1.134.274-.08.294-.798.244-1.104-.055-.31 0-.85.266-.8.274.052.49.41.925.44.432.025 1.084-.1 1.03.203-.054.307-.3.688-.598 1.026-.29.337-.428 1.002-.24 1.438.19.44.68 1.137 1.112 1.416.43.282 1.245.49 1.764.822.513.338 1.71 1.284 2.116 1.387.407.105.814.31.814.31s.46-.205 1.086-.205c.623 0 2.06.102 2.603-.13.543-.234 1.25-.616 1.032-1.107-.215-.485-1.41-.924-1.303-1.306.11-.385.543-.41 1.273-.44.732-.023 1.736.13 1.924-.9.19-1.025.245-1.62-.782-1.847-1.032-.232-1.794-.255-1.98-1.002-.19-.744-.38-.924-.165-1.132.22-.2.597-.307 1.357-.354.76-.055 1.627-.055 1.872-.24.245-.173.295-.663.594-.872.297-.2 1.468-.386 1.468-.386s1.394.683 2.69 1.644c1.158.866 2.206 2.144 2.206 2.144"
                fill="#ed72aa"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path d="M228.124 226.792s-.162-.462-.19-.592c-.025-.127-.11-.283-.11-.283s.844 0 .816.255c-.026.26-.27.26-.325.358-.054.106-.19.262-.19.262" />
            <path
                d="M228.124 226.792s-.162-.462-.19-.592c-.025-.127-.11-.283-.11-.283s.844 0 .816.255c-.026.26-.27.26-.325.358-.054.106-.19.262-.19.262z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M231.98 225.453l-.058-.412s.734.008 1.087.257c.543.385.89.977.866 1.002-.094.09-.514-.257-.814-.36 0 0-.216.052-.434.052-.216 0-.325-.102-.354-.205-.024-.105.03-.283.03-.283l-.324-.047" />
            <path
                d="M231.98 225.453l-.058-.412s.734.008 1.087.257c.543.385.89.977.866 1.002-.094.09-.514-.257-.814-.36 0 0-.216.052-.434.052-.216 0-.325-.102-.354-.205-.024-.105.03-.283.03-.283l-.324-.047v-.004z"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path
                d="M237.27 231.262s-.327-.464-.406-.62c-.083-.15-.22-.46-.22-.46"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M217.405 226.636s.46.33.814.382c.35.054.733.054.787.054.054 0 .165-.52.108-.872-.19-1.16-1.25-1.415-1.25-1.415s.316.703.163 1.026c-.216.464-.623.826-.623.826"
                fill="#db4446"
            />
            <path
                d="M217.405 226.636s.46.33.814.382c.35.054.733.054.787.054.054 0 .165-.52.108-.872-.19-1.16-1.25-1.415-1.25-1.415s.316.703.163 1.026c-.216.464-.623.826-.623.826z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M215.205 227.638s-.407-.746-1.273-.644c-.868.102-1.44.774-1.44.774s.958-.03 1.194.125c.354.233.462.826.462.826s.518-.31.68-.516a7.23 7.23 0 00.377-.566"
                fill="#db4446"
            />
            <path
                d="M215.205 227.638s-.407-.746-1.273-.644c-.868.102-1.44.774-1.44.774s.958-.03 1.194.125c.354.233.462.826.462.826s.518-.31.68-.516a7.23 7.23 0 00.377-.566z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M214.148 230.642s-.732.105-1.138.57c-.41.462-.352 1.335-.352 1.335s.484-.51.92-.51c.437 0 1.113.152 1.113.152s-.215-.546-.215-.775c0-.23-.327-.773-.327-.773"
                fill="#db4446"
            />
            <path
                d="M214.148 230.642s-.732.105-1.138.57c-.41.462-.352 1.335-.352 1.335s.484-.51.92-.51c.437 0 1.113.152 1.113.152s-.215-.546-.215-.775c0-.23-.327-.773-.327-.773z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path d="M228.153 230.54l.323-.512.32.464-.643.047" />
            <path d="M228.153 230.54l.323-.512.32.464-.643.047" fill="none" stroke="#000" strokeWidth={0.25} />
            <path d="M228.937 230.515l.38-.51.41.458-.79.052" />
            <path d="M228.937 230.515l.38-.51.41.458-.79.052" fill="none" stroke="#000" strokeWidth={0.25} />
            <path d="M228.586 227.355l.787.283-.705.358-.082-.64" />
            <path d="M228.586 227.355l.787.283-.705.358-.082-.64" fill="none" stroke="#000" strokeWidth={0.25} />
            <path d="M229.534 227.614l.706.178-.568.436-.138-.614" />
            <path d="M229.534 227.614l.706.178-.568.436-.138-.614" fill="none" stroke="#000" strokeWidth={0.25} />
            <path
                d="M224.243 233.652s-.773.225-1.058.64c-.352.514-.326 1.03-.326 1.03s.65-.54 1.49-.31c.844.23.923.31 1.28.286.352-.027 1.22-.338 1.22-.338s-.705.822-.626 1.39c.082.564.187.82.164 1.106-.058.695-.57 1.544-.57 1.544s.298-.184 1.003-.337a4.58 4.58 0 001.682-.77c.38-.287.867-.98.867-.98s-.158.952 0 1.364c.162.413.216 1.595.216 1.595s.453-.4.812-.593c.19-.106.68-.362.873-.668.134-.22.3-1.024.3-1.024s.107.866.377 1.286c.273.405.676 1.67.676 1.67s.274-.82.573-1.158c.296-.334.652-.77.677-1.03.025-.256-.08-.818-.08-.818l.378.818m-10.96.59s.462-.795.898-1.054c.435-.258 1.033-.72 1.194-.77.158-.052.868-.44.868-.44m.95 4.963s1.045-.535 1.357-.722c.65-.383 1.112-1.078 1.112-1.078"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M216.616 240.357s-.406-.433-1.112-.307c-.706.13-1.166.927-1.166.927s.597-.157.95-.078c.352.077.598.435.598.435s.324-.283.432-.436c.11-.154.295-.543.295-.543"
                fill="#db4446"
            />
            <path
                d="M216.616 240.357s-.406-.433-1.112-.307c-.706.13-1.166.927-1.166.927s.597-.157.95-.078c.352.077.598.435.598.435s.324-.283.432-.436c.11-.154.295-.543.295-.543h.003z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M215.803 243.21s-.598-.102-1.112.31c-.514.412-.542 1.207-.542 1.207s.49-.413.87-.357c.378.047.84.254.84.254s.082-.49.107-.616c.083-.36-.162-.8-.162-.8"
                fill="#db4446"
            />
            <path
                d="M215.803 243.21s-.598-.102-1.112.31c-.514.412-.542 1.207-.542 1.207s.49-.413.87-.357c.378.047.84.254.84.254s.082-.49.107-.616c.083-.36-.162-.8-.162-.8z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M217.19 245.835s-.04.763.323 1.23c.38.49 1.087.567 1.087.567s-.237-.512-.274-.772c-.053-.384.325-.72.325-.72s-.35-.356-.7-.356c-.355 0-.76.05-.76.05"
                fill="#db4446"
            />
            <path
                d="M217.19 245.835s-.04.763.323 1.23c.38.49 1.087.567 1.087.567s-.237-.512-.274-.772c-.053-.384.325-.72.325-.72s-.35-.356-.7-.356c-.355 0-.76.05-.76.05zm16.01 1.281s1.954 1.21 1.9 2.213c-.057 1.002-1.087 2.313-1.087 2.313"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M224.243 252.594s-.49-.616-1.166-.592c-.68.027-1.387.664-1.387.664s.844-.072 1.06.208c.22.287.435.64.435.64s.38-.2.544-.33c.162-.125.513-.59.513-.59"
                fill="#db4446"
            />
            <path
                d="M224.243 252.594s-.49-.616-1.166-.592c-.68.027-1.387.664-1.387.664s.844-.072 1.06.208c.22.287.435.64.435.64s.38-.2.544-.33c.162-.125.513-.59.513-.59z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M222.153 255.29s-.893-.128-1.33.335c-.435.46-.406 1.31-.406 1.31s.545-.59 1.03-.54c.49.052 1.033.31 1.033.31s-.083-.514-.137-.746c-.054-.232-.19-.67-.19-.67"
                fill="#db4446"
            />
            <path
                d="M222.153 255.29s-.893-.128-1.33.335c-.435.46-.406 1.31-.406 1.31s.545-.59 1.03-.54c.49.052 1.033.31 1.033.31s-.083-.514-.137-.746c-.054-.232-.19-.67-.19-.67z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M224.082 258.145s-.436.616-.108 1.104c.324.49 1 .722 1 .722s-.24-.358-.132-.775c.085-.326.65-.77.65-.77l-1.41-.28"
                fill="#db4446"
            />
            <path
                d="M224.082 258.145s-.436.616-.108 1.104c.324.49 1 .722 1 .722s-.24-.358-.132-.775c.085-.326.65-.77.65-.77l-1.41-.28v-.002z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M235.992 259.304s-.783-.185-1.22.075c-.43.254-.784 1.335-.784 1.335s.705-.59 1.22-.518c.515.08.897.287.897.287s.078-.44.024-.744c-.033-.184-.138-.436-.138-.436"
                fill="#db4446"
            />
            <path
                d="M235.992 259.304s-.783-.185-1.22.075c-.43.254-.784 1.335-.784 1.335s.705-.59 1.22-.518c.515.08.897.287.897.287s.078-.44.024-.744c-.033-.184-.138-.436-.138-.436z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M236.374 262.178s-.597.616-.382 1.13c.22.515.598 1.054.598 1.054s-.022-.766.22-.974c.35-.308 1-.36 1-.36s-.514-.462-.68-.513a15.836 15.836 0 01-.756-.337"
                fill="#db4446"
            />
            <path
                d="M236.374 262.178s-.597.616-.382 1.13c.22.515.598 1.054.598 1.054s-.022-.766.22-.974c.35-.308 1-.36 1-.36s-.514-.462-.68-.513a15.836 15.836 0 01-.756-.337z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M239.358 263.08s-.298.743.274 1.23c.568.492 1.06.543 1.06.543s-.437-.774-.3-1.183c.14-.426.514-.692.514-.692s-.706-.235-.814-.208c-.107.024-.734.31-.734.31"
                fill="#db4446"
            />
            <path
                d="M239.358 263.08s-.298.743.274 1.23c.568.492 1.06.543 1.06.543s-.437-.774-.3-1.183c.14-.426.514-.692.514-.692s-.706-.235-.814-.208c-.107.024-.734.31-.734.31z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M208.79 316.368c2.01.605 3.028 2.1 3.028 3.852 0 2.28-2.213 4.012-5.086 4.012-2.872 0-5.2-1.73-5.2-4.012 0-1.725.956-3.65 2.954-3.79 0 0-.06-.18-.233-.478-.208-.22-.616-.633-.616-.633s.763-.144 1.202.023c.442.167.733.446.733.446s.21-.41.5-.727c.296-.314.678-.51.678-.51s.442.37.587.62c.144.255.238.56.238.56s.406-.337.76-.473c.35-.14.805-.248.805-.248s-.13.44-.216.664c-.086.223-.133.692-.133.692"
                fill="#ffd691"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M206.308 326.708s-3.82-2.574-5.475-2.922c-2.117-.446-4.496-.085-5.525-.14.028.03 1.234.89 1.763 1.422.53.528 2.294 1.585 3.29 1.834 3.1.778 5.948-.194 5.948-.194m1.089.225s2.447-2.544 5.007-2.895c3.027-.42 5.007.25 6.183.556.026 0-.972.474-1.5.835-.53.36-1.893 1.503-3.977 1.527-2.087.03-4.39-.22-4.772-.16-.382.05-.94.136-.94.136"
                fill="#058e6e"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M206.664 323.786a4.852 4.852 0 01.003-7.13 4.845 4.845 0 011.552 3.562 4.864 4.864 0 01-1.556 3.568"
                fill="#ad1519"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M205.692 329.002s.59-1.46.648-2.713c.05-1.05-.148-2.087-.148-2.087h.763s.382 1.114.382 2.086c0 .973-.176 2.27-.176 2.27s-.528.08-.704.162c-.174.086-.764.28-.764.28"
                fill="#058e6e"
                stroke="#000"
                strokeWidth={0.499}
            />
            <path
                d="M254.005 190.727c0-.553.47-.993 1.05-.993.585 0 1.052.44 1.052.993 0 .552-.467.995-1.05.995-.58 0-1.052-.443-1.052-.995"
                fill="#fff"
            />
            <path
                d="M254.005 190.727c0-.553.47-.993 1.05-.993.585 0 1.052.44 1.052.993 0 .552-.467.995-1.05.995-.58 0-1.052-.443-1.052-.995z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M255.444 188.177c0-.55.468-.992 1.052-.992.58 0 1.05.443 1.05.992 0 .556-.47 1-1.05 1-.584 0-1.052-.444-1.052-1"
                fill="#fff"
            />
            <path
                d="M255.444 188.177c0-.55.468-.992 1.052-.992.58 0 1.05.443 1.05.992 0 .556-.47 1-1.05 1-.584 0-1.052-.444-1.052-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M256.4 185.225c0-.55.473-.995 1.058-.995.58 0 1.05.446 1.05.995 0 .552-.47 1-1.05 1-.585 0-1.057-.448-1.057-1"
                fill="#fff"
            />
            <path
                d="M256.4 185.225c0-.55.473-.995 1.058-.995.58 0 1.05.446 1.05.995 0 .552-.47 1-1.05 1-.585 0-1.057-.448-1.057-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M256.525 182.057c0-.552.47-.994 1.05-.994.58 0 1.05.442 1.05.994 0 .553-.47.996-1.05.996-.58 0-1.05-.443-1.05-.996"
                fill="#fff"
            />
            <path
                d="M256.525 182.057c0-.552.47-.994 1.05-.994.58 0 1.05.442 1.05.994 0 .553-.47.996-1.05.996-.58 0-1.05-.443-1.05-.996z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M255.743 178.94c0-.55.473-.993 1.05-.993.584 0 1.056.443 1.056.992 0 .554-.473.998-1.056.998-.578 0-1.05-.444-1.05-1"
                fill="#fff"
            />
            <path
                d="M255.743 178.94c0-.55.473-.993 1.05-.993.584 0 1.056.443 1.056.992 0 .554-.473.998-1.056.998-.578 0-1.05-.444-1.05-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M254.124 176.11c0-.553.47-.996 1.05-.996.584 0 1.054.443 1.054.995s-.47.998-1.053.998c-.58 0-1.05-.446-1.05-1"
                fill="#fff"
            />
            <path
                d="M254.124 176.11c0-.553.47-.996 1.05-.996.584 0 1.054.443 1.054.995s-.47.998-1.053.998c-.58 0-1.05-.446-1.05-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M251.964 173.784c0-.552.47-.998 1.05-.998.585 0 1.055.446 1.055.998 0 .55-.47.996-1.055.996-.58 0-1.05-.447-1.05-.996"
                fill="#fff"
            />
            <path
                d="M251.964 173.784c0-.552.47-.998 1.05-.998.585 0 1.055.446 1.055.998 0 .55-.47.996-1.055.996-.58 0-1.05-.447-1.05-.996z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M249.454 171.852c0-.553.473-1 1.056-1 .58 0 1.05.447 1.05 1 0 .548-.47.994-1.05.994-.583 0-1.056-.446-1.056-.994"
                fill="#fff"
            />
            <path
                d="M249.454 171.852c0-.553.473-1 1.056-1 .58 0 1.05.447 1.05 1 0 .548-.47.994-1.05.994-.583 0-1.056-.446-1.056-.994z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M246.457 170.27c0-.553.47-.992 1.05-.992.584 0 1.056.44 1.056.99 0 .554-.472 1-1.055 1-.58 0-1.05-.446-1.05-1"
                fill="#fff"
            />
            <path
                d="M246.457 170.27c0-.553.47-.992 1.05-.992.584 0 1.056.44 1.056.99 0 .554-.472 1-1.055 1-.58 0-1.05-.446-1.05-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M243.347 169.14c0-.548.47-.994 1.054-.994.58 0 1.053.446 1.053.995 0 .553-.473 1-1.052 1-.582 0-1.053-.447-1.053-1"
                fill="#fff"
            />
            <path
                d="M243.347 169.14c0-.548.47-.994 1.054-.994.58 0 1.053.446 1.053.995 0 .553-.473 1-1.052 1-.582 0-1.053-.447-1.053-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M239.87 168.52c0-.548.47-.998 1.05-.998.585 0 1.054.45 1.054.998 0 .55-.47.997-1.053.997-.58 0-1.05-.448-1.05-.997"
                fill="#fff"
            />
            <path
                d="M239.87 168.52c0-.548.47-.998 1.05-.998.585 0 1.054.45 1.054.998 0 .55-.47.997-1.053.997-.58 0-1.05-.448-1.05-.997z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M236.568 168.347c0-.55.473-.992 1.055-.992.58 0 1.053.442 1.053.992 0 .553-.473 1-1.053 1-.582 0-1.055-.447-1.055-1"
                fill="#fff"
            />
            <path
                d="M236.568 168.347c0-.55.473-.992 1.055-.992.58 0 1.053.442 1.053.992 0 .553-.473 1-1.053 1-.582 0-1.055-.447-1.055-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M233.328 168.46c0-.55.474-.996 1.055-.996.584 0 1.052.447 1.052.996 0 .552-.468.998-1.052.998-.58 0-1.055-.446-1.055-.998"
                fill="#fff"
            />
            <path
                d="M233.328 168.46c0-.55.474-.996 1.055-.996.584 0 1.052.447 1.052.996 0 .552-.468.998-1.052.998-.58 0-1.055-.446-1.055-.998z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M230.093 168.46c0-.55.47-.996 1.05-.996.58 0 1.052.447 1.052.996 0 .552-.472.998-1.05.998-.58 0-1.052-.446-1.052-.998"
                fill="#fff"
            />
            <path
                d="M230.093 168.46c0-.55.47-.996 1.05-.996.58 0 1.052.447 1.052.996 0 .552-.472.998-1.05.998-.58 0-1.052-.446-1.052-.998z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M231.714 171.238c0-.552.47-.998 1.05-.998.584 0 1.05.446 1.05.998 0 .55-.466.998-1.05.998-.58 0-1.05-.45-1.05-.998m.658 3.068c0-.552.472-1 1.05-1 .584 0 1.056.448 1.056 1 0 .546-.472.992-1.055.992-.58 0-1.05-.446-1.05-.992m.117 3.058c0-.556.473-1 1.055-1 .58 0 1.05.444 1.05 1 0 .548-.47.995-1.05.995-.582 0-1.055-.448-1.055-.996m-.957 2.782c0-.55.47-.998 1.05-.998.584 0 1.053.45 1.053.998 0 .552-.47.995-1.053.995-.58 0-1.05-.443-1.05-.995m-1.789 2.557c0-.55.472-.998 1.05-.998.583 0 1.052.45 1.052.998 0 .55-.47.996-1.05.996-.58 0-1.052-.446-1.052-.996"
                fill="#fff"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M227.642 166.53c0-.55.472-.992 1.054-.992.58 0 1.052.443 1.052.992 0 .552-.472 1-1.052 1-.582 0-1.054-.448-1.054-1"
                fill="#fff"
            />
            <path
                d="M227.642 166.53c0-.55.472-.992 1.054-.992.58 0 1.052.443 1.052.992 0 .552-.472 1-1.052 1-.582 0-1.054-.448-1.054-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M224.765 164.94c0-.548.47-.997 1.052-.997.58 0 1.05.45 1.05.998 0 .55-.47.997-1.05.997-.582 0-1.052-.446-1.052-.996"
                fill="#fff"
            />
            <path
                d="M224.765 164.94c0-.548.47-.997 1.052-.997.58 0 1.05.45 1.05.998 0 .55-.47.997-1.05.997-.582 0-1.052-.446-1.052-.996z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M221.595 163.983c0-.55.472-.99 1.053-.99.58 0 1.052.44 1.052.99 0 .552-.472 1-1.052 1-.58 0-1.053-.448-1.053-1"
                fill="#fff"
            />
            <path
                d="M221.595 163.983c0-.55.472-.99 1.053-.99.58 0 1.052.44 1.052.99 0 .552-.472 1-1.052 1-.58 0-1.053-.448-1.053-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M218.298 163.418c0-.55.472-.996 1.05-.996.584 0 1.052.447 1.052.996 0 .548-.468.995-1.05.995-.58 0-1.052-.447-1.052-.995"
                fill="#fff"
            />
            <path
                d="M218.298 163.418c0-.55.472-.996 1.05-.996.584 0 1.052.447 1.052.996 0 .548-.468.995-1.05.995-.58 0-1.052-.447-1.052-.995z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M215.07 163.472c0-.548.47-1 1.05-1 .583 0 1.054.452 1.054 1 0 .553-.47.996-1.054.996-.58 0-1.05-.443-1.05-.996"
                fill="#fff"
            />
            <path
                d="M215.07 163.472c0-.548.47-1 1.05-1 .583 0 1.054.452 1.054 1 0 .553-.47.996-1.054.996-.58 0-1.05-.443-1.05-.996z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M211.71 164.038c0-.548.472-.993 1.052-.993.583 0 1.054.445 1.054.993 0 .555-.47 1-1.054 1-.58 0-1.052-.445-1.052-1"
                fill="#fff"
            />
            <path
                d="M211.71 164.038c0-.548.472-.993 1.052-.993.583 0 1.054.445 1.054.993 0 .555-.47 1-1.054 1-.58 0-1.052-.445-1.052-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M208.6 165.112c0-.553.472-1 1.05-1 .585 0 1.056.447 1.056 1 0 .548-.47 1-1.055 1-.578 0-1.05-.452-1.05-1"
                fill="#fff"
            />
            <path
                d="M208.6 165.112c0-.553.472-1 1.05-1 .585 0 1.056.447 1.056 1 0 .548-.47 1-1.055 1-.578 0-1.05-.452-1.05-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M155.928 190.727c0-.553.473-.993 1.052-.993.583 0 1.05.44 1.05.993 0 .552-.467.995-1.05.995-.58 0-1.052-.443-1.052-.995"
                fill="#fff"
            />
            <path
                d="M155.928 190.727c0-.553.473-.993 1.052-.993.583 0 1.05.44 1.05.993 0 .552-.467.995-1.05.995-.58 0-1.052-.443-1.052-.995z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M154.488 188.177c0-.55.472-.992 1.052-.992.583 0 1.055.443 1.055.992 0 .556-.472 1-1.055 1-.58 0-1.052-.444-1.052-1"
                fill="#fff"
            />
            <path
                d="M154.488 188.177c0-.55.472-.992 1.052-.992.583 0 1.055.443 1.055.992 0 .556-.472 1-1.055 1-.58 0-1.052-.444-1.052-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M153.527 185.225c0-.55.472-.995 1.055-.995.58 0 1.052.446 1.052.995 0 .552-.472 1-1.052 1-.583 0-1.055-.448-1.055-1"
                fill="#fff"
            />
            <path
                d="M153.527 185.225c0-.55.472-.995 1.055-.995.58 0 1.052.446 1.052.995 0 .552-.472 1-1.052 1-.583 0-1.055-.448-1.055-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M153.408 182.057c0-.552.473-.994 1.052-.994.583 0 1.055.442 1.055.994 0 .553-.472.996-1.055.996-.58 0-1.052-.443-1.052-.996"
                fill="#fff"
            />
            <path
                d="M153.408 182.057c0-.552.473-.994 1.052-.994.583 0 1.055.442 1.055.994 0 .553-.472.996-1.055.996-.58 0-1.052-.443-1.052-.996z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M154.19 178.94c0-.55.47-.993 1.05-.993.58 0 1.052.443 1.052.992 0 .554-.472.998-1.052.998-.58 0-1.05-.444-1.05-1"
                fill="#fff"
            />
            <path
                d="M154.19 178.94c0-.55.47-.993 1.05-.993.58 0 1.052.443 1.052.992 0 .554-.472.998-1.052.998-.58 0-1.05-.444-1.05-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M155.805 176.11c0-.553.473-.996 1.056-.996.58 0 1.052.443 1.052.995s-.472.998-1.05.998c-.584 0-1.057-.446-1.057-1"
                fill="#fff"
            />
            <path
                d="M155.805 176.11c0-.553.473-.996 1.056-.996.58 0 1.052.443 1.052.995s-.472.998-1.05.998c-.584 0-1.057-.446-1.057-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M157.966 173.784c0-.552.472-.998 1.054-.998.58 0 1.052.446 1.052.998 0 .55-.473.996-1.052.996-.582 0-1.054-.447-1.054-.996"
                fill="#fff"
            />
            <path
                d="M157.966 173.784c0-.552.472-.998 1.054-.998.58 0 1.052.446 1.052.998 0 .55-.473.996-1.052.996-.582 0-1.054-.447-1.054-.996z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M160.475 171.852c0-.553.47-1 1.054-1 .58 0 1.05.447 1.05 1 0 .548-.47.994-1.05.994-.584 0-1.055-.446-1.055-.994"
                fill="#fff"
            />
            <path
                d="M160.475 171.852c0-.553.47-1 1.054-1 .58 0 1.05.447 1.05 1 0 .548-.47.994-1.05.994-.584 0-1.055-.446-1.055-.994z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M163.473 170.27c0-.553.47-.992 1.055-.992.58 0 1.05.44 1.05.99 0 .554-.47 1-1.05 1-.584 0-1.055-.446-1.055-1"
                fill="#fff"
            />
            <path
                d="M163.473 170.27c0-.553.47-.992 1.055-.992.58 0 1.05.44 1.05.99 0 .554-.47 1-1.05 1-.584 0-1.055-.446-1.055-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M166.583 169.14c0-.548.472-.994 1.052-.994.582 0 1.054.446 1.054.995 0 .553-.473 1-1.055 1-.58 0-1.052-.447-1.052-1"
                fill="#fff"
            />
            <path
                d="M166.583 169.14c0-.548.472-.994 1.052-.994.582 0 1.054.446 1.054.995 0 .553-.473 1-1.055 1-.58 0-1.052-.447-1.052-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M170.064 168.52c0-.548.47-.998 1.052-.998.578 0 1.05.45 1.05.998 0 .55-.472.997-1.05.997-.58 0-1.052-.448-1.052-.997"
                fill="#fff"
            />
            <path
                d="M170.064 168.52c0-.548.47-.998 1.052-.998.578 0 1.05.45 1.05.998 0 .55-.472.997-1.05.997-.58 0-1.052-.448-1.052-.997z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M173.362 168.347c0-.55.47-.992 1.054-.992.58 0 1.05.442 1.05.992 0 .553-.47 1-1.05 1-.584 0-1.054-.447-1.054-1"
                fill="#fff"
            />
            <path
                d="M173.362 168.347c0-.55.47-.992 1.054-.992.58 0 1.05.442 1.05.992 0 .553-.47 1-1.05 1-.584 0-1.054-.447-1.054-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M176.6 168.46c0-.55.472-.996 1.05-.996.585 0 1.056.447 1.056.996 0 .552-.47.998-1.055.998-.578 0-1.05-.446-1.05-.998"
                fill="#fff"
            />
            <path
                d="M176.6 168.46c0-.55.472-.996 1.05-.996.585 0 1.056.447 1.056.996 0 .552-.47.998-1.055.998-.578 0-1.05-.446-1.05-.998z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M179.84 168.46c0-.55.47-.996 1.05-.996.584 0 1.056.447 1.056.996 0 .552-.472.998-1.055.998-.58 0-1.05-.446-1.05-.998"
                fill="#fff"
            />
            <path
                d="M179.84 168.46c0-.55.47-.996 1.05-.996.584 0 1.056.447 1.056.996 0 .552-.472.998-1.055.998-.58 0-1.05-.446-1.05-.998z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M178.22 171.238c0-.552.472-.998 1.052-.998.582 0 1.054.446 1.054.998 0 .55-.472.998-1.054.998-.58 0-1.052-.45-1.052-.998m-.658 3.068c0-.552.467-1 1.05-1 .58 0 1.052.448 1.052 1 0 .546-.472.992-1.05.992-.585 0-1.052-.446-1.052-.992m-.122 3.058c0-.556.47-1 1.054-1 .58 0 1.05.444 1.05 1 0 .548-.47.995-1.05.995-.583 0-1.054-.448-1.054-.996m.96 2.782c0-.55.472-.998 1.05-.998.585 0 1.056.45 1.056.998 0 .552-.47.995-1.055.995-.578 0-1.05-.443-1.05-.995m1.787 2.557c0-.55.474-.998 1.052-.998.583 0 1.055.45 1.055.998 0 .55-.472.996-1.055.996-.578 0-1.052-.446-1.052-.996"
                fill="#fff"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M182.288 166.53c0-.55.472-.992 1.05-.992.584 0 1.055.443 1.055.992 0 .552-.47 1-1.054 1-.58 0-1.052-.448-1.052-1"
                fill="#fff"
            />
            <path
                d="M182.288 166.53c0-.55.472-.992 1.05-.992.584 0 1.055.443 1.055.992 0 .552-.47 1-1.054 1-.58 0-1.052-.448-1.052-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M185.168 164.94c0-.548.47-.997 1.05-.997.583 0 1.055.45 1.055.998 0 .55-.472.997-1.055.997-.58 0-1.05-.446-1.05-.996"
                fill="#fff"
            />
            <path
                d="M185.168 164.94c0-.548.47-.997 1.05-.997.583 0 1.055.45 1.055.998 0 .55-.472.997-1.055.997-.58 0-1.05-.446-1.05-.996z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M188.334 163.983c0-.55.473-.99 1.055-.99.58 0 1.05.44 1.05.99 0 .552-.47 1-1.05 1-.583 0-1.056-.448-1.056-1"
                fill="#fff"
            />
            <path
                d="M188.334 163.983c0-.55.473-.99 1.055-.99.58 0 1.05.44 1.05.99 0 .552-.47 1-1.05 1-.583 0-1.056-.448-1.056-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M191.635 163.418c0-.55.472-.996 1.05-.996.585 0 1.057.447 1.057.996 0 .548-.472.995-1.056.995-.58 0-1.05-.447-1.05-.995"
                fill="#fff"
            />
            <path
                d="M191.635 163.418c0-.55.472-.996 1.05-.996.585 0 1.057.447 1.057.996 0 .548-.472.995-1.056.995-.58 0-1.05-.447-1.05-.995z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M194.865 163.472c0-.548.467-1 1.05-1 .58 0 1.05.452 1.05 1 0 .553-.47.996-1.05.996-.583 0-1.05-.443-1.05-.996"
                fill="#fff"
            />
            <path
                d="M194.865 163.472c0-.548.467-1 1.05-1 .58 0 1.05.452 1.05 1 0 .553-.47.996-1.05.996-.583 0-1.05-.443-1.05-.996z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M198.223 164.038c0-.548.47-.993 1.05-.993.585 0 1.052.445 1.052.993 0 .555-.467 1-1.052 1-.58 0-1.05-.445-1.05-1"
                fill="#fff"
            />
            <path
                d="M198.223 164.038c0-.548.47-.993 1.05-.993.585 0 1.052.445 1.052.993 0 .555-.467 1-1.052 1-.58 0-1.05-.445-1.05-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M201.33 165.112c0-.553.47-1 1.054-1 .58 0 1.05.447 1.05 1 0 .548-.47 1-1.05 1-.584 0-1.054-.452-1.054-1"
                fill="#fff"
            />
            <path
                d="M201.33 165.112c0-.553.47-1 1.054-1 .58 0 1.05.447 1.05 1 0 .548-.47 1-1.05 1-.584 0-1.054-.452-1.054-1z"
                fill="none"
                stroke="#000"
                strokeWidth={0.374}
            />
            <path
                d="M174.647 228.876h-.887v-.888h-1.553v3.55h1.553v2.44h-3.327v7.098h1.774v14.197h-3.55v7.32h27.286v-7.32h-3.55v-14.197h1.775v-7.1h-3.327v-2.438h1.554v-3.55h-1.553v.888h-.886v-.888H188.4v.888h-1.108v-.888h-1.554v3.55h1.554v2.44h-3.328v-7.765h1.774v-3.55h-1.774v.888h-.887v-.886h-1.553v.887h-.887v-.886h-1.775v3.55h1.775v7.763h-3.328v-2.44h1.552v-3.55h-1.553v.89h-.89v-.89h-1.773v.89zm-5.99 33.718h27.286m-27.285-1.775h27.285m-27.285-1.776h27.285m-27.285-1.775h27.285m-27.285-1.997h27.285m-23.736-1.553h20.187m-20.187-1.775h20.187m-20.187-1.996h20.187m-20.187-1.776h20.187m-20.187-1.775h20.187m-20.187-1.775h20.187m-20.187-1.775h20.187m-21.96-1.774h23.734m-23.735-1.775h23.735m-23.735-1.773h23.735m-23.735-1.775h23.735m-20.408-1.775h17.08m-10.203-1.774h3.327m-3.327-1.775h3.327m-3.327-1.774h3.327m-3.327-1.775h3.327m-5.102-2.22h6.876m-11.978 7.543h3.55m-5.103-2.22h6.655m-6.655 32.61v-1.774m0-1.776v-1.775m-1.774 1.774v1.775m3.327 0v-1.776m1.774 3.55v-1.775m0-1.776v-1.775m0-1.997v-1.553m0-1.775v-1.996m-1.774 7.32v-1.997m-3.327 1.996v-1.997m6.876 0v1.996m1.552-1.997v-1.553m-5.102-1.775v1.775m3.55-1.775v1.775m3.327-1.775v1.775m-1.775-1.775v-1.996m1.775-1.776v1.775m0-5.325v1.774m-1.775-3.55v1.775m1.775-3.55v1.775m-3.328-1.774v1.774m-3.55-1.774v1.774m-1.553-3.55v1.776m3.327-1.775v1.776m3.328-1.775v1.776m1.775-3.55v1.775m-3.328-1.773v1.774m-3.55-1.773v1.774m-1.553-3.548v1.775m6.655-1.775v1.775m-3.328-5.324v1.774m15.307-1.774h-3.548m5.102-2.22h-6.656m6.656 32.61v-1.774m0-1.776v-1.775m1.774 1.774v1.775m-3.327 0v-1.776m-1.774 3.55v-1.775m0-1.776v-1.775m0-1.997v-1.553m0-1.775v-1.996m1.775 7.32v-1.997m3.328 1.996v-1.997m-6.876 0v1.996m-1.554-1.997v-1.553m5.103-1.775v1.775m-3.548-1.775v1.775m-3.328-1.775v1.775m1.774-1.775v-1.996m-1.774-1.776v1.775m0-5.325v1.774m1.774-3.55v1.775m-1.774-3.55v1.775m3.328-1.774v1.774m3.55-1.774v1.774m1.552-3.55v1.776m-3.328-1.775v1.776m-3.328-1.775v1.776m-1.774-3.55v1.775m3.328-1.773v1.774m3.55-1.773v1.774m1.552-3.548v1.775m-6.656-1.775v1.775m3.328-5.324v1.774m-6.877 17.968v-1.996m0-5.325v-1.775m0 5.324V246.4m0-5.324V239.3m0-1.773v-1.775m0-3.55v-1.774m0-1.774v-1.775m-8.43 4.658h3.55m3.327-5.325h3.327m3.328 5.325h3.55"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.442}
            />
            <path
                d="M186.848 262.594v-4.66c0-.886-.444-3.548-4.66-3.548-3.992 0-4.435 2.662-4.435 3.55v4.658h9.095z"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.442}
            />
            <path
                d="M179.305 258.156l-2.217-.22c0-.888.22-2.22.887-2.663l1.997 1.553c-.222.222-.667.887-.667 1.33zm5.99 0l2.218-.22c0-.888-.22-2.22-.887-2.663l-1.997 1.553c.22.222.665.887.665 1.33zm-2.218-2.218l1.11-1.996c-.445-.222-1.333-.443-1.998-.443-.444 0-1.33.22-1.775.442l1.11 1.996h1.552zm-4.215-5.545v-4.88c0-1.33-.887-2.44-2.44-2.44s-2.44 1.11-2.44 2.44v4.88h4.88zm6.876 0v-4.88c0-1.33.888-2.44 2.44-2.44 1.554 0 2.44 1.11 2.44 2.44v4.88h-4.88zm-1.774-11.979l.444-4.437h-4.215l.222 4.437h3.55zm3.328 0l-.444-4.437h4.436l-.443 4.437h-3.548zm-9.982 0l.22-4.437h-4.214l.444 4.437h3.55z"
                fill="#c8b100"
                stroke="#000"
                strokeWidth={0.442}
            />
            <path
                d="M185.295 262.594V258.6c0-.665-.444-2.662-3.106-2.662-2.44 0-2.885 1.997-2.885 2.662v3.994h5.99zm-6.877-12.644v-4.216c0-1.11-.665-2.218-1.997-2.218-1.33 0-1.994 1.11-1.994 2.218v4.215h3.992zm7.765 0v-4.216c0-1.11.665-2.218 1.996-2.218 1.33 0 1.995 1.11 1.995 2.218v4.215h-3.992z"
                fill="#0039f0"
            />
            <path
                d="M190.808 269.766c0-9.698 6.987-17.56 15.604-17.56 8.62 0 15.608 7.862 15.608 17.56 0 9.698-6.987 17.56-15.608 17.56-8.617 0-15.604-7.862-15.604-17.56"
                fill="#ad1519"
            />
            <path
                d="M190.808 269.766c0-9.698 6.987-17.56 15.604-17.56 8.62 0 15.608 7.862 15.608 17.56 0 9.698-6.987 17.56-15.608 17.56-8.617 0-15.604-7.862-15.604-17.56z"
                fill="none"
                stroke="#000"
                strokeWidth={0.586}
            />
            <path
                d="M195.437 269.732c0-7.112 4.913-12.875 10.982-12.875 6.064 0 10.978 5.763 10.978 12.875 0 7.114-4.914 12.88-10.98 12.88-6.068 0-10.98-5.766-10.98-12.88"
                fill="#005bbf"
            />
            <path
                d="M195.437 269.732c0-7.112 4.913-12.875 10.982-12.875 6.064 0 10.978 5.763 10.978 12.875 0 7.114-4.914 12.88-10.98 12.88-6.068 0-10.98-5.766-10.98-12.88z"
                fill="none"
                stroke="#000"
                strokeWidth={0.586}
            />
            <path
                d="M201.232 260.868s-1.304 1.428-1.304 2.75c0 1.33.55 2.434.55 2.434-.196-.524-.73-.902-1.355-.902-.79 0-1.437.607-1.437 1.36 0 .218.134.56.235.746l.468.945c.155-.348.52-.54.944-.54.567 0 1.03.432 1.03.97a.88.88 0 01-.033.238l-1.17.004v.996h1.043l-.777 1.54 1.03-.4.776.875.806-.876 1.026.4-.773-1.54h1.044v-.995l-1.173-.004a.878.878 0 01-.024-.237c0-.538.453-.97 1.02-.97.426 0 .79.192.948.54l.464-.944c.1-.187.235-.528.235-.746 0-.753-.64-1.36-1.436-1.36-.627 0-1.156.378-1.354.902 0 0 .547-1.104.547-2.433 0-1.324-1.33-2.752-1.33-2.752"
                fill="#c8b100"
            />
            <path
                d="M201.232 260.868s-1.304 1.428-1.304 2.75c0 1.33.55 2.434.55 2.434-.196-.524-.73-.902-1.355-.902-.79 0-1.437.607-1.437 1.36 0 .218.134.56.235.746l.468.945c.155-.348.52-.54.944-.54.567 0 1.03.432 1.03.97a.88.88 0 01-.033.238l-1.17.004v.996h1.043l-.777 1.54 1.03-.4.776.875.806-.876 1.026.4-.773-1.54h1.044v-.995l-1.173-.004a.878.878 0 01-.024-.237c0-.538.453-.97 1.02-.97.426 0 .79.192.948.54l.464-.944c.1-.187.235-.528.235-.746 0-.753-.64-1.36-1.436-1.36-.627 0-1.156.378-1.354.902 0 0 .547-1.104.547-2.433 0-1.324-1.33-2.752-1.33-2.752h.002z"
                fill="none"
                stroke="#000"
                strokeWidth={0.326}
                strokeLinejoin="round"
            />
            <path d="M199.16 269.868h4.177v-.996h-4.178v.996z" fill="#c8b100" />
            <path d="M199.16 269.868h4.177v-.996h-4.178v.996z" fill="none" stroke="#000" strokeWidth={0.326} />
            <path
                d="M211.436 260.868s-1.302 1.428-1.302 2.75c0 1.33.547 2.434.547 2.434-.194-.524-.726-.902-1.353-.902-.795 0-1.436.607-1.436 1.36 0 .218.135.56.235.746l.464.945c.158-.348.522-.54.947-.54.568 0 1.025.432 1.025.97a.89.89 0 01-.028.238l-1.17.004v.996h1.043l-.777 1.54 1.026-.4.78.875.804-.876 1.03.4-.778-1.54h1.043v-.995l-1.17-.004a.84.84 0 01-.028-.237c0-.538.457-.97 1.026-.97.425 0 .788.192.943.54l.467-.944c.102-.187.234-.528.234-.746 0-.753-.643-1.36-1.436-1.36-.624 0-1.16.378-1.355.902 0 0 .55-1.104.55-2.433 0-1.324-1.33-2.752-1.33-2.752"
                fill="#c8b100"
            />
            <path
                d="M211.436 260.868s-1.302 1.428-1.302 2.75c0 1.33.547 2.434.547 2.434-.194-.524-.726-.902-1.353-.902-.795 0-1.436.607-1.436 1.36 0 .218.135.56.235.746l.464.945c.158-.348.522-.54.947-.54.568 0 1.025.432 1.025.97a.89.89 0 01-.028.238l-1.17.004v.996h1.043l-.777 1.54 1.026-.4.78.875.804-.876 1.03.4-.778-1.54h1.043v-.995l-1.17-.004a.84.84 0 01-.028-.237c0-.538.457-.97 1.026-.97.425 0 .788.192.943.54l.467-.944c.102-.187.234-.528.234-.746 0-.753-.643-1.36-1.436-1.36-.624 0-1.16.378-1.355.902 0 0 .55-1.104.55-2.433 0-1.324-1.33-2.752-1.33-2.752h.002z"
                fill="none"
                stroke="#000"
                strokeWidth={0.326}
                strokeLinejoin="round"
            />
            <path d="M209.363 269.868h4.176v-.996h-4.177v.996z" fill="#c8b100" />
            <path d="M209.363 269.868h4.176v-.996h-4.177v.996z" fill="none" stroke="#000" strokeWidth={0.326} />
            <path
                d="M206.333 269.646s-1.304 1.428-1.304 2.755.55 2.43.55 2.43c-.197-.524-.727-.903-1.356-.903-.792 0-1.437.608-1.437 1.36 0 .222.133.56.234.747l.47.944c.158-.347.517-.545.94-.545.57 0 1.032.436 1.032.975a.86.86 0 01-.033.242l-1.17.003v.996h1.047l-.778 1.54 1.026-.406.777.876.807-.876 1.03.406-.783-1.54h1.048v-.997l-1.17-.003a.9.9 0 01-.03-.242c0-.54.458-.975 1.028-.975.423 0 .783.198.942.545l.47-.944c.098-.188.232-.525.232-.746 0-.753-.644-1.36-1.436-1.36-.625 0-1.154.378-1.356.903 0 0 .55-1.103.55-2.43 0-1.326-1.335-2.754-1.335-2.754"
                fill="#c8b100"
            />
            <path
                d="M206.333 269.646s-1.304 1.428-1.304 2.755.55 2.43.55 2.43c-.197-.524-.727-.903-1.356-.903-.792 0-1.437.608-1.437 1.36 0 .222.133.56.234.747l.47.944c.158-.347.517-.545.94-.545.57 0 1.032.436 1.032.975a.86.86 0 01-.033.242l-1.17.003v.996h1.047l-.778 1.54 1.026-.406.777.876.807-.876 1.03.406-.783-1.54h1.048v-.997l-1.17-.003a.9.9 0 01-.03-.242c0-.54.458-.975 1.028-.975.423 0 .783.198.942.545l.47-.944c.098-.188.232-.525.232-.746 0-.753-.644-1.36-1.436-1.36-.625 0-1.154.378-1.356.903 0 0 .55-1.103.55-2.43 0-1.326-1.335-2.754-1.335-2.754h.003z"
                fill="none"
                stroke="#000"
                strokeWidth={0.326}
                strokeLinejoin="round"
            />
            <path d="M204.26 278.65h4.178v-.997h-4.178v.996z" fill="#c8b100" />
            <path d="M204.26 278.65h4.178v-.997h-4.178v.996z" fill="none" stroke="#000" strokeWidth={0.326} />
            <path
                d="M237.567 223.398l-.278.02a1.483 1.483 0 01-.256.342c-.246.234-.616.26-.825.064a.472.472 0 01-.134-.393.498.498 0 01-.49-.006c-.248-.143-.31-.483-.13-.767.03-.054.058-.125.1-.167l-.017-.31-.336.08-.097.182c-.208.236-.518.297-.673.158a.555.555 0 01-.126-.253c.003.008-.08.082-.166.102-.513.126-.72-1.006-.73-1.3l-.17.24s.153.677.076 1.25c-.075.573-.278 1.146-.278 1.146.717.184 1.79.766 2.855 1.588 1.066.815 1.904 1.7 2.25 2.322 0 0 .552-.308 1.13-.49.574-.188 1.303-.192 1.303-.192l.21-.205c-.308.044-1.52.095-1.495-.413.005-.08.065-.17.076-.17a.667.667 0 01-.29-.065c-.175-.116-.17-.412.024-.658l.17-.123.01-.326-.325.045c-.03.04-.105.087-.15.128-.254.222-.62.238-.823.03a.422.422 0 01-.107-.446.548.548 0 01-.433-.045c-.248-.15-.295-.5-.104-.773.09-.134.266-.29.297-.307l-.067-.287"
                fill="#c8b100"
            />
            <path
                d="M237.567 223.398l-.278.02a1.483 1.483 0 01-.256.342c-.246.234-.616.26-.825.064a.472.472 0 01-.134-.393.498.498 0 01-.49-.006c-.248-.143-.31-.483-.13-.767.03-.054.058-.125.1-.167l-.017-.31-.336.08-.097.182c-.208.236-.518.297-.673.158a.555.555 0 01-.126-.253c.003.008-.08.082-.166.102-.513.126-.72-1.006-.73-1.3l-.17.24s.153.677.076 1.25c-.075.573-.278 1.146-.278 1.146.717.184 1.79.766 2.855 1.588 1.066.815 1.904 1.7 2.25 2.322 0 0 .552-.308 1.13-.49.574-.188 1.303-.192 1.303-.192l.21-.205c-.308.044-1.52.095-1.495-.413.005-.08.065-.17.076-.17a.667.667 0 01-.29-.065c-.175-.116-.17-.412.024-.658l.17-.123.01-.326-.325.045c-.03.04-.105.087-.15.128-.254.222-.62.238-.823.03a.422.422 0 01-.107-.446.548.548 0 01-.433-.045c-.248-.15-.295-.5-.104-.773.09-.134.266-.29.297-.307l-.067-.287-.007-.003z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M235.406 224.06c.048-.06.148-.056.223.002.074.058.095.15.05.205-.047.054-.145.054-.223-.007-.072-.054-.097-.147-.05-.2" />
            <path
                d="M235.406 224.06c.048-.06.148-.056.223.002.074.058.095.15.05.205-.047.054-.145.054-.223-.007-.072-.054-.097-.147-.05-.2z"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path d="M236.317 224.825l-.314-.242c-.057-.044-.075-.115-.04-.156.037-.038.113-.038.17.003l.313.246.32.243c.055.04.075.11.04.155-.04.037-.115.034-.172-.007l-.317-.243" />
            <path
                d="M236.317 224.825l-.314-.242c-.057-.044-.075-.115-.04-.156.037-.038.113-.038.17.003l.313.246.32.243c.055.04.075.11.04.155-.04.037-.115.034-.172-.007l-.317-.243"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path d="M234.644 223.68l-.25-.146c-.06-.037-.093-.11-.063-.156.026-.052.1-.06.162-.02l.247.145.252.147c.06.034.09.106.065.157-.028.044-.1.054-.165.017l-.248-.144" />
            <path
                d="M234.644 223.68l-.25-.146c-.06-.037-.093-.11-.063-.156.026-.052.1-.06.162-.02l.247.145.252.147c.06.034.09.106.065.157-.028.044-.1.054-.165.017l-.248-.144"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path d="M233.653 222.996c.047-.05.15-.05.223.007.076.058.097.15.05.204-.047.055-.146.05-.222-.003-.075-.062-.098-.15-.05-.208" />
            <path
                d="M233.653 222.996c.047-.05.15-.05.223.007.076.058.097.15.05.204-.047.055-.146.05-.222-.003-.075-.062-.098-.15-.05-.208z"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path d="M237.325 225.528c.047-.055.024-.143-.05-.204-.076-.06-.177-.062-.224-.003-.045.054-.024.146.05.204.076.06.177.06.225.004" />
            <path
                d="M237.325 225.528c.047-.055.024-.143-.05-.204-.076-.06-.177-.062-.224-.003-.045.054-.024.146.05.204.076.06.177.06.225.004z"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path d="M237.876 226.16l.204.196c.05.047.13.066.174.027.043-.033.037-.1-.01-.15l-.203-.2-.208-.205c-.05-.047-.13-.06-.173-.023-.047.03-.04.105.013.152l.203.202" />
            <path
                d="M237.876 226.16l.204.196c.05.047.13.066.174.027.043-.033.037-.1-.01-.15l-.203-.2-.208-.205c-.05-.047-.13-.06-.173-.023-.047.03-.04.105.013.152l.203.202"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path d="M238.785 226.935c.048-.057.026-.146-.05-.207-.075-.06-.176-.06-.223-.003-.047.058-.025.146.05.207.076.055.178.06.223.003" />
            <path
                d="M238.785 226.935c.048-.057.026-.146-.05-.207-.075-.06-.176-.06-.223-.003-.047.058-.025.146.05.207.076.055.178.06.223.003z"
                fill="none"
                stroke="#000"
                strokeWidth={0.048}
            />
            <path d="M236.146 221.14l-.567.018-.112.835.06.133.148-.01.727-.49-.257-.486" fill="#c8b100" />
            <path
                d="M236.146 221.14l-.567.018-.112.835.06.133.148-.01.727-.49-.257-.486"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M234.608 221.604l-.016.522.883.11.137-.06-.01-.142-.516-.686-.478.256" fill="#c8b100" />
            <path
                d="M234.608 221.604l-.016.522.883.11.137-.06-.01-.142-.516-.686-.478.256"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M236.432 222.644l-.47.262-.517-.687-.01-.14.137-.06.886.106-.026.518" fill="#c8b100" />
            <path
                d="M236.432 222.644l-.47.262-.517-.687-.01-.14.137-.06.886.106-.026.518"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M235.29 222a.28.28 0 01.378-.09.25.25 0 01.095.356.287.287 0 01-.378.092.255.255 0 01-.095-.358"
                fill="#c8b100"
            />
            <path
                d="M235.29 222a.28.28 0 01.378-.09.25.25 0 01.095.356.287.287 0 01-.378.092.255.255 0 01-.095-.358z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M233.226 221.138c-.015.003-.124-.44-.246-.686-.083-.177-.375-.408-.375-.408.03-.055.397-.188.836.088.357.294-.028.832-.028.832s-.094.13-.184.174"
                fill="#c8b100"
            />
            <path
                d="M233.226 221.138c-.015.003-.124-.44-.246-.686-.083-.177-.375-.408-.375-.408.03-.055.397-.188.836.088.357.294-.028.832-.028.832s-.094.13-.184.174h-.003z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M234.217 221.437l-.402.348-.656-.57.057-.08.023-.14.888-.066.09.507" fill="#c8b100" />
            <path
                d="M234.217 221.437l-.402.348-.656-.57.057-.08.023-.14.888-.066.09.507"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M233.107 221.082c.05-.143.175-.227.276-.197.1.037.14.177.093.317-.05.143-.176.225-.276.198-.105-.038-.144-.178-.093-.318"
                fill="#c8b100"
            />
            <path
                d="M233.107 221.082c.05-.143.175-.227.276-.197.1.037.14.177.093.317-.05.143-.176.225-.276.198-.105-.038-.144-.178-.093-.318z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M238.32 222.5l-.564-.06-.237.815.043.14.148.003.792-.386-.18-.51" fill="#c8b100" />
            <path
                d="M238.32 222.5l-.564-.06-.237.815.043.14.148.003.792-.386-.18-.51"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M236.727 222.753l-.09.515.857.225.144-.04.01-.14-.407-.754-.513.193" fill="#c8b100" />
            <path
                d="M236.727 222.753l-.09.515.857.225.144-.04.01-.14-.407-.754-.513.193"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M238.383 224.02l-.507.202-.407-.75.01-.143.143-.04.857.227-.097.504" fill="#c8b100" />
            <path
                d="M238.383 224.02l-.507.202-.407-.75.01-.143.143-.04.857.227-.097.504"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M237.346 223.237c.094-.116.27-.125.386-.037a.25.25 0 01.043.365.29.29 0 01-.39.036.25.25 0 01-.04-.363"
                fill="#c8b100"
            />
            <path
                d="M237.346 223.237c.094-.116.27-.125.386-.037a.25.25 0 01.043.365.29.29 0 01-.39.036.25.25 0 01-.04-.363z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M240.22 224.264l.102.534-.838.28-.148-.03-.017-.14.348-.775.55.13" fill="#c8b100" />
            <path
                d="M240.22 224.264l.102.534-.838.28-.148-.03-.017-.14.348-.775.55.13"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M240.068 225.794l-.536.12-.297-.8.034-.135.147-.02.817.333-.166.5" fill="#c8b100" />
            <path
                d="M240.068 225.794l-.536.12-.297-.8.034-.135.147-.02.817.333-.166.5"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M238.613 224.314l-.173.495.818.33.15-.02.03-.137-.292-.794-.533.124" fill="#c8b100" />
            <path
                d="M238.613 224.314l-.173.495.818.33.15-.02.03-.137-.292-.794-.533.124"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M239.517 225.242a.26.26 0 00.015-.373.298.298 0 00-.393-.014.257.257 0 00-.01.373.29.29 0 00.387.012"
                fill="#c8b100"
            />
            <path
                d="M239.517 225.242a.26.26 0 00.015-.373.298.298 0 00-.393-.014.257.257 0 00-.01.373.29.29 0 00.387.012z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M240.837 226.973c-.003.014.48.025.757.085.198.042.504.263.504.263.054-.04.108-.405-.27-.755-.378-.27-.85.204-.85.204s-.115.112-.14.203"
                fill="#c8b100"
            />
            <path
                d="M240.837 226.973c-.003.014.48.025.757.085.198.042.504.263.504.263.054-.04.108-.405-.27-.755-.378-.27-.85.204-.85.204s-.115.112-.14.203z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path d="M240.32 226.114l-.277.447.726.492.09-.08.118-.04-.112-.84-.547.022" fill="#c8b100" />
            <path
                d="M240.32 226.114l-.277.447.726.492.09-.08.118-.04-.112-.84-.547.022"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M240.917 227.072c.133-.074.198-.21.144-.296-.057-.09-.21-.1-.344-.024-.134.078-.198.207-.14.3.052.085.208.096.34.02"
                fill="#c8b100"
            />
            <path
                d="M240.917 227.072c.133-.074.198-.21.144-.296-.057-.09-.21-.1-.344-.024-.134.078-.198.207-.14.3.052.085.208.096.34.02z"
                fill="none"
                stroke="#000"
                strokeWidth={0.25}
            />
            <path
                d="M279.087 205.098v.556h-2.434v-.556h.9v-1.254h-.594v-.56h.594v-.547h.586v.548h.586v.56h-.586v1.253h.947"
                fill="none"
                stroke="#000"
                strokeWidth={0.288}
            />
            <path d="M134.418 217.104v-1.216" fill="none" stroke="#000" strokeWidth={0.019} />
            <path d="M134.087 217.104v-1.216" fill="none" stroke="#000" strokeWidth={0.029} />
            <path d="M133.775 217.104v-1.216m-.31 1.216v-1.216" fill="none" stroke="#000" strokeWidth={0.038} />
            <path d="M133.19 217.104v-1.216" fill="none" stroke="#000" strokeWidth={0.048} />
            <path d="M132.665 217.04l-.008-1.11m.256 1.123v-1.16" fill="none" stroke="#000" strokeWidth={0.058} />
            <path d="M132.18 216.99v-1.022m.245 1.05l-.007-1.086" fill="none" stroke="#000" strokeWidth={0.067} />
            <path d="M131.528 216.93v-.896m.214.91v-.94m.22.97v-.977" fill="none" stroke="#000" strokeWidth={0.077} />
            <path d="M131.3 216.924v-.868" fill="none" stroke="#000" strokeWidth={0.086} />
            <path d="M131.087 216.88v-.81" fill="none" stroke="#000" strokeWidth={0.096} />
            <path d="M130.86 216.857v-.75" fill="none" stroke="#000" strokeWidth={0.106} />
            <path
                d="M130.392 216.792l-.008-.598m.247.627v-.67m-.479.589v-.524"
                fill="none"
                stroke="#000"
                strokeWidth={0.115}
            />
            <path d="M129.933 216.698v-.437" fill="none" stroke="#000" strokeWidth={0.125} />
            <path d="M129.693 216.64v-.342" fill="none" stroke="#000" strokeWidth={0.134} />
            <path d="M129.448 216.612v-.256" fill="none" stroke="#000" strokeWidth={0.144} />
            <path d="M129.188 216.553v-.124" fill="none" stroke="#000" strokeWidth={0.173} />
            <path
                d="M135.733 217.04v-1.116m-.56 1.15l.007-1.18m-.416 1.196v-1.202"
                fill="none"
                stroke="#000"
                strokeWidth={0.01}
            />
            <path d="M277.777 217.125v-1.217" fill="none" stroke="#000" strokeWidth={0.019} />
            <path d="M277.447 217.125v-1.217" fill="none" stroke="#000" strokeWidth={0.029} />
            <path d="M277.135 217.125v-1.217m-.309 1.217v-1.217" fill="none" stroke="#000" strokeWidth={0.038} />
            <path d="M276.55 217.125v-1.217" fill="none" stroke="#000" strokeWidth={0.048} />
            <path d="M276.024 217.06l-.008-1.11m.258 1.123v-1.157" fill="none" stroke="#000" strokeWidth={0.058} />
            <path d="M275.54 217.01v-1.022m.245 1.05l-.008-1.086" fill="none" stroke="#000" strokeWidth={0.067} />
            <path d="M274.888 216.95v-.895m.214.91v-.94m.22.97v-.977" fill="none" stroke="#000" strokeWidth={0.077} />
            <path d="M274.66 216.944v-.867" fill="none" stroke="#000" strokeWidth={0.086} />
            <path d="M274.447 216.9v-.81" fill="none" stroke="#000" strokeWidth={0.096} />
            <path d="M274.22 216.878v-.75" fill="none" stroke="#000" strokeWidth={0.106} />
            <path
                d="M273.752 216.812l-.008-.597m.247.627v-.67m-.479.588v-.524"
                fill="none"
                stroke="#000"
                strokeWidth={0.115}
            />
            <path d="M273.293 216.72v-.438" fill="none" stroke="#000" strokeWidth={0.125} />
            <path d="M273.053 216.66v-.34" fill="none" stroke="#000" strokeWidth={0.134} />
            <path d="M272.807 216.632v-.256" fill="none" stroke="#000" strokeWidth={0.144} />
            <path d="M272.547 216.573v-.124" fill="none" stroke="#000" strokeWidth={0.173} />
            <path
                d="M279.092 217.06v-1.116m-.56 1.15l.008-1.178m-.415 1.194v-1.202"
                fill="none"
                stroke="#000"
                strokeWidth={0.01}
            />
        </svg>
    );
}

export default SvgEs;
